var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroSolEnAero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1600,
    height: 660,
    viewBox: "0 0 1600 660",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #dfe9f0;\n      }\n\n      .cls-2, .cls-30, .cls-31 {\n        fill: none;\n      }\n\n      .cls-3 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-4 {\n        clip-path: url(#clip-path-2);\n      }\n\n      .cls-21, .cls-5 {\n        fill: #fff;\n      }\n\n      .cls-6 {\n        fill: #5c2483;\n      }\n\n      .cls-7 {\n        fill: #af1280;\n      }\n\n      .cls-8 {\n        fill: #831f82;\n      }\n\n      .cls-9 {\n        fill: #d39883;\n      }\n\n      .cls-10 {\n        fill: #c56e58;\n      }\n\n      .cls-11 {\n        fill: #661615;\n      }\n\n      .cls-12 {\n        fill: #85a34c;\n      }\n\n      .cls-13 {\n        fill: #5b7234;\n      }\n\n      .cls-14 {\n        fill: #bed3e0;\n      }\n\n      .cls-15 {\n        fill: #a7bbc5;\n      }\n\n      .cls-16 {\n        fill: #ffde14;\n      }\n\n      .cls-17 {\n        fill: #e29260;\n      }\n\n      .cls-18 {\n        fill: #f7ae83;\n      }\n\n      .cls-19 {\n        fill: #d94350;\n      }\n\n      .cls-20 {\n        fill: #ef7d00;\n      }\n\n      .cls-21, .cls-28, .cls-29 {\n        fill-rule: evenodd;\n      }\n\n      .cls-22 {\n        fill: #833f34;\n      }\n\n      .cls-23, .cls-29 {\n        fill: #ddb199;\n      }\n\n      .cls-24 {\n        fill: #b9343d;\n      }\n\n      .cls-25 {\n        fill: #fcd9ca;\n      }\n\n      .cls-26, .cls-28 {\n        fill: #f0c1a6;\n      }\n\n      .cls-27 {\n        fill: #ea5153;\n      }\n\n      .cls-30, .cls-31 {\n        stroke: #b9343d;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-30 {\n        stroke-width: 3.399px;\n      }\n\n      .cls-31 {\n        stroke-width: 2.377px;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_834",
    "data-name": "Path 834",
    className: "cls-1",
    d: "M51.79,4.372c30.1,6.605,59.183,5.564,92.509,6.6,44.853,1.4,85.918,6.033,131.07,3.116C312.9,11.666,354.853,7.149,392.909,8.8c32.582,1.413,29.493,11.724,38.268,24.024-.466-9.169-1.946-17.967,16.31-21.806,18.2-3.826,61.2-3.29,81.143-3.325,22.493-.04,45.054-.176,67.541,0,28.5.227,48.279,5.038,75.222,6.692,9.3.572,30.222-2.074,38.205-.107,11.449,2.824,7.09,9.314,18.568,12.141-.674-3.664,1.839-8.22,9.275-10.673,12.641-4.169,9.5.6,19.685-.27,30.925-2.649,57.322-5.57,89.88-5.573q37.73,0,75.46,0c22.7,0,49.971-3.145,71.166-2.565,37.147,1.014,36.779,20.126,48.757,29.375.024-7.872-9.264-30.505,18.637-32.2,4.064,5.395,4.779,11.526,12.149,16.093,4.043-24.283,145.793-14.745,182.087-13.983,49.16,1.034,109.875-5.28,152.914,2.7,9.514,1.764,28.057,3.841,35.315,5.266,18.446,3.62,16.812,10.564,32.4,15.194-1.206-6.932,7.686-18.612,23.381-22.654,12.033-3.1,32.153-.689,50.364-.377a35.917,35.917,0,0,1-4.837,10.684c59.98,3.252,22.149,14.452,26.921,30.21,9.107,30.074,9.117,62.76,5.124,93.68-24.918,1.14-46.669.616-65.624,9.112,51.041,1.007,44.99,2.7,49.681,21.029,2.429,9.488,2.526,18.693,3.283,28.05.8,9.876,12.007,17.743,7.3,27.357-3.344,6.827-11.559,9.111-9.071,16.758.919,2.823,7.895,7.322,9.538,10.707,8.279,17.064,2.772,35.779,10.847,53.353,4.776,10.393,18,28.894-2.277,35.786-9.324,3.17-39.1,2.413-51.535,4.021-15.492,2-34.066,5.047-44.437,9.9,21.513,2.974,40.814-2.092,62.2-.743a5.626,5.626,0,0,1,2.326,1.815c-16.8,1.828-31.578,6.692-44.937,11.138,18.506.808,67.024-5.343,78.748,1.76,5.689,3.447,5.171,22.812,5.021,28.11-50.5,1.1-94.551,3.389-141.18,13.395,28.489.918,111.62-13.576,134.539,1.232,9.992,6.456-4.585,14.983-4.247,21.2.777,14.275,19.7,24.462,12.777,39.416-9.68,20.906-19.748,33.285-8.729,53.758,11.734,21.8,7.517,43.163,6.985,64.975-.418,17.109,16.477,36.466,10.776,53.012-17.1-1.518-39.447-3.871-57.367-2.041-18.121,1.85-30.929,6.519-50.48,7.546-23.94,1.257-48.783-1.287-72.737-1.6-77.19-1.018-191.115,20.939-242.283-9.187-2.715,4.351-4.123,9.231-.762,13.2-116.324-2.442-232.478,18.244-341.474-7.279-43.647,15.652-119.335-.233-164.44,10.456-5.257-14.248-30.525-23.2-39.255-36.518,1.011,10.977,11.965,26.117-10.128,29.994-5.292.929-28.045.817-36.118,1.362-26.672,1.8-50.59,4.078-77.851,4.13-24.982.048-51.476,1.684-76.055.593-36.989-1.643-69.913-10.851-107.884-10.485-30.774.3-62.046,8.769-92.353,7.665-19.057-.693-34.667-7.215-54.4-3.27-5.06-4.918-4.315-11.071-11.032-14.5-1.195,5.9-3.4,13.171-14.252,16.857-18.633-7.5-37.113,3.516-57.847,3.209-12.5-.185-22.48-5.595-34.874-6.608-12.823-1.048-25.268,1.977-38.818.175-2.143-10.24,24.222-15.146,15.647-26.238-2.971-3.842-15.329-6.575-20.182-11.174-7.993-7.578-.962-13.331-.233-20.574,4.523-44.9-9.233-90.765.316-136.158,21.71.061,36.979-12.05,44.947-18.9-15.3.149-29.663,1.433-42.325-1.86,10.644-12.3-1.147-24.871-3.232-37.279-.749-4.462-3.064-19.479,2.919-23.9,6.206-4.59,23.674-4.735,29.935-12.1-13.492.556-25.822.626-35.727-2.972,10.536-4.342,2.705-7.253,5.338-11.363,3.067-4.789,12.9-8.139,5.058-13.383,17.535-5.491,73.812-11.245,79.018-21.585,4.764-9.46-65.151-11.122-81.3-15.274,3.744-.327,10.065-2.41,14.327-2.852-2.674-1.131-4.324-3.269-7.639-4.49,11.985-8.814,2.64-22.373,1.806-31.817-1.968-22.312,2.367-44.312-4.71-66.46-4.261-13.337-2.166-26.374-3.068-39.755-.856-12.693-10.918-24.731-11.456-37.333-.542-12.678,35.868-33.542,17.374-44.82,3.65-.684,6.787-2.2,10.344-2.891-39.069-12.8,64.7-14.625,84.229-19.26-31.835-1.178-64.888,4.109-95.063-1.81C12.688,43.547.488,41.087.007,34.861c-.4-5.127,16.66-3.645,14.631-10.374,8.427-2.693,8.8-6.253,2.394-9.982C30.315,9.391,35.444,4.554,51.927,0,50.336,2.408,47.561,4.6,51.79,4.372Z",
    transform: "translate(0 100)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_101",
    "data-name": "Rectangle 101",
    className: "cls-2",
    width: 1600,
    height: 660
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_5",
    "data-name": "Mask Group 5",
    className: "cls-3",
    transform: "translate(0 -100)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139",
    transform: "translate(0 100)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    className: "cls-1",
    d: "M51.79,4.372c30.1,6.605,59.183,5.564,92.509,6.6,44.853,1.4,85.918,6.033,131.07,3.116C312.9,11.666,354.853,7.149,392.909,8.8c32.582,1.413,29.493,11.724,38.268,24.024-.466-9.169-1.946-17.967,16.31-21.806,18.2-3.826,61.2-3.29,81.143-3.325,22.493-.04,45.054-.176,67.541,0,28.5.227,48.279,5.038,75.222,6.692,9.3.572,30.222-2.074,38.205-.107,11.449,2.824,7.09,9.314,18.568,12.141-.674-3.664,1.839-8.22,9.275-10.673,12.641-4.169,9.5.6,19.685-.27,30.925-2.649,57.322-5.57,89.88-5.573q37.73,0,75.46,0c22.7,0,49.971-3.145,71.166-2.565,37.147,1.014,36.779,20.126,48.757,29.375.024-7.872-9.264-30.505,18.637-32.2,4.064,5.395,4.779,11.526,12.149,16.093,4.043-24.283,145.793-14.745,182.087-13.983,49.16,1.034,109.875-5.28,152.914,2.7,9.514,1.764,28.057,3.841,35.315,5.266,18.446,3.62,16.812,10.564,32.4,15.194-1.206-6.932,7.686-18.612,23.381-22.654,12.033-3.1,32.153-.689,50.364-.377a35.917,35.917,0,0,1-4.837,10.684c59.98,3.252,22.149,14.452,26.921,30.21,9.107,30.074,9.117,62.76,5.124,93.68-24.918,1.14-46.669.616-65.624,9.112,51.041,1.007,44.99,2.7,49.681,21.029,2.429,9.488,2.526,18.693,3.283,28.05.8,9.876,12.007,17.743,7.3,27.357-3.344,6.827-11.559,9.111-9.071,16.758.919,2.823,7.895,7.322,9.538,10.707,8.279,17.064,2.772,35.779,10.847,53.353,4.776,10.393,18,28.894-2.277,35.786-9.324,3.17-39.1,2.413-51.535,4.021-15.492,2-34.066,5.047-44.437,9.9,21.513,2.974,40.814-2.092,62.2-.743a5.627,5.627,0,0,1,2.326,1.815c-16.8,1.828-31.578,6.692-44.937,11.138,18.506.808,67.024-5.343,78.748,1.76,5.689,3.447,5.171,22.812,5.021,28.11-50.5,1.1-94.551,3.389-141.18,13.395,28.489.918,111.62-13.576,134.539,1.232,9.992,6.456-4.585,14.983-4.247,21.2.777,14.275,19.7,24.462,12.777,39.416-9.68,20.906-19.748,33.285-8.729,53.758,11.734,21.8,7.517,43.163,6.985,64.975-.418,17.109,16.477,36.467,10.776,53.012-17.1-1.518-39.447-3.871-57.367-2.041-18.121,1.85-30.929,6.519-50.48,7.546-23.94,1.257-48.783-1.286-72.737-1.6-77.19-1.018-191.115,20.939-242.283-9.187-2.715,4.351-4.123,9.231-.762,13.2-116.324-2.442-232.478,18.244-341.474-7.279-43.647,15.652-119.335-.232-164.44,10.456-5.257-14.248-30.525-23.2-39.255-36.518,1.011,10.977,11.965,26.117-10.128,29.994-5.292.929-28.045.817-36.118,1.362-26.672,1.8-50.59,4.078-77.851,4.13-24.982.048-51.476,1.684-76.055.593-36.989-1.643-69.913-10.851-107.884-10.485-30.774.3-62.046,8.769-92.353,7.665-19.057-.693-34.667-7.215-54.4-3.271-5.06-4.918-4.315-11.071-11.032-14.5-1.195,5.9-3.4,13.171-14.252,16.858-18.633-7.5-37.113,3.516-57.847,3.209-12.5-.185-22.48-5.595-34.874-6.608-12.823-1.048-25.268,1.977-38.818.175-2.143-10.24,24.222-15.146,15.647-26.239-2.971-3.842-15.329-6.575-20.182-11.174-7.993-7.578-.962-13.331-.233-20.574,4.523-44.9-9.233-90.765.316-136.158,21.71.061,36.979-12.05,44.947-18.9-15.3.149-29.663,1.433-42.325-1.86,10.644-12.3-1.147-24.871-3.232-37.279-.749-4.462-3.064-19.479,2.919-23.9,6.206-4.59,23.674-4.735,29.935-12.1-13.492.556-25.822.626-35.727-2.972,10.536-4.342,2.705-7.253,5.338-11.363,3.067-4.789,12.9-8.139,5.058-13.383,17.535-5.491,73.812-11.245,79.018-21.585,4.764-9.46-65.151-11.121-81.3-15.274,3.744-.327,10.065-2.41,14.327-2.852-2.674-1.131-4.324-3.269-7.639-4.49,11.985-8.814,2.64-22.373,1.806-31.817-1.968-22.312,2.367-44.312-4.71-66.46-4.261-13.337-2.166-26.374-3.068-39.755-.856-12.693-10.918-24.731-11.456-37.333-.542-12.678,35.868-33.542,17.374-44.82,3.65-.684,6.787-2.2,10.344-2.891-39.069-12.8,64.7-14.625,84.229-19.26-31.835-1.178-64.888,4.109-95.063-1.81C12.688,43.547.488,41.087.007,34.861c-.4-5.127,16.66-3.645,14.631-10.374,8.427-2.693,8.8-6.253,2.394-9.982C30.315,9.391,35.444,4.554,51.927,0,50.336,2.408,47.561,4.6,51.79,4.372Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(1117.52 62.326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    className: "cls-5",
    d: "M1600.928,249.94a84.888,84.888,0,0,1,28.3,22.488l2.934,3.686c2.211,2.81,4.719,5.966,7.535,9.166a52.954,52.954,0,0,0-4.912,5.536,54.257,54.257,0,0,0-8.88,17.668C1618,288.843,1609.794,269.24,1600.928,249.94Z",
    transform: "translate(-1067.314 -65.922)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    className: "cls-5",
    d: "M1099.337,711.985c-.547.155-16.964,4.855-16.964,4.855l-22.853,6.625,4.384-23.657c4.287-23.156,27.152-33.99,47.325-43.549,3.222-1.526,7.135-3.382,10.593-5.165l17.546-9.049L1127.773,625.9a40.23,40.23,0,0,1-5.918-12.116c-4.606-15.651.334-34.21,12.9-48.419,7.893-8.936,17.083-14.936,25.969-20.74l5.41-3.567c43.61-29.381,77.338-76.369,92.538-128.916,9.905-34.291,25.529-55.307,44-59.182l8.558-1.8,3.448-8.156c5.271-12.474,11.3-25.549,21.843-36.267a56.968,56.968,0,0,1,6.674-5.806l13.467-9.991-9.776-13.72a95.843,95.843,0,0,0-11.61-13.409c-20.542-19.752-49.8-32.842-86.961-38.906l-1.975-.317c-7.777-1.242-16.549-2.642-25-7.182a39.828,39.828,0,0,1-16.77-16.9l-7.577-14.737-14.685,7.352a56.979,56.979,0,0,1-25.68,5.861c-.38,0-1.841-.02-2.615-.052a26.611,26.611,0,0,1-12.393-3.138c-10.62-5.985-14.823-19.9-9.791-32.383,3.021-7.524,8.17-11.073,11.578-13.422l1.757-1.224,1.9-1.607,1.55-.733a72.667,72.667,0,0,1,31.146-7.315l14.979-.116,1.558-15.128c.048-.468.074-.887.089-1.225,1.978-13.823,13.593-24.708,26.7-24.927l1.2-.02,1.182-.193c.626-.1,1.245-.212,1.863-.322l.457-.082a69.46,69.46,0,0,1,12.188-1.349,34.709,34.709,0,0,1,10.826,1.65,35.232,35.232,0,0,1,20.539,17.677l5.443,10.991,11.985-1.8a49.46,49.46,0,0,1,7.385-.612c1.41,0,2.824.054,4.2.161,20,1.535,39.594,11.993,59.9,31.974a233.641,233.641,0,0,1,37.283,47.764l17.526,29.684,12.443-32.222q1.524-3.948,3.068-8.009l.46-1.206c8.422-22.1,17.106-44.892,31.171-64.979,26.269-37.475,70.623-60.759,115.75-60.759a128.5,128.5,0,0,1,26.414,2.722c3.03.638,9.339,1.969,14.44,7.292a24.591,24.591,0,0,1,3.871,5.215l5.877,10.823,11.954-2.332a158.376,158.376,0,0,1,30.221-2.91,156.4,156.4,0,0,1,83.617,23.9c7.637,4.812,18.58,12.6,25.494,24.717,8.012,14.016,8.5,30.512,1.27,43.063-7.932,13.773-22.718,20.468-45.2,20.468-2.505,0-5.274-.069-8.713-.217-1.083-.044-2.1-.085-3.12-.117l-29.32-.922,14.113,26.112a53.452,53.452,0,0,1,6.563,24.773,45.016,45.016,0,0,1-10.757,29.361l-10.074,11.926,10.909,11.144a50.073,50.073,0,0,1,5.857,7,54.374,54.374,0,0,1,5.357,49.753,35.544,35.544,0,0,1-10.283,14.831c-5.487,4.487-12.6,6.864-20.549,6.864a45.961,45.961,0,0,1-8.114-.75,55.406,55.406,0,0,1-21.189-8.686L1624.005,348.2l10.166-34.732a37.272,37.272,0,0,1,6.084-12.122,36.741,36.741,0,0,1,3.369-3.772l11.439-11.371L1644.4,274.086c-2.541-2.888-4.821-5.757-6.939-8.449l-3.1-3.894a101.935,101.935,0,0,0-33.922-26.974l-42.408-20.856,19.92,43.359c7.638,16.628,15.472,34.991,24.653,57.79l12.616,31.329,16.459,43.935.638,1.685c11.211,29.8,22.818,60.661,35.146,90.479,6.054,14.634,16.556,32.27,31.216,52.42,3.653,5.029,7.633,10.3,12.159,16.112,4.069,5.2,8.42,10.617,12.953,16.125,5.935,7.214,12.537,15,20.18,23.8l6.724,7.682c8.773,9.957,17.144,19.267,25.237,28.271l6.745,7.5c4.864,5.419,8.248,9.219,11.3,12.691,25.7,29.134,34.872,41.343,29.205,54.1l-.083.189a25.321,25.321,0,0,1-5.759,8.266,18.94,18.94,0,0,1-2.846,2.219l-.377.242-.366.262a26.442,26.442,0,0,1-4.551,2.68,25.435,25.435,0,0,1-3.277,1.172l-.316.094-.313.105a36.414,36.414,0,0,1-4.551,1.275c-.775.156-1.864.318-3.2.474l-.213.027c-2.289.3-3.72.465-5.193.546-1.146.062-2.482.07-3.517.07l-2.45.014c-1.142,0-2.155-.02-3.095-.063l-.119-.005c-1.115-.042-2.568-.147-3.959-.251-2.054-.155-3.772-.289-5.508-.476-1.466-.162-2.989-.353-4.528-.56-1.678-.221-3.617-.482-5.626-.8-1.538-.237-3.129-.505-4.743-.786-1.95-.333-3.9-.678-5.883-1.058l-5.031-.989-6.1-1.274-5.03-1.106-11.579-2.687-11.666-2.849-34.539-8.7-10.88-2.65c-4.168-.989-7.484-1.751-10.528-2.421a68.524,68.524,0,0,0-14.937-1.546c-13.557,0-27.728,3.327-42.265,7.033l-12.676,3.232v.329l-12.634,2.68c-1.722.372-3.443.713-5.172,1.056l-3.6.687c-1.729.305-3.495.571-5.159.819l-3.741.547c-1.927.244-3.943.423-5.84.582l-.286.027c-1.2.122-1.955.193-2.7.245-2.741.175-5.342.263-7.86.264l-1.276-.008c-3.412-.043-6.874-.2-10.292-.449l-1.812-.176c-1.185-.094-2.739-.231-4.5-.415l2.365-14.405-32.968-6.076-2.759,14.265-.618-.146-11.044-2.937c-3.066-.854-5.647-1.576-8.22-2.325l-11.022-3.229c-23.975-7.081-46.651-13.778-69.812-14.646-1.61-.06-3.233-.091-4.825-.091-4.353,0-8.887.208-13.86.636-1.476.126-2.979.281-4.489.452-2.068.234-3.768.445-5.345.663-1.521.218-3.03.437-4.538.683-1.79.291-3.6.612-5.392.948l-4.579.876c-1.828.376-9.024,1.995-9.838,2.178l-.25.059c-1.8.434-9.8,2.47-9.8,2.47l-.308.081-6.2,1.705c-3.415.948-13.046,3.725-13.453,3.842l-24.884,7.271-11.265,3.1-6.447,1.669-4.713,1.149c-1.843.441-3.945.921-6.363,1.449l-4.7,1.007c-2.311.473-4.641.9-6.618,1.251-2,.363-3.277.6-4.552.8-2.257.371-4.672.693-7.373,1.046-.116.016-3.031.416-3.981.523-3.568.4-7.124.7-10.545.91l-.361.022-.358.037a60.23,60.23,0,0,1-6.134.328h-.269l-.27.01c-.273.01-.534.02-.768.02H1101.919l4.419,14.85Z",
    transform: "translate(-1059.52 -66.063)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(18.78 14.873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    className: "cls-6",
    d: "M1347.616,253c-25.806-24.816-60.313-37.178-94.711-42.789-7.662-1.25-15.539-2.253-22.461-5.963s-12.822-10.839-12.9-19.078c-.131-13.02,13.8-21.439,26.047-21.628s24.161,4.759,36.411,4.792c-6.755-4.665-6.4-16.283-.84-22.481s14.335-7.837,22.369-7.222c19.373,1.483,36.542,13.8,50.8,27.823a221.289,221.289,0,0,1,43.522,60.76c3.8,7.812,8.3,16.838,16.432,18.473,10.674,2.148,18.814-9.746,23.381-20.223,13.207-30.293,21.986-63.253,40.749-90.03,28.641-40.874,80.217-61.991,127.256-52.1,2.484.522,5.091,1.2,6.9,3.086,7.669,8.011-7.96,21.168-4.479,31.981,44.311-23.914,100.073-21.967,142.812,4.988,7.982,5.034,15.723,11.1,20.537,19.533s6.153,19.685,1.307,28.1c-7.772,13.494-25.782,13.547-40.656,12.908a361.306,361.306,0,0,0-72.856,4.257c-6.208,1-13.951,3.97-14.024,10.643,13.381,3.3,27.045,6.719,38.673,14.492s21.051,20.842,21.176,35.441-11.69,29.3-25.374,28.019c-12.853-1.2-21.3-14.13-29.736-24.509-19.78-24.346-48.939-39.815-79.135-41.98-9.158-.656-18.93.042-26.508,5.546-15.513,11.267-14.444,35.312-13.762,55.269a284.7,284.7,0,0,1-9.845,84.527c-3.322,12.159-7.8,24.616-16.784,32.927-7.439,6.879-17.182,10.172-26.756,12.677a233.637,233.637,0,0,1-47.053,7.3c-40.219,2.081-46.689-23.846-45.406-60.621C1383.965,311.446,1373.669,278.055,1347.616,253Z",
    transform: "translate(-1080.574 -80.925)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    className: "cls-7",
    d: "M1387.676,267.527c-9.873-22.455-26.236-42.347-47.6-52.273-6.139-2.852-12.827-5-17.645-9.95s-6.838-13.989-2.126-19.054c5.394-5.8,14.69-2.411,21.063,2.132,20.234,14.425,34.246,36.715,45.985,59.407,5.383,10.4,14.8,22.891,25.078,18.243,1.832-.829,3.518-2.2,5.5-2.366,8.67-.731,7.515,18.518,16.186,19.258,4.791.408,7.6-5.476,9.069-10.34q11.19-37.047,22.382-74.093c6.523-21.59,17.06-46.916,38.234-49.7a365.2,365.2,0,0,0,.166,48.911c34.779-53.442,100.414-73.073,161.38-77.938,7.264-.579,14.991-.9,21.357,2.859s10.323,13.159,6.19,19.533c-3.2,4.931-9.5,6.033-15.111,6.619-30.347,3.17-62.183,4.123-88.778,19.976-3.553,2.118-7.354,5.138-7.571,9.461-.352,6.991,8.147,9.958,14.7,10.677l23.03,2.529c-1.435,10.195-15.563,8.455-24.868,5.549-41.441-12.944-90.233,14.861-103.023,58.711-9.644,33.063-.447,68.72-1.857,103.3-.35,8.569-1.529,17.57-6.442,24.375-5.14,7.118-13.465,10.622-21.438,13.575-15.263,5.652-33.4,10.091-46.588.152-19.334-14.574-11.7-41.424-12.343-62.469A185.056,185.056,0,0,0,1387.676,267.527Z",
    transform: "translate(-1082.015 -80.895)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    className: "cls-8",
    d: "M1273.815,416.1c-16.233,56.132-51.83,105.686-98.5,137.12-9.939,6.694-20.511,12.726-28.568,21.841s-13.264,22.309-9.755,34.245c4.959,16.862,25.4,23.713,41.369,18.807s28.31-18.072,39.825-30.811c42.224-46.711,85.329-96.853,106.758-158.619,6.029-17.376,18.083-50.557.979-65.161C1297.975,349.667,1279.7,395.748,1273.815,416.1Z",
    transform: "translate(-1079.399 -80.706)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    className: "cls-9",
    d: "M1206.974,577.366a1339.66,1339.66,0,0,0,119.109-223.092c5.563-13.3,11.166-27.082,21.06-37.143s25.383-15.475,37.589-8.878c7.006,3.787,12.046,10.94,19.164,14.482,13.851,6.89,22.116-16.7,33.041-21.551,18.2-9.668,31.3,15.736,48.287,14.143,12.718-14.409,12.718-36.36,17.733-55.384s22.8-38.757,39.64-30.4c7.687,3.813,12.156,12.318,16,20.355,36.84,76.976,62.93,159.178,95.635,238.236s162.246,193.1,155.8,206.987c-9.344,22.966-91.6-4.888-149.277-17.617-39.878-8.8-80.344,16.085-121.071,15.605-51.16-.6-99.213-28.615-150.344-30.533-60.013-2.253-116.568,31.5-176.541,34.748-28.7,3.283-15.732-17.436-27.853-16.806-36.927,1.925-71.052,11.7-106.377,21.915,4.427-23.921,46.151-32.161,62.814-46.151C1167.406,634.432,1187.995,605.991,1206.974,577.366Z",
    transform: "translate(-1078.574 -80.812)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(12.532 148.494)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    className: "cls-10",
    d: "M1263.863,659.839l-55.693,37.7a47.872,47.872,0,0,0,6.5-.339c53.818-2.918,104.886-30.391,158.17-34.371-1.7-12,2.316-24.956,7.212-36.318,18.2-42.239,48.6-80.6,51.554-126.949l-18.936-1.158a708.084,708.084,0,0,0,22.085-120.877c-21.328,16.475-29.033,45.943-35.562,73.094-4.287,17.829-9.43,36.923-23.01,48.338-5.259,4.421-11.6,7.487-15.992,12.872-8.507,10.432-7.257,25.872-8.748,39.586C1346.113,600.438,1303.018,633.331,1263.863,659.839Z",
    transform: "translate(-1092.972 -229.191)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    className: "cls-10",
    d: "M1146.006,676.6c-13.711,5.477-28.525,7.554-41.932,13.825a56.707,56.707,0,0,0-12.785,8.212c30.932-8.819,61.3-16.615,93.845-18.31a8.169,8.169,0,0,1,1.813.091c.606-1.3,1.254-2.54,1.931-3.706,41.269-70.989,118.356-122.072,130.949-204.438l-96.957,131.9C1201.5,633.233,1178.488,663.622,1146.006,676.6Z",
    transform: "translate(-1091.289 -229.119)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    className: "cls-10",
    d: "M1545.323,693.008c11.164.132,22.308-1.643,33.426-4.108-7.994-14.387-11.549-33.2-13.758-50.161q-6.708-51.521-13.417-103.039c-.572-4.385-1.345-9.179-4.515-12.049-3.213-2.908-7.894-2.93-11.735-4.788-5.455-2.64-8.67-8.673-10.994-14.545-18.736-47.325-2.778-104.986-24.912-150.624-6.064,18.33-6.35,38.166-6.571,57.6q-1.292,113.574-2.584,227.147c-.1,8.381-.275,17.131-3.98,24.531-3.5,7-9.529,11.667-16.324,15.214C1494.819,685.517,1519.681,692.706,1545.323,693.008Z",
    transform: "translate(-1096.74 -229.21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    className: "cls-10",
    d: "M1547.218,269.386a415,415,0,0,1,36.314,159.6c.443,17.544-.041,35.943,7.514,51.548,10.6,21.89,36.012,36.271,37.259,60.853.394,7.771-1.857,15.495-1.424,23.264.561,10.064,5.522,19.171,10.355,27.845l33.145,59.5c4.745,8.517,9.619,18.566,7.246,27.847,56.717,13.432,130.261,36.914,139.066,15.274,6.446-13.885-123.1-127.928-155.8-206.987s-58.8-161.26-95.635-238.236c-3.847-8.036-8.316-16.543-16-20.356-.175-.087-.351-.152-.526-.233C1536.217,235.9,1541.139,255.926,1547.218,269.386Z",
    transform: "translate(-1097.762 -229.305)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    className: "cls-8",
    d: "M1529.18,355.358c1.025,20.8,3.326,42.222,12.941,60.374,6.027,11.376,14.648,20.92,21.762,31.562,19.071,28.533,26.611,63.725,33.736,97.9,2.386,11.44,3.445,26.288-6.191,31.98-8.488,5.015-19.571-1.917-23.683-11.268s-3.471-20.14-3.766-30.456-2.085-21.585-9.428-28.338c-3.323-3.055-7.53-4.913-10.694-8.153-4.451-4.557-6.271-11.219-7.844-17.571a877.649,877.649,0,0,1-17.16-88.719c-.857-6.1-1.713-12.4-4.727-17.669-11.935-20.866-62.165-33.47-38.817-69.713,8.482-13.166,25.266-13.4,36.889-4.484C1527.984,312.908,1528.26,336.706,1529.18,355.358Z",
    transform: "translate(-1084.197 -80.761)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    className: "cls-8",
    d: "M1355.344,425.139c-8.045,9.648-19.146,16.561-25.089,27.8-9.743,18.428-2.552,41.845-7.492,62.32-6.205,25.72-29.945,42.005-41.9,65.317-2.067,4.029-3.8,8.8-2.312,13.108,2.12,6.131,10.036,7.972,15.654,5.324s9.362-8.327,12.619-13.866a273.13,273.13,0,0,0,33.261-90.594c1.947-11.012,3.371-22.56,9.186-31.906,4.76-7.652,12.009-13.066,18.6-18.987,13.026-11.7,24.091-26.165,30.652-42.9,8.962-22.853,8.99-49.043,19.975-71.068,5.407-10.841,17.83-18.922,8.7-29.892-6.422-7.712-18.8-5.582-25.924-1.129C1364.587,321.589,1382.464,392.616,1355.344,425.139Z",
    transform: "translate(-1081.445 -80.761)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    className: "cls-7",
    d: "M1353.509,420.036c-11.239,14.974-23.992,29.714-28.554,48.244-3.539,14.375-1.748,29.652-4.2,44.279-3.816,22.728-17.641,42.275-33.725,57.793-3.807,3.673-7.951,7.478-9.392,12.723s1.427,12.184,6.565,12.38c4.019.154,7.1-3.611,9.437-7.088a254.623,254.623,0,0,0,41.031-111.122,105.271,105.271,0,0,1,2.151-13.772c6.321-24.48,31.927-38.035,41.369-61.352,3.409-8.416,4.506-17.652,5.569-26.745q2.657-22.747,5.314-45.5c.385-3.3.038-7.77-3.03-8.427-2.357-.505-4.341,1.851-5.55,4.059-8.46,15.442-5.518,32.149-6.424,48.969C1373.141,391.661,1363.282,407.014,1353.509,420.036Z",
    transform: "translate(-1081.434 -80.74)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    className: "cls-7",
    d: "M1493.851,314.858c0,4.462,2.647,8.466,5.751,11.473s6.75,5.347,9.729,8.492c4.323,4.563,7.011,10.56,9.338,16.544a210.037,210.037,0,0,1,12.49,49.038c1.917,14.786,2.306,29.958,6.774,44.109a41.317,41.317,0,0,0,7.124,14.1c2.8,3.371,6.335,5.964,9.3,9.169,13.2,14.255,12.763,36.919,19.718,55.5.614,1.641,1.473,3.436,3.066,3.937,2.1.661,4.153-1.376,4.99-3.531,1.789-4.607.4-9.84-1.009-14.6q-7.672-25.965-15.344-51.932c-2.833-9.584-5.725-19.31-10.921-27.7-2.492-4.029-5.489-7.7-7.769-11.87-5.4-9.871-6.384-21.668-7.7-33q-2.339-20.183-6.564-40.05c-1.94-9.114-4.271-18.386-9.363-26C1518.745,311.481,1493.855,296,1493.851,314.858Z",
    transform: "translate(-1084.552 -80.752)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    className: "cls-6",
    d: "M1657.087,335.68c3.863,14.957,17.415,25.688,31.8,28.267,5.811,1.042,12.263.776,16.934-3.043a21.165,21.165,0,0,0,5.878-8.782,39.644,39.644,0,0,0-3.831-35.8C1690.227,290.217,1647.492,298.529,1657.087,335.68Z",
    transform: "translate(-1086.882 -80.756)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    className: "cls-6",
    d: "M1262.206,127.809c-.358-7.754-6.734-14-13.714-16.286s-14.469.248-21.73,1.09c-6.62-.736-12.864,5.425-13.729,12.44s2.919,14.1,8.447,18.04,12.5,5.077,19.131,4.482C1251.093,146.635,1262.72,138.977,1262.206,127.809Z",
    transform: "translate(-1080.508 -80.902)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    className: "cls-6",
    d: "M1189.716,155.987c-1.779-1.727-4.381-2.026-6.789-2.086a57.836,57.836,0,0,0-26.74,5.868c-3.834,3.236-7.651,4.431-9.575,9.216s-.973,11.31,3.351,13.751a12.741,12.741,0,0,0,5.837,1.274c13.025.522,27.451-4.08,33.974-16.073C1191.8,164.2,1192.711,158.9,1189.716,155.987Z",
    transform: "translate(-1079.54 -80.869)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    className: "cls-7",
    d: "M1220.126,122.122c-2.211,1.38-4.451,3.3-4.84,6a6.976,6.976,0,0,0,1.111,4.622c2.528,4.016,7.57,5.126,12.1,5.465a37.479,37.479,0,0,0,12.908-.924,20.177,20.177,0,0,0,10.863-7.137c1.347-1.816,2.373-4.142,1.891-6.4a8.01,8.01,0,0,0-1.927-3.476,16.593,16.593,0,0,0-15.249-5.367c-2.639.474-4.551,2.018-6.968,3.009C1226.634,119.3,1223.312,120.132,1220.126,122.122Z",
    transform: "translate(-1080.541 -80.899)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    className: "cls-7",
    d: "M1150.562,174.089a1.962,1.962,0,0,0,.113,1.149,1.873,1.873,0,0,0,.9.708,13.544,13.544,0,0,0,2.376.98,8.909,8.909,0,0,0,7.479-1.856,26.193,26.193,0,0,0,5.393-6.122,5.991,5.991,0,0,0,1.456-3.633c-.121-1.982-2.113-3.294-3.974-3.465C1157.79,161.252,1151.317,167.56,1150.562,174.089Z",
    transform: "translate(-1079.61 -80.863)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    className: "cls-7",
    d: "M1669.4,314.53a12.588,12.588,0,0,0-.274,6.284c.947,3.363,4.15,5.415,7.289,6.509s6.511,1.58,9.36,3.356c3.386,2.111,6.14,6.041,10.067,6.073,2.961.024,5.6-2.442,6.58-5.412a14.216,14.216,0,0,0-.545-9.222C1697.518,310.3,1673.863,295.93,1669.4,314.53Z",
    transform: "translate(-1087.071 -80.753)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82",
    transform: "translate(581.51 375.099)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72",
    transform: "translate(230.888 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    className: "cls-5",
    d: "M898.1,822.292c-14.311,0-85.7-1.035-85.7-21.469,0-3.529,0-14.046,44.111-19.2q3.316-34.163,6.549-68.331c-8.879-.126-15.527-1.672-22-5.1a15.991,15.991,0,0,1-4.275-2.618l-1.837-1.651,0-2.491c-.013-11.229-.234-22.827-.449-34.043-.19-9.893-.385-20.122-.43-29.835-.028-2.445-.028-4.916-.028-7.384v-.621l-1.889,1.126-2.414-5.837c-1.712-4.141-3.024-7.681-4.125-11.143a134.3,134.3,0,0,1-6.731-46.132c.291-15.7,5.015-33.334,12.956-48.272a163.177,163.177,0,0,1,12.651-20.007l.874-1.217c.957-1.343,2.03-2.848,3.255-4.305a38.555,38.555,0,0,1,14.623-14.909l10.65-6.067,6.4-3.659c-5.621-4.244-10.192-10.667-13.638-19.163-5.984-1.316-11.149-6.352-13.641-13.57-2.564-7.422-1.284-14.6,3.257-18.285a12.4,12.4,0,0,1,1.31-.932,30.354,30.354,0,0,1-.707-3.569c-.19-1.64-1.033-9.531-1.4-15.3a32.851,32.851,0,0,1,3.252-16.733A23.4,23.4,0,0,1,865.4,373.2c7.225-5.462,33.764-12.781,51.007-12.781,7.1,0,12.242,1.175,15.722,3.591,11.3,7.845,8.6,20.9,4.547,28.959,2.5,4.338,5.554,12.574,3.522,25.084.027.02.053.042.079.064,4.539,3.685,5.817,10.864,3.254,18.287-2.464,7.134-7.539,12.137-13.437,13.523-2.851,7.338-6.569,13.147-11.089,17.332v2.686l16.034,9.143A38.578,38.578,0,0,1,948.5,491.947c.3.249.643.563,1.05.964.508.5,1.055,1.071,1.619,1.739.159.18.259.3.345.416l.141.163.546.763a29.742,29.742,0,0,1,1.787,2.7l.306.5a71.577,71.577,0,0,1,3.688,7.393c1.071,2.455,2.1,5.092,3.069,7.829a7.888,7.888,0,0,1,5.823-2.684l.481.016,44.369,2.991a7.124,7.124,0,0,1,5.245,2.888,8.171,8.171,0,0,1,1.327,6.6l-5.939,27.665a7.746,7.746,0,0,1,1.87,1.8,8.946,8.946,0,0,1,1.434,7.216,10.648,10.648,0,0,1-.569,1.831,9.306,9.306,0,0,1,.325,5.156,10.355,10.355,0,0,1-1.607,3.734,9.6,9.6,0,0,1-.154,3.147,10.18,10.18,0,0,1-2.865,5.207,9.415,9.415,0,0,1-.178,1.2,9.181,9.181,0,0,1-6.032,6.924l-1.853,8.636a8.391,8.391,0,0,1-7.939,6.846l-.481-.016-4.319-.291a35.719,35.719,0,0,1-3.947,3.363,26.087,26.087,0,0,1-5.406,3.057,21.421,21.421,0,0,1-8.142,1.646c-.244,0-.489-.005-.737-.013a20.046,20.046,0,0,1-7.511-1.8c.094,6.427.14,13.41.14,21.634l-.012,7.357c-.037,9.3-.126,18.671-.212,28.1-.105,11.274-.212,22.929-.233,34.48v3.356l-2.519,1.634c-6.227,4.038-14.6,6.426-25.5,7.253q3.27,34.31,6.582,68.614c41.31,5.273,41.312,15.412,41.312,18.859C983.8,821.258,912.41,822.292,898.1,822.292Zm0-42.938q2.109,0,4.191.022c-.656-25.673-1.083-46.177-1.357-65.278q-1.562.037-3.124.06c-.261,19.046-.678,39.578-1.329,65.2Q897.288,779.354,898.1,779.355Z",
    transform: "translate(-812.398 -360.416)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71",
    transform: "translate(11.845 5.54)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    transform: "translate(0 106.414)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(20.267 315.725)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    className: "cls-11",
    d: "M877.33,798.612c3.772.206,7.784.445,10.7-1.12v-2.507l-11.284-1.426Z",
    transform: "translate(-844.51 -781.431)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    className: "cls-11",
    d: "M888.026,795.022c-20.048,5.406-34.947,6.059-43.25,2.944l-.263-3.187L887.7,791.1Z",
    transform: "translate(-844.51 -781.469)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    className: "cls-11",
    d: "M887.8,792.449c-6.33,3.954-39.729,6.271-43.282,2.472-.176-2.186,3.306-4.551,9.6-7.119.623-.251,1.27-.5,1.953-.765.47-.18.964-.358,1.47-.549.659-.24,1.33-.478,2.024-.717h.011c.471-.167.965-.335,1.459-.5h.012c.682-.227,1.388-.454,2.118-.694q2.611-.842,5.517-1.7C885.515,777.912,887.515,788.926,887.8,792.449Z",
    transform: "translate(-844.51 -781.614)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    transform: "translate(87.471 315.725)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    className: "cls-11",
    d: "M922.41,798.612c-3.772.206-7.784.445-10.7-1.12v-2.507L923,793.559Z",
    transform: "translate(-911.714 -781.431)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    className: "cls-11",
    d: "M911.714,795.022c20.047,5.406,34.946,6.059,43.249,2.944l.264-3.187L912.038,791.1Z",
    transform: "translate(-911.714 -781.469)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    className: "cls-11",
    d: "M911.942,792.449c6.329,3.954,39.729,6.271,43.282,2.472.176-2.186-3.306-4.551-9.6-7.119-.624-.251-1.271-.5-1.953-.765-.471-.18-.965-.358-1.471-.549-.658-.24-1.329-.478-2.023-.717h-.012c-.47-.167-.964-.335-1.459-.5H938.7c-.683-.227-1.389-.454-2.118-.694q-2.612-.842-5.518-1.7C914.224,777.912,912.225,788.926,911.942,792.449Z",
    transform: "translate(-911.714 -781.614)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    className: "cls-12",
    d: "M997.678,561.933a10.337,10.337,0,0,0-1.553-.943,10.525,10.525,0,0,0-14.141,5.029l-.047.1s-.212.442-.6,1.278-.988,2.054-1.741,3.56-1.718,3.308-2.835,5.256a54.2,54.2,0,0,1-3.694,5.614,65.533,65.533,0,0,1-3.165-9.234c-1.024-3.691-1.93-7.633-2.788-11.622s-1.659-8.064-2.447-12.089c-.8-4.049-1.541-7.98-2.412-12.041-.882-3.977-1.812-7.812-2.835-11.431-.036-.108-.059-.227-.094-.335-.989-3.488-2-6.76-3.059-9.783-1.071-3.129-2.188-5.985-3.294-8.517a65.577,65.577,0,0,0-3.318-6.677c-.6-.98-1.07-1.8-1.706-2.652-.152-.191-.294-.394-.423-.574l-.2-.274c-.071-.084-.118-.155-.259-.311-.459-.549-.906-1.015-1.318-1.422a8.844,8.844,0,0,0-.917-.812c-.153-.12-.271-.2-.377-.286a.315.315,0,0,1-.059-.048c-.164-.108-.247-.168-.247-.168a6.818,6.818,0,0,0-9.376,1.206,7.064,7.064,0,0,0,.953,9.831l.165.143a3.263,3.263,0,0,1,.294.24c.094.083.224.179.365.3.246.179.059.119-.024.1a.6.6,0,0,1-.235-.191.085.085,0,0,1,.023.048l.071.119c.047.084.106.168.165.263.211.287.506.908.835,1.494a55.793,55.793,0,0,1,2.235,5.268c.8,2.162,1.647,4.719,2.447,7.585.835,2.832,1.612,6,2.353,9.341s1.4,6.94,2.023,10.643c.565,3.655,1.118,7.729,1.683,11.8q.441,3.243.918,6.557c.294,1.972.588,3.954.9,5.949.659,4.229,1.4,8.506,2.33,12.794a78.8,78.8,0,0,0,3.87,13.176,33.378,33.378,0,0,0,2.388,4.754,24.039,24.039,0,0,0,1.8,2.58,17.972,17.972,0,0,0,4.4,3.966,14.8,14.8,0,0,0,7.212,2.258,15.976,15.976,0,0,0,6.635-1.231,20.669,20.669,0,0,0,4.259-2.413A33.157,33.157,0,0,0,988,595.381c1.317-1.481,2.435-2.879,3.4-4.2,1.011-1.362,1.882-2.64,2.682-3.846,1.541-2.365,2.788-4.42,3.765-6.117s1.717-3.034,2.2-3.942.765-1.386.765-1.386c.083-.167.188-.37.271-.537A10.848,10.848,0,0,0,997.678,561.933Zm-22.729,23.055a1.477,1.477,0,0,1-.212-.239C975.078,585,975.067,585.1,974.949,584.989Z",
    transform: "translate(-824.243 -470.342)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    className: "cls-13",
    d: "M958.469,667.219l-32.792-56.457H864.811L840.4,667.219v30.359c9.822,8.84,81.482,10.426,118.069,0Z",
    transform: "translate(-824.243 -468.518)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    className: "cls-14",
    d: "M928.828,482.084l-16.29-11.177c-.476,7.31-3.66,13.516-13.2,15.22-8.466-1.45-12.867-8.142-13.593-15.453l-15.9,11.411c-10.263,33.022-13.352,69.856-12.578,108.744,14.169,2.841,29.777,21.089,42.07,21.035,12.292.054,27.9-18.194,42.07-21.035C940.645,550.108,937.391,512.637,928.828,482.084Z",
    transform: "translate(-824.243 -470.673)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(33.007 120.155)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    className: "cls-15",
    d: "M899.336,647.27a102.3,102.3,0,0,1-15.322-.68A27.776,27.776,0,0,1,860.3,624.457a166.723,166.723,0,0,1-3.034-35.45c14.416,4.178,28.5,6.876,42.07,7.334,13.574-.458,27.654-3.156,42.07-7.334a166.723,166.723,0,0,1-3.034,35.45,27.778,27.778,0,0,1-23.715,22.132A102.279,102.279,0,0,1,899.336,647.27Z",
    transform: "translate(-857.25 -589.007)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    transform: "translate(7.561 2.054)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    className: "cls-11",
    d: "M867.188,600.232h-2.377v-9.2l2.377.592Z",
    transform: "translate(-864.811 -591.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    className: "cls-11",
    d: "M931.483,600.232h2.378v-9.2l-2.378.592Z",
    transform: "translate(-864.811 -591.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    className: "cls-11",
    d: "M880.918,603.245H878.54v-9.2l2.378.343Z",
    transform: "translate(-864.811 -590.983)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    className: "cls-11",
    d: "M917.754,603.245h2.377v-9.2l-2.377.343Z",
    transform: "translate(-864.811 -590.983)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    className: "cls-15",
    d: "M891.322,790.081c.1-1.163-.458-8.313-.428-9.492,1.379-53.356,2.412-106.587,1.334-159.957-.242-10.433-15.526-11.827-17.55-1.6-1.143,5.777-.719,12.227-1.017,18.079-1.205,23.637-2.736,47.252-4.979,70.814q-3.6,37.822-7.254,75.641c-.018.182-.024.362-.035.542C866.953,787.276,876.109,791.54,891.322,790.081Z",
    transform: "translate(-824.243 -468.498)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    className: "cls-15",
    d: "M907.382,787.434c-.1-1.163.458-8.313.428-9.492-1.379-53.357-2.411-106.587-1.334-159.957.242-10.433,15.526-11.827,17.55-1.6,1.143,5.778.719,12.227,1.017,18.079,1.2,23.636,2.736,47.252,4.979,70.814q3.6,37.823,7.254,75.641c.018.182.024.362.035.542C930.631,786.328,920.875,789.517,907.382,787.434Z",
    transform: "translate(-824.243 -468.539)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    className: "cls-12",
    d: "M885.743,470.674c-.295,26.452-.228,52.891-.268,78.419-.107,62.1-.8,118.731-8.639,156.444-14.948.912-25.158,1.513-36.436-5.8-.027-21.284-.787-43.32-.881-63.9-.026-2.462-.026-4.91-.026-7.359-.081-44.962,1.393-87.545,10.6-125.395a33.338,33.338,0,0,1,15.818-21.095l10.649-6.065Z",
    transform: "translate(-824.243 -470.673)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    className: "cls-12",
    d: "M958.926,629.467c0,2.449-.012,4.9-.012,7.358-.082,20.618-.412,41.678-.447,62.905-11.271,7.311-29.623,7.2-44.564,6.283,4.106-39.575,2.129-96.46.341-158.874-.729-24.787-1.423-50.434-1.706-76.236l9.224,5.268,10.611,6.045A33.045,33.045,0,0,1,944.4,494.042a34.047,34.047,0,0,1,3.789,9.257,311.532,311.532,0,0,1,5.905,31.823,558.069,558.069,0,0,1,4.447,60.169c.071,2.975.142,5.961.189,8.96C958.879,612.564,958.926,620.974,958.926,629.467Z",
    transform: "translate(-824.243 -470.669)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    className: "cls-16",
    d: "M958.926,627.068c0,2.448-.014,4.9-.014,7.358h-26.2c-.026-2.461-.026-4.909-.026-7.358Z",
    transform: "translate(-824.243 -468.267)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49",
    transform: "translate(12.355 135.444)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    className: "cls-17",
    d: "M868.2,628.357v6.08H864.68l-1.27-2.328a.249.249,0,0,1-.035-.06l-.8-1.481a3.006,3.006,0,0,1,.436-3.489,2.748,2.748,0,0,1,.729-.585l.047-.036a2.93,2.93,0,0,1,3.624.62,2.876,2.876,0,0,1,.376.526L868,628Z",
    transform: "translate(-836.598 -603.726)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    className: "cls-17",
    d: "M864.68,634.393h-6.823l-.106-.179c-.012-.024-.023-.06-.035-.083l-.377-.681a3.026,3.026,0,0,1,1.165-4.074l.059-.035a2.925,2.925,0,0,1,4.011,1.183l.8,1.481a.246.246,0,0,0,.035.06Z",
    transform: "translate(-836.598 -603.682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    className: "cls-17",
    d: "M850.11,613.667l.028-.06a3.087,3.087,0,0,1,4.413-1.215A96.5,96.5,0,0,0,873.9,620.42a3.373,3.373,0,0,1,2.271,4.011l-.015.064a3.088,3.088,0,0,1-3.94,2.269,102.592,102.592,0,0,1-20.338-8.293A3.831,3.831,0,0,1,850.11,613.667Z",
    transform: "translate(-836.598 -603.944)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    className: "cls-17",
    d: "M857.857,634.349H851.8a3,3,0,0,1,1.483-2.1l.046-.024a2.924,2.924,0,0,1,4.012,1.183l.377.681c.012.023.023.059.035.083Z",
    transform: "translate(-836.598 -603.637)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    className: "cls-18",
    d: "M865.68,623.924l-.753.43-5.247,2.926-13.14,7.359h-1.565l-.153-.3-2.906-5.363a8.435,8.435,0,0,1-.694-1.7,8.8,8.8,0,0,1,.365-6.139c.117-.263.247-.526.388-.777a8.588,8.588,0,0,1,3.353-3.38l4.529-2.532h.012l.565-.323a8.493,8.493,0,0,1,5.447-1h.011c.035,0,.071.011.094.011H856c.224.037.447.084.671.144a8.49,8.49,0,0,1,3.847,2.09l.011.012a8.675,8.675,0,0,1,1.718,2.222l.071.132,2.847,5.232Z",
    transform: "translate(-836.598 -603.927)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    className: "cls-18",
    d: "M858.528,618.125l-3.623,2.031-10.682,5.973-.247-.454-2.388-4.4-.529-.98-2.082-3.846-2.377-4.384,14.294-8,2.176,4,2.788,5.137.024.06h.012Z",
    transform: "translate(-836.598 -604.065)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    className: "cls-18",
    d: "M868.2,628.408v4.229a2.947,2.947,0,0,1-.753.609l-.059.024a2.932,2.932,0,0,1-3.976-1.111,2.985,2.985,0,0,1,.164,2.328h-5.717l-.141-.262c.012.023.023.059.035.083a1.224,1.224,0,0,1,.082.179H844.975l-.153-.3,1.129-.633,11.494-6.427,6.153-3.44,1.565-.871.517.955.471.872,1.353,2.484.282.526.212.394Z",
    transform: "translate(-836.598 -603.776)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    className: "cls-12",
    d: "M866.469,504.787c-.165.226-.33.466-.483.693-15.435,21.932-24.023,45.548-20.458,73.668,1.894,14.991,5.623,16.52,11.623,28.239l-4.082,2.425L838.975,618.2l-3.271,1.935-.941.561c-1.447-3.5-2.8-7.049-3.964-10.7a128.212,128.212,0,0,1-6.471-44.21c.294-15.792,5.118-32.336,12.306-45.859a158.718,158.718,0,0,1,12.223-19.328c3.035-4.157,7.024-10.739,12.588-9.854C867.327,491.67,870.139,499.615,866.469,504.787Z",
    transform: "translate(-824.243 -470.366)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    className: "cls-16",
    d: "M868.2,627.064v7.358H839.916c-.023-2.46-.023-4.909-.023-7.358Z",
    transform: "translate(-824.243 -468.267)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51",
    transform: "translate(124.377 44.906)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    className: "cls-13",
    d: "M950.3,592.674l44.367,2.991a2.936,2.936,0,0,0,2.731-2.482l15.568-72.515c.311-1.451-.407-2.694-1.6-2.774L966.992,514.9a2.937,2.937,0,0,0-2.731,2.483L948.693,589.9C948.382,591.351,949.1,592.593,950.3,592.674Z",
    transform: "translate(-948.62 -514.899)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    className: "cls-18",
    d: "M998.535,556.049l.015-.069c.4-1.882,1.989-3.322,3.54-3.218l6.158.408c1.552.1,2.482,1.715,2.078,3.6l-.015.068c-.4,1.883-1.989,3.322-3.54,3.218l-6.158-.407C999.061,559.541,998.131,557.93,998.535,556.049Z",
    transform: "translate(-948.62 -514.317)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    className: "cls-18",
    d: "M997.045,562.844l.015-.068c.4-1.882,1.989-3.322,3.541-3.218l7.4.493c1.552.1,2.482,1.715,2.078,3.6l-.015.069c-.4,1.882-1.989,3.322-3.54,3.218l-7.405-.494C997.571,566.337,996.641,564.726,997.045,562.844Z",
    transform: "translate(-948.62 -514.212)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    className: "cls-18",
    d: "M995.556,569.64l.014-.068c.4-1.883,1.99-3.323,3.541-3.218l7.133.475c1.552.1,2.482,1.714,2.078,3.6l-.015.068c-.4,1.882-1.989,3.323-3.541,3.219l-7.133-.476C996.082,573.132,995.152,571.522,995.556,569.64Z",
    transform: "translate(-948.62 -514.107)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    className: "cls-18",
    d: "M994.812,576.09l.013-.062a3.38,3.38,0,0,1,3.143-2.855l5.466.361c1.378.093,2.2,1.522,1.845,3.192l-.013.061a3.38,3.38,0,0,1-3.143,2.856l-5.466-.362C995.279,579.189,994.453,577.761,994.812,576.09Z",
    transform: "translate(-948.62 -514.003)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    transform: "translate(27.28 45.806)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    className: "cls-11",
    d: "M868.714,570.592a5.429,5.429,0,0,1-4.54-2.123c-1.735-2.028-2.616-4.837-3.392-7.315l-7.031-22.411c-1.182-3.763-2.652-8.447-2.114-12.992a10.6,10.6,0,0,1,3.277-6.663,4.538,4.538,0,0,1,4.312-1.1l-.217,1.531a3.611,3.611,0,0,0-3.372.885,9,9,0,0,0-2.776,5.654c-.487,4.124.854,8.4,2.036,12.164l7.032,22.411c.725,2.313,1.547,4.934,3.058,6.7,1.306,1.525,3.184,2.111,4.468,1.4l.183-.1.2.058c1.408.412,3.114-.577,4.062-2.353,1.1-2.06,1.34-4.8,1.554-7.215l2.075-23.427c.349-3.941.745-8.406-.611-12.324A8.932,8.932,0,0,0,873,518.473a3.6,3.6,0,0,0-3.481-.122l-.539-1.447a4.518,4.518,0,0,1,4.444.122,10.512,10.512,0,0,1,4.623,5.783c1.5,4.317,1.061,9.214.712,13.148l-2.076,23.426c-.227,2.589-.487,5.526-1.747,7.888-1.183,2.222-3.262,3.437-5.121,3.012A3.426,3.426,0,0,1,868.714,570.592Z",
    transform: "translate(-851.523 -515.776)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    className: "cls-14",
    d: "M861.626,519.88l-2.974.093a.8.8,0,0,1-.723-.786l-.133-1.225a.806.806,0,0,1,.538-.927l2.923-.565c.384-.073.754.282.807.778l.183,1.695A.775.775,0,0,1,861.626,519.88Z",
    transform: "translate(-851.523 -515.774)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    className: "cls-14",
    d: "M867.041,519.287l2.923-.565a.8.8,0,0,0,.538-.927l-.132-1.225a.8.8,0,0,0-.723-.786l-2.974.093a.774.774,0,0,0-.622.936l.183,1.695C866.288,519,866.658,519.361,867.041,519.287Z",
    transform: "translate(-851.523 -515.785)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    className: "cls-11",
    d: "M874.256,563.327c-2.039-1.823-1.921-4.4-1.806-6.9.027-.593.055-1.189.051-1.776-.008-1.562-.066-3.088-.124-4.616-.051-1.335-.1-2.673-.12-4.039-.043-3.042-.753-6.855-2.623-8.429a4.9,4.9,0,0,0-4.129-.595,4.1,4.1,0,0,0-2.914,2,9.561,9.561,0,0,0-.532,4.827l1.3,12.736-1.755.185-1.3-12.736a11.3,11.3,0,0,1,.673-5.734,5.755,5.755,0,0,1,4.124-3.018,6.563,6.563,0,0,1,5.661.961c2.933,2.47,3.237,8.113,3.26,9.783.018,1.35.069,2.673.119,3.995.059,1.548.117,3.093.126,4.675,0,.618-.025,1.246-.054,1.869-.1,2.263-.193,4.219,1.21,5.473Z",
    transform: "translate(-824.243 -469.684)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    className: "cls-11",
    d: "M870.06,559.281a51.9,51.9,0,0,1-.38-5.379c-.055-1.574-.113-3.2-.309-4.812-.036-.3-.066-.625-.1-.958a11.584,11.584,0,0,0-.412-2.524c-.228-.646-.931-1.253-1.49-1.075-1.99.586-1.3,6.163-.714,9.441l-1.737.317c-1.631-9.184.135-10.942,1.854-11.446a3.132,3.132,0,0,1,3.749,2.161,12.814,12.814,0,0,1,.507,2.96c.029.316.057.621.091.9.206,1.689.265,3.356.322,4.968a49.773,49.773,0,0,0,.363,5.193Z",
    transform: "translate(-824.243 -469.565)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53",
    transform: "translate(31.602 81.239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    className: "cls-13",
    d: "M855.845,550.682v22.976a7.523,7.523,0,0,0,7.465,7.58H871.8a7.523,7.523,0,0,0,7.464-7.58V550.682Z",
    transform: "translate(-855.845 -550.682)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    className: "cls-16",
    width: 23.416,
    height: 5.772,
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    className: "cls-11",
    d: "M861.978,570.819l-1.75-.231a24.625,24.625,0,0,0-.99-10.65c-.128-.4-.266-.79-.4-1.184a18.083,18.083,0,0,1-1.025-3.783c-.228-1.847-.062-4.561,1.158-6.134a3.434,3.434,0,0,1,3.947-.944,3.156,3.156,0,0,1,2.344,2.8h-1.764c0-.4-.5-.873-1.157-1.1a1.768,1.768,0,0,0-1.984.359c-.821,1.06-.987,3.233-.793,4.8a16.559,16.559,0,0,0,.936,3.406c.144.407.287.815.419,1.225A26.457,26.457,0,0,1,861.978,570.819Z",
    transform: "translate(-824.243 -469.489)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    transform: "translate(30.091 99.946)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    className: "cls-14",
    width: 3.535,
    height: 4.932,
    transform: "translate(5.291)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54",
    transform: "translate(0 3.479)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    className: "cls-11",
    cx: 7.059,
    cy: 7.167,
    rx: 7.059,
    ry: 7.167
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    className: "cls-14",
    d: "M864.726,579.642a3.334,3.334,0,1,1-3.333-3.385A3.36,3.36,0,0,1,864.726,579.642Z",
    transform: "translate(-854.334 -572.474)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70",
    transform: "translate(32.909)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    className: "cls-18",
    d: "M899.766,487.995h0a13.933,13.933,0,0,1-13.785-14V458.7a13.933,13.933,0,0,1,13.785-14h0a13.933,13.933,0,0,1,13.785,14V474A13.933,13.933,0,0,1,899.766,487.995Z",
    transform: "translate(-857.152 -364.659)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    className: "cls-17",
    d: "M899.766,444.706c7.582,0,13.067,7.916,12.286,16.538l-1.306,14.394c-.557,6.147-5.476,10.731-10.98,10.731h0c-5.5,0-10.423-4.583-10.98-10.731l-1.306-14.394c-.781-8.622,4.7-16.538,12.286-16.538a13.934,13.934,0,0,0-13.786,14V474a13.934,13.934,0,0,0,13.786,14h0a13.933,13.933,0,0,0,13.785-14V458.7A13.933,13.933,0,0,0,899.766,444.706Z",
    transform: "translate(-857.152 -364.659)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    className: "cls-17",
    d: "M907.889,475.942a28.307,28.307,0,0,0,5.569-.571,14.248,14.248,0,0,0,.093-1.568V458.508c0-.38-.027-.752-.056-1.125a20.683,20.683,0,0,1-6.827,1.177h-13.7a20.734,20.734,0,0,1-6.931-1.2c-.031.38-.058.761-.058,1.148V473.8a14.046,14.046,0,0,0,.092,1.557,28.368,28.368,0,0,0,5.683.582Z",
    transform: "translate(-857.152 -364.464)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    transform: "translate(0 54.974)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    className: "cls-18",
    d: "M872.024,423.892s-6.868-6.823-12.354-2.371c-6.48,5.261.3,24.193,11.794,22.187Z",
    transform: "translate(-857.152 -420.013)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    transform: "translate(67.364 54.974)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    className: "cls-18",
    d: "M924.516,423.892s6.868-6.823,12.354-2.371c6.48,5.261-.3,24.193-11.793,22.187Z",
    transform: "translate(-924.516 -420.013)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    className: "cls-18",
    d: "M898.614,469.285c-23.733,0-31.06-28.623-33.244-49.578-2.014-19.321,12.761-36.349,31.894-36.572.254,0,.51,0,.768,0q.479,0,.95.006c18.9.257,33.621,16.822,31.988,35.942C929.157,440.309,922.337,469.285,898.614,469.285Z",
    transform: "translate(-857.152 -365.606)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    className: "cls-19",
    d: "M929.052,368.5c12.041,8.363,1.148,24.669,1.148,24.669s11.988,11.917-.351,39.969l-2.2-.456c1.4-8.982.56-19.916,0-21.638-1.669-5.129-10.532-7.861-10.077-13.405,0,0-27.167,8.625-41.869.154,0,0-1.161,7.106-5.189,11.588-3.371,3.75-1.452,16.808-1.018,22.457l-2.257.225c-1.338-5.755-4.6-16.119-4.954-19.172-.221-1.924-1.028-9.557-1.373-15.015A27.214,27.214,0,0,1,863.585,384a18.125,18.125,0,0,1,5.078-6.445C876.556,371.587,918.132,360.912,929.052,368.5Z",
    transform: "translate(-857.152 -365.872)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63",
    transform: "translate(27.871 75.542)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    className: "cls-11",
    d: "M914.224,440.269a15.919,15.919,0,0,1-1.111,2.6,17.405,17.405,0,0,1-5.461,6.33q-.486.334-1.013.628a14.3,14.3,0,0,1-7.158,1.816,15.13,15.13,0,0,1-6.588-1.414c-.315-.149-.619-.311-.912-.477a15.521,15.521,0,0,1-5.629-5.725,14.8,14.8,0,0,1-1.329-2.908c.025.012.428.254,1.158.605a30.333,30.333,0,0,0,13.036,2.835c.089,0,.177,0,.264,0l.292-.007a30.285,30.285,0,0,0,13.058-3.471C913.69,440.62,914.18,440.3,914.224,440.269Z",
    transform: "translate(-885.023 -440.269)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    className: "cls-19",
    d: "M906.639,449.7a14.3,14.3,0,0,1-7.158,1.816,15.13,15.13,0,0,1-6.588-1.414,14.217,14.217,0,0,1,7.047-1.587A18.523,18.523,0,0,1,906.639,449.7Z",
    transform: "translate(-885.023 -440.142)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    className: "cls-5",
    d: "M914.224,440.269a15.919,15.919,0,0,1-1.111,2.6,24.22,24.22,0,0,1-13.173,3.644,35.1,35.1,0,0,1-13.588-2.487,14.8,14.8,0,0,1-1.329-2.908c.025.012.428.254,1.158.605a30.333,30.333,0,0,0,13.036,2.835c.089,0,.177,0,.264,0l.292-.007a30.285,30.285,0,0,0,13.058-3.471C913.69,440.62,914.18,440.3,914.224,440.269Z",
    transform: "translate(-885.023 -440.269)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65",
    transform: "translate(18.643 42.83)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    className: "cls-19",
    d: "M875.795,415.424s1.824-4.933,6.056-6.528a10.984,10.984,0,0,1,8.4-.038,1.477,1.477,0,0,1,.816,1.735h0a1.45,1.45,0,0,1-1.892,1.008C886.634,410.683,881.143,409.714,875.795,415.424Z",
    transform: "translate(-875.795 -408.053)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67",
    transform: "translate(49.818 42.966)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    className: "cls-19",
    d: "M922.508,415.086s-2.04-4.844-6.338-6.246a10.984,10.984,0,0,0-8.392.345,1.478,1.478,0,0,0-.739,1.771h0a1.447,1.447,0,0,0,1.935.92C911.471,410.843,916.914,409.626,922.508,415.086Z",
    transform: "translate(-906.97 -408.187)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68",
    transform: "translate(35.246 88.564)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    className: "cls-17",
    d: "M899.717,456.59a12.555,12.555,0,0,1-6.892-1.848.9.9,0,0,1-.3-1.215.867.867,0,0,1,1.2-.309c5.819,3.519,11.479.168,11.717.023a.866.866,0,0,1,1.2.3.9.9,0,0,1-.3,1.215A14.367,14.367,0,0,1,899.717,456.59Z",
    transform: "translate(-892.398 -453.093)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    className: "cls-5",
    d: "M908.151,424.961s6.317,8.778,14.559-.344c.273-.306-.393-1.632-.513-1.929a7.231,7.231,0,0,0-6.629-4.225,8.825,8.825,0,0,0-6.7,3.179A4.466,4.466,0,0,0,908.151,424.961Z",
    transform: "translate(-857.152 -365.063)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    className: "cls-11",
    d: "M920.014,423.546a4.879,4.879,0,1,1-4.878-4.954A4.916,4.916,0,0,1,920.014,423.546Z",
    transform: "translate(-857.152 -365.061)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    className: "cls-11",
    d: "M908.151,425.309a9.9,9.9,0,0,1,1.351-5.6,5.4,5.4,0,0,1,2.411-1.923,8.09,8.09,0,0,1,2.965-.522,7.992,7.992,0,0,1,5.441,2.2,8.743,8.743,0,0,1,2.625,5.083,11.551,11.551,0,0,0-3.352-4.2,7.95,7.95,0,0,0-4.733-1.624,5.585,5.585,0,0,0-4.481,1.682A13.828,13.828,0,0,0,908.151,425.309Z",
    transform: "translate(-857.152 -365.081)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    className: "cls-5",
    d: "M890.813,424.961s-6.317,8.778-14.559-.344c-.274-.306.393-1.632.512-1.929a7.231,7.231,0,0,1,6.63-4.225,8.828,8.828,0,0,1,6.7,3.179A4.475,4.475,0,0,1,890.813,424.961Z",
    transform: "translate(-857.152 -365.063)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    className: "cls-11",
    d: "M878.95,423.546a4.879,4.879,0,1,0,4.878-4.954A4.916,4.916,0,0,0,878.95,423.546Z",
    transform: "translate(-857.152 -365.061)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    className: "cls-11",
    d: "M890.813,425.309a13.811,13.811,0,0,0-2.228-4.906,5.583,5.583,0,0,0-4.481-1.682,7.955,7.955,0,0,0-4.733,1.624,11.562,11.562,0,0,0-3.352,4.2,8.745,8.745,0,0,1,2.626-5.083,7.992,7.992,0,0,1,5.441-2.2,8.1,8.1,0,0,1,2.965.522,5.4,5.4,0,0,1,2.411,1.923A9.911,9.911,0,0,1,890.813,425.309Z",
    transform: "translate(-857.152 -365.081)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    className: "cls-17",
    d: "M904.548,432.969a3.363,3.363,0,0,1-3.277,2.754H898.26a3.362,3.362,0,0,1-3.276-2.754h-.721a4.177,4.177,0,0,0,4.126,3.927h2.754a4.177,4.177,0,0,0,4.126-3.927Z",
    transform: "translate(-857.152 -364.839)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69",
    transform: "translate(34.432 14.39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    className: "cls-5",
    d: "M891.747,388.249a28.226,28.226,0,0,0,15.2.83c4.884-1.151,9.658-4,11.98-8.663.122-.245-.236-.518-.4-.28a20.214,20.214,0,0,1-11.932,8.21,28.358,28.358,0,0,1-14.751-.535c-.275-.082-.36.351-.093.439Z",
    transform: "translate(-891.585 -380.044)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    className: "cls-5",
    d: "M879.811,622.292c-9.268-32.347-34.75-61.159-68.456-77.583a189.483,189.483,0,0,0-4.414-21.461c-1.5-5.7-3.066-10.773-4.694-15.171l5.213-1.831-1.479-5.048c-.321-1.1-.68-2.135-1.1-3.277l-.36-.949-2.052-5.094-.3.1a36.882,36.882,0,0,0-19.108-16.82q-.222-.548-.471-1.079l-.5-1.069a65.229,65.229,0,0,0-4.724-8.807c-2.993-4.417-2.68-9.983-2.315-16.428l.112-1.965a109.979,109.979,0,0,0,.136-16c-1.1-11.783-3.721-25.112-14.824-34.623-5.023-4.3-8.968-6.137-13.2-6.137-.383,0-.764.014-1.149.046-4.867-4.129-10.794-6.143-18.022-6.143a54.034,54.034,0,0,0-9.069.858,50.87,50.87,0,0,0-24.267,11.427c-11.441,9.8-15.672,24.474-17.209,35.056a85.589,85.589,0,0,0-.746,17.044c.057,1.047.138,2.116.218,3.2.42,5.664.818,11.012-1.637,14.634-.594.875-1.246,1.7-1.9,2.535a34.03,34.03,0,0,0-4.2,6.378,19.46,19.46,0,0,0-.816,2.018,36.745,36.745,0,0,0-16.944,15.887l-.322-.11L649.3,496.66s-.408,1.064-.525,1.387c-.375,1.016-.736,2.054-1.057,3.152l-.545,1.86c-1.107,1.016-2.848,2.538-4.814,4.258-2.291,2-4.983,4.359-7.609,6.731-.043-.075-.085-.149-.13-.223l.7-.777-11.181-20.069,3.141-7.89a8.307,8.307,0,0,0,1.07-2.75l1.309-6.829a8.281,8.281,0,0,0-1.238-6.172,8.044,8.044,0,0,0-5.171-3.479,7.926,7.926,0,0,0-1.547-.151,8.03,8.03,0,0,0-5.376,2.072l-2.51-6.561c-1.443-3.783-4.765-6.325-8.262-6.325a7.218,7.218,0,0,0-2.209.344,8.021,8.021,0,0,0-11.352,2.92A8.125,8.125,0,0,0,586,464.35a8.111,8.111,0,0,0-3.8,4.057,8.3,8.3,0,0,0-.135,6.3l9.471,24.676a11.4,11.4,0,0,0,5.48,6.085l3.925,23.117,5.146-.486c.472.935.967,1.924,1.477,2.942,1.492,2.977,3.129,6.244,4.677,9.233a13.209,13.209,0,0,0-1.66,5.57c-.592,8.648,7.174,16,17.679,16.744.554.041,1.1.059,1.648.059,9.755,0,17.532-6.043,18.133-14.073,8.018-3.887,17.6-10.156,27.442-17.988q1.493-1.186,2.909-2.358a55.163,55.163,0,0,0,7.476,21.854l3.43,38.533h-.054a7.411,7.411,0,0,0-3.167.707l-.461.216-10.757-23.664a12.076,12.076,0,0,0-.651-8.168,11.788,11.788,0,0,0-10.688-6.929,11.462,11.462,0,0,0-4.907,1.1,11.783,11.783,0,0,0-6.1,6.713,12.015,12.015,0,0,0,.35,9.121,11.807,11.807,0,0,0,5.7,5.8l10.757,23.664-.465.216a7.754,7.754,0,0,0-3.7,10.2l.344.754a7.62,7.62,0,0,0,5.433,4.319,8.367,8.367,0,0,0,.452,5.749,7.955,7.955,0,0,0,4.7,4.244l8.389,18.025c-.185,3.715-.28,7.509-.28,11.3a163.583,163.583,0,0,0,1.191,20.882c-4.595,4.147-7.414,10.938-7.414,18.361,0,9.168,4.358,17.325,10.841,20.763-.081,2.146-.12,4.445-.12,6.942a165.525,165.525,0,0,0,1.141,19.158l-1.111.362,3.469,33.97q-.717.623-1.421,1.228c-43.985,5.418-50.612,17.416-50.612,24.138,0,20.764,56.677,26.25,86.646,26.25s86.645-5.486,86.645-26.25c0-6.715-6.612-18.7-50.512-24.126-.474-.408-.95-.821-1.434-1.239l3.472-33.971-1.113-.362A165.525,165.525,0,0,0,765,718.929c0-2.5-.04-4.8-.12-6.943,6.483-3.439,10.839-11.6,10.839-20.762,0-7.423-2.819-14.215-7.415-18.361A162.842,162.842,0,0,0,769.5,651.98v0a142.057,142.057,0,0,0,31.574,3.6h0c28.893,0,55.722-9.1,75.544-25.617a11,11,0,0,0,2.846-3.688l.936-1.919ZM728.631,771.539q-.91-.006-1.826-.005c-.583,0-1.162,0-1.741,0l-.39-44.681c.021-.383.039-.767.058-1.15l4.263,4.022Z",
    transform: "translate(-581.51 -360.069)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81",
    transform: "translate(5.424 28.384)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    className: "cls-16",
    d: "M743.644,395.016c3.948-1.214,7.1-1.134,13.327,4.2,8.892,7.617,11.756,18.432,12.922,30.937.494,5.29.059,11.389-.238,16.7-.4,7.063-.893,14.206,3.238,20.3a69.455,69.455,0,0,1,4.807,9.143,16.1,16.1,0,0,1,.609,11.95,14.033,14.033,0,0,1-7.731,8.382,18.192,18.192,0,0,0-.734-5.614c-.629-1.77-1.953-3.359-3.651-3.663a7.573,7.573,0,0,1-2.454,7.509,11.938,11.938,0,0,0-3.5-7.258c-.2,1.9-2.7,5.751-3.27,6.3-2.364,2.269-5.175,2.494-8.2,3.419a14.543,14.543,0,0,0,2.059-7.8,13.8,13.8,0,0,1-8.215,7.227,22.281,22.281,0,0,0,1.394-6.325,17.981,17.981,0,0,1-12.608,6.57",
    transform: "translate(-586.933 -388.277)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    className: "cls-16",
    d: "M749.053,401.558c-7.278-13.988-18.483-14.2-29.135-12.4a45.2,45.2,0,0,0-21.659,10.2c-8.892,7.617-13.6,19.634-15.341,31.652a80.185,80.185,0,0,0-.7,15.929c.4,7.063,1.765,15.169-2.366,21.263-1.868,2.756-4.234,5.129-5.679,8.18a16.1,16.1,0,0,0-.609,11.95,14.035,14.035,0,0,0,7.731,8.382,18.192,18.192,0,0,1,.734-5.614c.629-1.77,1.953-3.359,3.651-3.663a7.575,7.575,0,0,0,2.454,7.509,11.944,11.944,0,0,1,3.5-7.259c-.857.822,1.981,5.255,2.43,5.786,1.925,2.271,4.632,2.441,7.352,3.207-.369-2.107-.586-4.7.957-6a13.462,13.462,0,0,0,8.07,6.326,5.247,5.247,0,0,1,1.153-6.183,16.412,16.412,0,0,0,4.042,4.312,6.662,6.662,0,0,0,5.4,1.147",
    transform: "translate(-586.933 -388.37)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    className: "cls-11",
    d: "M678.8,599.819a3.218,3.218,0,0,0-.8.551c-.132-.247-.26-.5-.379-.762l-15.479-34.05c-1.58-3.475-1.42-7,.355-7.83s4.519,1.33,6.1,4.8l15.479,34.05q.145.318.271.639Z",
    transform: "translate(-586.933 -385.767)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    className: "cls-15",
    d: "M688.781,595.4l-14.668,6.874,53.845,115.695,15.579,14.7-.911-21.574Z",
    transform: "translate(-586.933 -385.185)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    className: "cls-14",
    d: "M682.621,598.243l-2.347,1.1,53.845,115.7,9.418,17.587-7.071-18.687Z",
    transform: "translate(-586.933 -385.141)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_851",
    "data-name": "Path 851",
    className: "cls-11",
    d: "M.9-.011,22.415-.136a.9.9,0,0,1,.9.908L23.3,4.13a.922.922,0,0,1-.91.919L.87,5.175a.9.9,0,0,1-.9-.908L-.011.908A.922.922,0,0,1,.9-.011Z",
    transform: "translate(82.254 214.85) rotate(-24.777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    className: "cls-11",
    d: "M660.883,554.242h0a6.491,6.491,0,0,0-3.1,8.532h0a6.311,6.311,0,0,0,8.4,3.144h0a6.492,6.492,0,0,0,3.1-8.533h0A6.311,6.311,0,0,0,660.883,554.242Z",
    transform: "translate(-586.933 -385.827)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    className: "cls-12",
    d: "M722.778,648.827c0,33.646-7.424,45.7-16.581,45.7s-16.581-12.057-16.581-45.7,7.424-60.921,16.581-60.921S722.778,615.181,722.778,648.827Z",
    transform: "translate(-586.933 -385.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    className: "cls-12",
    d: "M719.405,718.95c-1.636,38.047-8.433,58.023-10.959,58.023-2.945,0-14.333-29.005-14.333-62.651,0-21.245,2.927-31.988,12.084-31.988S720.85,685.335,719.405,718.95Z",
    transform: "translate(-586.933 -383.847)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    className: "cls-14",
    d: "M718.19,690.14,692.813,693.5V679.818l25.377,3.356Z",
    transform: "translate(-586.933 -383.886)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    className: "cls-15",
    cx: 12.299,
    cy: 17.014,
    rx: 12.299,
    ry: 17.014,
    transform: "translate(96.459 285.757)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    className: "cls-14",
    d: "M695.691,669.8a9.109,9.109,0,0,0-2.937.509c5.372,1.825,9.362,8.512,9.362,16.505s-3.99,14.682-9.362,16.505a9.083,9.083,0,0,0,2.937.509c6.793,0,12.3-7.617,12.3-17.014S702.484,669.8,695.691,669.8Z",
    transform: "translate(-586.933 -384.04)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    className: "cls-14",
    d: "M694.567,737l24.753-8.067.506,58.163-6.133,3.044s5.392-16.181-15.817-20.747Z",
    transform: "translate(-586.933 -383.13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    className: "cls-15",
    d: "M713.693,789.53s7.415-18.837-15.817-20.747c-18.749,16.388-30.346,24.988-30.346,24.988S669.49,806.249,713.693,789.53Z",
    transform: "translate(-586.933 -382.517)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    className: "cls-12",
    d: "M668.956,792.439c-.932.714-1.426,1.079-1.426,1.079s1.96,12.478,46.163-4.24a19.075,19.075,0,0,0,.966-4.081C685.969,795.786,673.81,794.436,668.956,792.439Z",
    transform: "translate(-586.933 -382.265)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    className: "cls-15",
    d: "M719.32,728.936,694.567,737l1.04,10.186,23.812-6.778Z",
    transform: "translate(-586.933 -383.13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    className: "cls-12",
    d: "M730.918,648.827c0,33.646,7.423,45.7,16.58,45.7s16.581-12.057,16.581-45.7-7.423-60.921-16.581-60.921S730.918,615.181,730.918,648.827Z",
    transform: "translate(-586.933 -385.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    className: "cls-12",
    d: "M734.29,718.95c1.636,38.047,8.433,58.023,10.96,58.023,2.944,0,14.332-29.005,14.332-62.651,0-21.245-2.926-31.988-12.084-31.988S732.845,685.335,734.29,718.95Z",
    transform: "translate(-586.933 -383.847)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    className: "cls-14",
    d: "M735.506,690.14l25.377,3.356V679.818l-25.377,3.356Z",
    transform: "translate(-586.933 -383.886)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    className: "cls-15",
    cx: 12.299,
    cy: 17.014,
    rx: 12.299,
    ry: 17.014,
    transform: "translate(158.772 285.757)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    className: "cls-14",
    d: "M758,669.8a9.1,9.1,0,0,1,2.937.509c-5.371,1.825-9.362,8.512-9.362,16.505s3.991,14.682,9.362,16.505a9.074,9.074,0,0,1-2.937.509c-6.792,0-12.3-7.617-12.3-17.014S751.212,669.8,758,669.8Z",
    transform: "translate(-586.933 -384.04)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    className: "cls-14",
    d: "M759.129,737l-24.753-8.067L733.87,787.1,740,790.143s-5.392-16.181,15.817-20.747Z",
    transform: "translate(-586.933 -383.13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    className: "cls-15",
    d: "M740,789.53s-7.416-18.837,15.817-20.747c18.749,16.388,30.345,24.988,30.345,24.988S784.205,806.249,740,789.53Z",
    transform: "translate(-586.933 -382.517)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    className: "cls-12",
    d: "M784.739,792.439c.933.714,1.426,1.079,1.426,1.079S784.205,806,740,789.278a19,19,0,0,1-.966-4.081C767.727,795.786,779.886,794.436,784.739,792.439Z",
    transform: "translate(-586.933 -382.265)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    className: "cls-15",
    d: "M734.376,728.936,759.129,737l-1.041,10.186-23.812-6.778Z",
    transform: "translate(-586.933 -383.13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    className: "cls-14",
    d: "M740.135,599.519H713.561c-9.121,0-17.264-3.2-18.2-7.32a23.927,23.927,0,0,0,.553,5.582l22.537,63.99s2.569,2.594,4.949,2.594h6.9c2.379,0,4.949-2.594,4.949-2.594l22.537-63.99a23.924,23.924,0,0,0,.553-5.582C757.4,596.32,749.255,599.519,740.135,599.519Z",
    transform: "translate(-586.933 -385.234)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    className: "cls-14",
    d: "M740.135,600.512H713.561c-9.161,0-17.34-3.226-18.221-7.374l-4.4-49.4c-1.491-8.547,6.884-16.086,18.727-16.086h34.356c11.843,0,20.217,7.539,18.726,16.086l-4.4,49.4C757.475,597.286,749.295,600.512,740.135,600.512Z",
    transform: "translate(-586.933 -386.227)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    className: "cls-12",
    d: "M740.135,599.519H713.561c-9.121,0-17.264-3.2-18.2-7.32a23.927,23.927,0,0,0,.553,5.582l.411,1.271c2.571,3.182,9.55,5.458,17.239,5.458h26.574c7.688,0,14.668-2.276,17.239-5.458l.411-1.271a23.924,23.924,0,0,0,.553-5.582C757.4,596.32,749.255,599.519,740.135,599.519Z",
    transform: "translate(-586.933 -385.234)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    className: "cls-15",
    d: "M770.3,519.68c0,26.155-19.455,47.359-43.455,47.359s-43.456-21.2-43.456-47.359S702.848,486.8,726.848,486.8,770.3,493.526,770.3,519.68Z",
    transform: "translate(-586.933 -386.855)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    className: "cls-14",
    d: "M629.994,534.895c-7.36-.519-13.631,3.506-14.006,8.992s5.287,10.353,12.647,10.872,13.631-3.506,14.006-8.992S637.354,535.414,629.994,534.895Z",
    transform: "translate(-586.933 -386.116)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    className: "cls-12",
    d: "M609.918,522.071c3.614,7.11,9.412,19.06,12.034,22.843,4.445,6.412,19.627-1.96,20.986-2.715,2.126-1.182.085-5.481-7.014-17.053-11.827-19.28-24.078-44.625-30.689-40.949S600.175,502.9,609.918,522.071Z",
    transform: "translate(-586.933 -386.901)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    className: "cls-14",
    d: "M601.787,499.544,605.43,521l15.227-1.44,8.006-8.906-12.082-21.684Z",
    transform: "translate(-586.933 -386.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    className: "cls-14",
    d: "M792.472,565.73c0,7.491,4.39,13.564,9.8,13.564s9.8-6.073,9.8-13.564-4.389-13.565-9.8-13.565S792.472,558.238,792.472,565.73Z",
    transform: "translate(-586.933 -385.85)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    className: "cls-12",
    d: "M803.755,595.061c1.075-7.926,3.109-21.086,3.109-25.714,0-7.841-17.16-9.869-18.7-10.045-2.409-.275-3.177,4.433-3.932,18.045-1.258,22.678-5.607,50.563,1.883,51.42S800.855,616.431,803.755,595.061Z",
    transform: "translate(-586.933 -385.74)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    className: "cls-14",
    d: "M797.679,617.693l9.185-19.676L793.6,590.3,782,592.9l-2.412,24.793Z",
    transform: "translate(-586.933 -385.263)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    className: "cls-15",
    d: "M792.472,593.8l-10.8,2.424L782,592.9l11.6-2.6,13.268,7.722-1.528,3.274Z",
    transform: "translate(-586.933 -385.263)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    className: "cls-12",
    d: "M775.718,534.606c2.076,5.77,8.829,30.072,11.974,32.1,2.808,1.806,16.061,3.007,17.958,0,2.438-3.867,2.2-20.243-3.946-43.667-7.08-26.973-14.678-35.665-22.07-33.881S766.283,508.387,775.718,534.606Z",
    transform: "translate(-586.933 -386.823)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    className: "cls-14",
    d: "M784.547,568.383l23.4,2.676V560.154l-23.4,2.676Z",
    transform: "translate(-586.933 -385.727)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    className: "cls-14",
    d: "M770.994,626.379h0a2.768,2.768,0,0,1,.075-3.859l7.5-7.315a2.665,2.665,0,0,1,3.8.076h0a2.767,2.767,0,0,1-.075,3.859l-7.495,7.315A2.667,2.667,0,0,1,770.994,626.379Z",
    transform: "translate(-586.933 -384.892)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    className: "cls-14",
    d: "M777.337,633.021h0a2.674,2.674,0,0,1-3.653-1.065l-3.32-6.084a2.759,2.759,0,0,1,1.049-3.709h0a2.675,2.675,0,0,1,3.653,1.064l3.319,6.085A2.759,2.759,0,0,1,777.337,633.021Z",
    transform: "translate(-586.933 -384.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    className: "cls-15",
    d: "M791.738,644.949h0a2.694,2.694,0,0,0,3.253-2l2.285-9.406a2.741,2.741,0,0,0-1.966-3.3h0a2.694,2.694,0,0,0-3.253,2l-2.284,9.407A2.739,2.739,0,0,0,791.738,644.949Z",
    transform: "translate(-586.933 -384.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    className: "cls-15",
    d: "M785.594,644.836h0a2.692,2.692,0,0,0,3.252-2l1.666-6.86a2.739,2.739,0,0,0-1.966-3.3h0a2.693,2.693,0,0,0-3.252,2l-1.666,6.859A2.739,2.739,0,0,0,785.594,644.836Z",
    transform: "translate(-586.933 -384.612)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    className: "cls-15",
    d: "M773.83,641.7h0a2.74,2.74,0,0,1-1.966-3.3l2.489-10.248a2.693,2.693,0,0,1,3.253-2h0a2.74,2.74,0,0,1,1.966,3.3l-2.49,10.249A2.692,2.692,0,0,1,773.83,641.7Z",
    transform: "translate(-586.933 -384.713)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    className: "cls-15",
    d: "M779.3,644.444h0a2.74,2.74,0,0,1-1.965-3.3l1.666-6.86a2.692,2.692,0,0,1,3.252-2h0a2.739,2.739,0,0,1,1.966,3.3l-1.666,6.86A2.694,2.694,0,0,1,779.3,644.444Z",
    transform: "translate(-586.933 -384.618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_852",
    "data-name": "Path 852",
    className: "cls-15",
    d: "M3.152.087l17.4.062a3.129,3.129,0,0,1,3.093,3.134L23.7,20.063a3.076,3.076,0,0,1-3.071,3.113l-17.4-.062A3.13,3.13,0,0,1,.141,19.979L.082,3.2A3.076,3.076,0,0,1,3.152.087Z",
    transform: "matrix(-0.971, -0.239, 0.239, -0.971, 208.876, 255.234)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    className: "cls-15",
    d: "M619.587,515.751l7.453-8.292,1.622,2.912-8.006,8.906-15.227,1.44-.606-3.57Z",
    transform: "translate(-586.933 -386.538)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    className: "cls-12",
    d: "M651.446,504.934c-4.409,4.208-23.759,20.068-24.355,23.8-.532,3.331,3.592,16.177,7.061,16.765,4.459.755,19.2-5.9,37.989-20.854,21.64-17.216,26.524-27.728,22-33.927S671.478,485.816,651.446,504.934Z",
    transform: "translate(-586.933 -386.846)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    className: "cls-14",
    d: "M708.795,477.9s-45.2-13.057-55.886,23.437l43.2,15.162Z",
    transform: "translate(-586.933 -387.027)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    className: "cls-11",
    d: "M703.78,476.779,692.621,510.73l-38.3-13.444a42.735,42.735,0,0,0-1.408,4.037l43.2,15.162,12.687-38.6S706.893,477.337,703.78,476.779Z",
    transform: "translate(-586.933 -387.01)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    className: "cls-12",
    cx: 7.353,
    cy: 7.466,
    rx: 7.353,
    ry: 7.466,
    transform: "translate(101.822 122.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    className: "cls-11",
    d: "M700.821,515.956a4.713,4.713,0,1,1-4.713-4.785A4.749,4.749,0,0,1,700.821,515.956Z",
    transform: "translate(-586.933 -386.48)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    className: "cls-14",
    d: "M744.9,477.9s45.2-13.057,55.886,23.437l-43.2,15.162Z",
    transform: "translate(-586.933 -387.027)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    className: "cls-11",
    d: "M749.916,476.779l11.159,33.951,38.3-13.444c.516,1.276.991,2.615,1.408,4.037l-43.2,15.162-12.686-38.6S746.8,477.337,749.916,476.779Z",
    transform: "translate(-586.933 -387.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    className: "cls-12",
    d: "M750.234,516a7.354,7.354,0,1,0,7.353-7.466A7.41,7.41,0,0,0,750.234,516Z",
    transform: "translate(-586.933 -386.521)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    className: "cls-11",
    d: "M752.875,515.956a4.713,4.713,0,1,0,4.712-4.785A4.749,4.749,0,0,0,752.875,515.956Z",
    transform: "translate(-586.933 -386.48)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    className: "cls-14",
    d: "M632.453,518.819l-11.595,27.959,10.131,3.782,4.358-31.741Z",
    transform: "translate(-586.933 -386.363)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    className: "cls-14",
    d: "M620.965,477.512h0a2.751,2.751,0,0,1,1.485,3.553l-3.9,9.787a2.682,2.682,0,0,1-3.5,1.507h0a2.751,2.751,0,0,1-1.484-3.552l3.895-9.787A2.682,2.682,0,0,1,620.965,477.512Z",
    transform: "translate(-586.933 -387.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    className: "cls-14",
    d: "M622.209,469.923h0a2.735,2.735,0,0,1,2.124,3.2l-1.308,6.827a2.7,2.7,0,0,1-3.152,2.157h0a2.735,2.735,0,0,1-2.124-3.2l1.309-6.827A2.7,2.7,0,0,1,622.209,469.923Z",
    transform: "translate(-586.933 -387.116)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    className: "cls-15",
    d: "M588.644,467.871h0a2.751,2.751,0,0,0-1.528,3.534l5.667,14.767a2.682,2.682,0,0,0,3.479,1.552h0a2.751,2.751,0,0,0,1.528-3.534l-5.666-14.766A2.683,2.683,0,0,0,588.644,467.871Z",
    transform: "translate(-586.933 -387.149)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    className: "cls-15",
    d: "M592.932,462.395h0a2.751,2.751,0,0,0-1.528,3.534l5.508,14.351a2.683,2.683,0,0,0,3.479,1.552h0a2.751,2.751,0,0,0,1.529-3.534l-5.508-14.351A2.684,2.684,0,0,0,592.932,462.395Z",
    transform: "translate(-586.933 -387.234)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    className: "cls-15",
    d: "M604.852,459.356h0c1.377-.545,3.135.66,3.907,2.679l5.432,14.2c.773,2.02.278,4.117-1.1,4.664h0c-1.376.545-3.135-.66-3.907-2.68l-5.432-14.2C602.982,462,603.476,459.9,604.852,459.356Z",
    transform: "translate(-586.933 -387.28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    className: "cls-15",
    d: "M598.069,458.5h0a2.682,2.682,0,0,1,3.48,1.552l5.739,14.955a2.75,2.75,0,0,1-1.528,3.533h0a2.682,2.682,0,0,1-3.48-1.552l-5.739-14.955A2.749,2.749,0,0,1,598.069,458.5Z",
    transform: "translate(-586.933 -387.294)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_853",
    "data-name": "Path 853",
    className: "cls-15",
    d: "M3.069-.032l17.42-.09a3.064,3.064,0,0,1,3.069,3.1l-.086,16.76a3.142,3.142,0,0,1-3.1,3.136l-17.42.09a3.064,3.064,0,0,1-3.069-3.1L-.032,3.1A3.142,3.142,0,0,1,3.069-.032Z",
    transform: "translate(3.569 93.034) rotate(-21.288)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    className: "cls-11",
    d: "M734.617,630.7c-2.327-1.267-2.5-5.326-.385-7.821A103.961,103.961,0,0,0,754.8,584.5a105.014,105.014,0,0,0,3.215-43.571c-.445-3.261,1.869-6.576,4.5-6.358a139.479,139.479,0,0,1,27.159,5.037c43.148,13.712,74.587,45.783,84.932,81.892a5.632,5.632,0,0,1-1.424,1.871c-27.332,22.776-69.584,31.1-111.7,18.5A140.3,140.3,0,0,1,734.617,630.7Z",
    transform: "translate(-586.933 -386.121)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    className: "cls-16",
    d: "M747.882,624.827c-1.926-1.041-2.082-4.354-.342-6.383a83.727,83.727,0,0,0,16.868-31.252,84.582,84.582,0,0,0,2.519-35.546c-.378-2.663,1.523-5.36,3.7-5.174a116.948,116.948,0,0,1,22.444,4.2c35.678,11.329,61.741,37.6,70.4,67.1a4.539,4.539,0,0,1-1.17,1.522c-22.5,18.5-57.369,25.154-92.19,14.734A117.566,117.566,0,0,1,747.882,624.827Z",
    transform: "translate(-586.933 -385.937)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    className: "cls-12",
    d: "M767.371,555.491q4.178-4.224,8.35-8.453c-1.705-.224-3.405-.42-5.1-.565-2.174-.186-4.075,2.511-3.7,5.174C767.108,552.923,767.248,554.205,767.371,555.491Z",
    transform: "translate(-586.933 -385.937)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    className: "cls-12",
    d: "M796.912,551.929q-15.855,16.041-31.7,32.1c-.257,1.029-.507,2.058-.8,3.084a83.723,83.723,0,0,1-16.868,31.253c-1.544,1.8-1.588,4.6-.234,5.942l64.753-65.749A119.59,119.59,0,0,0,796.912,551.929Z",
    transform: "translate(-586.933 -385.853)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    className: "cls-12",
    d: "M851.255,591.9q-22.75,23.154-45.525,46.285a107.014,107.014,0,0,0,12.089-.961l37.8-38.386C854.275,596.482,852.827,594.163,851.255,591.9Z",
    transform: "translate(-586.933 -385.238)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    className: "cls-12",
    d: "M828.158,568.423,765.4,632.148c1.554.536,3.114,1.064,4.707,1.541a118.707,118.707,0,0,0,11.576,2.812q28.791-29.237,57.549-58.506A109.206,109.206,0,0,0,828.158,568.423Z",
    transform: "translate(-586.933 -385.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_854",
    "data-name": "Path 854",
    className: "cls-12",
    d: "M.9-.011,29.343-.177a.9.9,0,0,1,.9.908L30.222,4.09a.922.922,0,0,1-.91.919L.87,5.175a.9.9,0,0,1-.9-.908L-.011.908A.922.922,0,0,1,.9-.011Z",
    transform: "translate(88.273 225.214) rotate(-24.777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    className: "cls-18",
    d: "M727.96,500.1h0a13.842,13.842,0,0,1-13.7-13.906V471.006a13.842,13.842,0,0,1,13.7-13.906h0a13.842,13.842,0,0,1,13.7,13.906V486.2A13.842,13.842,0,0,1,727.96,500.1Z",
    transform: "translate(-586.933 -387.312)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    className: "cls-17",
    d: "M727.96,457.1c7.532,0,12.982,7.864,12.2,16.43l-1.3,14.3c-.553,6.107-5.44,10.659-10.908,10.659h0c-5.468,0-10.354-4.553-10.908-10.659l-1.3-14.3c-.776-8.566,4.673-16.43,12.205-16.43a13.842,13.842,0,0,0-13.7,13.906V486.2a13.842,13.842,0,0,0,13.7,13.906h0a13.842,13.842,0,0,0,13.7-13.906V471.006A13.842,13.842,0,0,0,727.96,457.1Z",
    transform: "translate(-586.933 -387.312)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    className: "cls-17",
    d: "M736.03,488.131a28.173,28.173,0,0,0,5.532-.567,14.066,14.066,0,0,0,.093-1.559V470.812c0-.378-.027-.748-.056-1.118a20.548,20.548,0,0,1-6.782,1.169H721.208a20.6,20.6,0,0,1-6.886-1.192c-.03.377-.057.755-.057,1.141v15.193a14.071,14.071,0,0,0,.091,1.546,28.155,28.155,0,0,0,5.646.579Z",
    transform: "translate(-586.933 -387.119)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    className: "cls-18",
    d: "M751.573,444.178s4.293-3.892,8.586-.934,2.759,17.9-8.586,17.123",
    transform: "translate(-586.933 -387.543)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    className: "cls-18",
    d: "M701.972,444.182s-4.292-3.892-8.585-.934-2.76,17.9,8.585,17.123",
    transform: "translate(-586.933 -387.542)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    className: "cls-18",
    d: "M756.5,415.739c-4.753-20.548-29.282-17.279-29.282-17.279s-24.53-3.27-29.282,17.279c0,0-3.147,25.941.532,38.705s19.835,26.987,28.75,26.987,25.07-14.221,28.75-26.987S756.5,415.739,756.5,415.739Z",
    transform: "translate(-586.933 -388.217)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    className: "cls-11",
    d: "M738.2,460.689c-.363-.4-4.842-.633-10.615-.633s-10.254.229-10.616.633c-.4.262,2.138,9.517,10.616,9.517S738.6,460.951,738.2,460.689Z",
    transform: "translate(-586.933 -387.267)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73",
    transform: "translate(131.441 70.606)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    className: "cls-19",
    d: "M736.789,466.935c-2.309,3.669-5.74,7.166-9.5,7.012-4.084-.154-7.092-3.478-8.913-6.648C721.559,464.465,729.991,461.251,736.789,466.935Z",
    transform: "translate(-718.374 -457.815)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    className: "cls-5",
    d: "M735.581,458.344c-.061,2.581-.637,2.581-.637,2.581-2.373,1.207-11.446,2.3-14.867,0-.362-.244-.427-1.463-.5-2.291a.881.881,0,0,1,.535-.237C725.782,458.053,733.013,457.516,735.581,458.344Z",
    transform: "translate(-718.374 -457.906)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    className: "cls-16",
    d: "M749.848,398.517c2.765,2.911.064,8.85-1.029,12.024a53.389,53.389,0,0,1-3.239,7.983,26.469,26.469,0,0,1-5.974,7.465,9.482,9.482,0,0,1-4.893,2.546.626.626,0,0,1-.841-.7,8.119,8.119,0,0,1,1.383-4.056,23.245,23.245,0,0,1-8.626,5,57.882,57.882,0,0,0,6.852-8.651,40.72,40.72,0,0,1-26.365,10.394,4.234,4.234,0,0,1,1.237-2.516l4.242-5.2q-3.75,2.224-7.374,4.661c-2.276,1.531-8.928,7.345-9.912,13.637-2.51-2.646-3.344-6.753-3.6-10.29A38.2,38.2,0,0,1,701,403.481a35.966,35.966,0,0,1,26.225-12.143C739.08,391.267,747.112,395.637,749.848,398.517Z",
    transform: "translate(-586.933 -388.324)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74",
    transform: "translate(148.745 42.646)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    className: "cls-11",
    d: "M754.357,436.826a12.182,12.182,0,0,0-4.5-3.854,18.392,18.392,0,0,0-5.361-2.225,14.209,14.209,0,0,0-4.811-.276c-1.3.186-4.067,1-4,2.731a.342.342,0,0,0,.426.329c.71-.2,1.178-.908,1.813-1.272a6.09,6.09,0,0,1,2.357-.715,13.849,13.849,0,0,1,4.294.281,20.971,20.971,0,0,1,9.576,5.166.136.136,0,0,0,.211-.166Z",
    transform: "translate(-735.679 -430.369)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    className: "cls-11",
    d: "M736.336,446.14c-.746-.186.2-4.186,5.235-4.971a10.477,10.477,0,0,1,5.178.455c1.046.4,3.586,1.709,4.36,3.828a11.249,11.249,0,0,0-7.9-2.416C739.128,443.137,737.081,446.325,736.336,446.14Z",
    transform: "translate(-586.933 -387.559)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    className: "cls-11",
    d: "M749.681,441.613a2.3,2.3,0,0,1-.1,1.033,2.5,2.5,0,0,1-.592.933l-.355-.5a1.887,1.887,0,0,0,.677-.576A2.2,2.2,0,0,0,749.681,441.613Z",
    transform: "translate(-586.933 -387.551)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    className: "cls-11",
    d: "M751.055,441.759a1.638,1.638,0,0,1-.191,1.468,3.133,3.133,0,0,1-1.11,1.1l-.245-.563a2.542,2.542,0,0,0,1.112-.722A1.505,1.505,0,0,0,751.055,441.759Z",
    transform: "translate(-586.933 -387.548)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    className: "cls-11",
    d: "M751.888,443.426a1.1,1.1,0,0,1-.336.948,2.139,2.139,0,0,1-.911.576l-.225-.6a1.982,1.982,0,0,0,.947-.215A.961.961,0,0,0,751.888,443.426Z",
    transform: "translate(-586.933 -387.523)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75",
    transform: "translate(113.129 42.646)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    className: "cls-11",
    d: "M700.294,436.991a20.949,20.949,0,0,1,9.575-5.166,14.168,14.168,0,0,1,4.183-.292,6.213,6.213,0,0,1,2.372.671c.675.368,1.17,1.119,1.91,1.327a.341.341,0,0,0,.425-.329c.065-1.689-2.616-2.517-3.89-2.714a14.011,14.011,0,0,0-4.921.259,18.244,18.244,0,0,0-5.242,2.156,12.339,12.339,0,0,0-4.623,3.923.136.136,0,0,0,.211.166Z",
    transform: "translate(-700.062 -430.369)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    className: "cls-11",
    d: "M718.1,446.14c.746-.186-.2-4.186-5.235-4.972a10.489,10.489,0,0,0-5.178.456c-1.047.4-3.586,1.709-4.36,3.828a11.246,11.246,0,0,1,7.9-2.416C715.311,443.137,717.359,446.325,718.1,446.14Z",
    transform: "translate(-586.933 -387.559)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    className: "cls-11",
    d: "M704.758,441.613a2.287,2.287,0,0,0,.1,1.033,2.49,2.49,0,0,0,.591.933l.356-.5a1.9,1.9,0,0,1-.678-.576A2.2,2.2,0,0,1,704.758,441.613Z",
    transform: "translate(-586.933 -387.551)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    className: "cls-11",
    d: "M703.385,441.759a1.636,1.636,0,0,0,.19,1.468,3.132,3.132,0,0,0,1.11,1.1l.245-.563a2.542,2.542,0,0,1-1.111-.722A1.5,1.5,0,0,1,703.385,441.759Z",
    transform: "translate(-586.933 -387.548)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    className: "cls-11",
    d: "M702.551,443.426a1.1,1.1,0,0,0,.336.948,2.139,2.139,0,0,0,.912.576l.224-.6a1.978,1.978,0,0,1-.946-.215A.963.963,0,0,1,702.551,443.426Z",
    transform: "translate(-586.933 -387.523)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    className: "cls-16",
    d: "M746.681,411.591c-1.159,6.343,2.5,18.945,4.374,18.719s1.144-3.4,1.787-6.151c.855,6.025.673,8.968,2.671,14.708a9.888,9.888,0,0,0,2.554,4.458c2.89-5.158,3.87-11.136,4.05-17,.252-8.207.565-19.715-6.766-25.1-2.271-1.669-3.538-1.409-6.3-.912",
    transform: "translate(-586.933 -388.192)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76",
    transform: "translate(169.662 16.373)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    className: "cls-20",
    d: "M756.642,405.076a49.285,49.285,0,0,1,4.86,16.292c.673,5.664.092,11.162-.712,16.769a.367.367,0,0,0,.706.2c1.919-5.468,2-11.684,1.261-17.378a44.973,44.973,0,0,0-5.458-16.271c-.244-.436-.88-.051-.657.39Z",
    transform: "translate(-756.595 -404.495)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77",
    transform: "translate(101.161 12.291)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    className: "cls-20",
    d: "M702.56,400.552a41.286,41.286,0,0,0-12.661,17.8c-2.4,6.806-2.722,14.783.981,21.185.2.336.792.113.642-.274a29.579,29.579,0,0,1-.486-20.781A41.529,41.529,0,0,1,703,401c.309-.27-.135-.707-.444-.451Z",
    transform: "translate(-688.095 -400.475)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78",
    transform: "translate(124.517 3.124)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    className: "cls-20",
    d: "M711.671,395.755a38.119,38.119,0,0,1,15.693-3.275,34.351,34.351,0,0,1,8.006,1.119c2.61.684,4.987,1.929,7.551,2.71.337.1.663-.392.363-.634-2.061-1.662-4.9-2.523-7.415-3.167a34.911,34.911,0,0,0-8.308-1.061,31.287,31.287,0,0,0-16.028,3.975c-.17.1-.055.414.138.332Z",
    transform: "translate(-711.45 -391.447)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79",
    transform: "translate(131.44 10.767)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    className: "cls-20",
    d: "M719.012,408.551a36.048,36.048,0,0,1,10.31-6.283,36.54,36.54,0,0,1,5.527-1.686c1.88-.414,3.8-.572,5.682-.941.373-.073.259-.619-.085-.641-3.954-.242-8.235,1.158-11.839,2.691a37.888,37.888,0,0,0-10.113,6.335c-.358.313.161.834.518.525Z",
    transform: "translate(-718.373 -398.973)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80",
    transform: "translate(157.821 9.875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    className: "cls-20",
    d: "M753.209,414.041a33.049,33.049,0,0,0-2.366-9.869c-1.1-2.351-3.075-5.4-5.735-6.069a.282.282,0,0,0-.269.469c.988.908,2.083,1.643,2.988,2.654a14.753,14.753,0,0,1,2.291,3.515,35.283,35.283,0,0,1,2.534,9.375c.053.317.6.247.557-.076Z",
    transform: "translate(-744.754 -398.095)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    className: "cls-17",
    d: "M732.71,451.723a3.34,3.34,0,0,1-3.254,2.735h-2.992a3.34,3.34,0,0,1-3.254-2.735h-.717a4.15,4.15,0,0,0,4.1,3.9h2.736a4.15,4.15,0,0,0,4.1-3.9Z",
    transform: "translate(-586.933 -387.395)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_114",
    "data-name": "Group 114",
    transform: "translate(-456.705 105.649)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_113",
    "data-name": "Group 113"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    className: "cls-21",
    d: "M463.942,571.753l-21.514-5.3-25.07-75.223h-4.033L388.4,405.488l-31.519-6.446-3.94,30.035-31.267-15.912-.3-4.62h.1l-1.091-16.729h.093l-1.092-16.725h.084l-1.1-17.015h.117l-2.42-37.153,11.48.074L341.175,288.9l-22.077.383-5.824-4.928-19.946-21.044q.9.014,1.846.014c20.613,0,28.6-3.728,32.224-7.092.774.277,1.539.566,2.243.852L344.812,235.2c-1.73-1.97-4.872-3.821-8.5-5.4l8.5-12.271c-4.994-5.679-21.705-10.378-28.125-10.378-7.437,0-11.391,3.84-13.224,6.472-.256,0-.517.008-.792.008a48.445,48.445,0,0,1-6.043-.377c-.35-.572-.732-1.133-1.142-1.678-5.753-7.563-16.608-10.95-24.815-10.95a28.577,28.577,0,0,0-9.339,1.508l-9.176,3.17v45.286l-30.484,36.647-4.751,3.839-24.255.424,8.673,12.216L180.86,320.369h38.2v11.923H218.8v17.3h-.746v17.579h-.247v17.011h-1.245v4.959l-90.6-2.855-.578-1.037-8.16.843-18.654-.46.685,2.324-20.819,2.163.364-7.463,14.319.31-28.6-83.729-.284-23.961,11.175.057L93.087,241.81l-30.811.438L50.2,235.424l-54.949-38.76V166.657a44.306,44.306,0,0,0,7.488.623c9.488,0,20.091-2.757,32.325-8.416.168.066.341.136.518.2a44.384,44.384,0,0,0,16.743,3.6,43.347,43.347,0,0,0,16.585-3.5l-4.826-15.6a49.19,49.19,0,0,0,6.089-2.075l-8.09-26.132a7.629,7.629,0,0,1-1.715.213c-2.155,0-4.262-1.311-7.526-3.451-4.015-2.631-9.008-5.906-15.7-5.906a19.447,19.447,0,0,0-6.117.987c-10.1,3.333-18.1,5.023-23.756,5.023-4.471,0-5.516-.845-7.6-2.531-2.616-2.114-6.994-5.652-13.876-5.652a20.95,20.95,0,0,0-6.732,1.148H-33.312v22.976l-.135.068v23.672l.117,44.338L-86,238.571l-10.99,5.927-17.508.251V220.629a70.871,70.871,0,0,0,14.124,1.114c20.609,0,28.59-3.726,32.213-7.092.779.277,1.544.568,2.248.855l15.186-21.875c-1.729-1.975-4.877-3.83-8.514-5.414l8.509-12.267c-4.989-5.681-21.7-10.382-28.129-10.382-7.437,0-11.391,3.837-13.228,6.472-.252,0-.513.007-.788.007a48.527,48.527,0,0,1-6.047-.376A19.49,19.49,0,0,0-100.067,170c-3.5-4.609-8.9-7.665-14.435-9.35V158.5h-28.562v5.18l-1.115.4,1.115,14.357v2.708l-1.129.373,1.129,14.594v52.62l-139.683-4.346V218.919a36.531,36.531,0,0,0,15.261,3.181,35.481,35.481,0,0,0,15.54-3.462c.952-.467,3.851-1.556,10.146-1.556a64,64,0,0,1,10.062.831l9.441-25.279a19.669,19.669,0,0,0-3.772-1.69l3.772-10.091c-5.176-3.172-18.324-5.12-25.472-5.12a34.012,34.012,0,0,0-10.025,1.311,15.818,15.818,0,0,1-4.1.435c-.242,0-.475,0-.7-.009-4.737-5.662-13.386-7.885-20.152-8.742V165.3H-311.31v88.559l-72.336,141.569,9.633,21.92,14.244-1.455v26.015l-1.655.109v45.409l.33-.022v31.214l-9.6,24.176-14.836-10.851-107.25,146.9,1005.633-.04ZM71.565,406.851l.634-.348-.527,1.956ZM-104.267,274.408l15.731.081.224.727v19.371H-89.8v21.468l-19.1-46.926Z",
    transform: "translate(492.775 -104.048)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_112",
    "data-name": "Group 112",
    transform: "translate(31.739 13.728)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83",
    transform: "translate(708.386 297.638)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    className: "cls-22",
    d: "M540.107,677.16l-32.924-76.437-13.266-3.269-7.144,3.269L460.6,522.19h-4.443l-25.473-87.645-9.344-1.909-6.116,46.614v51.406l-2.4,4.907-8.214-74.546-21.966-11.18-7.909,48-5.494,3.154,3.928,123.779-4.11,3.444L347.2,529.409l-20.306-8.256-13.516-4.62L300.3,676.525Z",
    transform: "translate(-300.303 -432.636)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109",
    transform: "translate(92.409)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    className: "cls-16",
    d: "M69.132,121.037c-49.28,16.256-39.911-8.193-53.859-1.215V135c6.66-12.705,8.624,14.389,51.95-6.786,6.342-3.1,13.892,8.72,31.759,1.316C83.635,133.04,77.024,118.434,69.132,121.037Z",
    transform: "translate(334.705 -118.535)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    className: "cls-12",
    d: "M67.778,139.686c-49.28,16.257-39.911-8.192-53.859-1.215v15.178c6.66-12.7,8.624,14.39,51.95-6.785,6.342-3.1,13.892,8.719,31.76,1.316C82.281,151.689,75.67,137.083,67.778,139.686Z",
    transform: "translate(334.796 -119.513)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    className: "cls-16",
    d: "M368.823,229.093c3.024,6.782-30.2,4.818-28.953,0s-11.452-10.773-19.913-7.85l1,12.953c5.225-5.669,16.15-4.764,13.687.851-2.07,4.723,41.221,3.691,38.249-2.266-4.147-8.318,16.094,0,16.094,0C387.487,231.078,366.251,223.33,368.823,229.093Z",
    transform: "translate(314.362 -123.878)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    className: "cls-12",
    d: "M368.823,247.742c3.024,6.783-30.2,4.818-28.953,0s-11.452-10.773-19.913-7.849l1,12.953c5.225-5.67,16.15-4.764,13.687.85-2.07,4.723,41.221,3.692,38.249-2.266-4.147-8.317,16.094,0,16.094,0C387.487,249.728,366.251,241.979,368.823,247.742Z",
    transform: "translate(314.362 -124.855)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    className: "cls-23",
    d: "M361.264,482.83H375.41l1.18,26.35-15.327,5.953Z",
    transform: "translate(311.604 -137.628)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    className: "cls-24",
    d: "M361.877,487.81l18.213-.563L360.7,423.766Z",
    transform: "translate(311.641 -134.533)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    className: "cls-25",
    d: "M351.231,312.3l-64.9,3.523-7.335,354.074h92.518Z",
    transform: "translate(317.097 -128.691)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    className: "cls-25",
    width: 6.72,
    height: 15.313,
    transform: "translate(598.729 280.145)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    className: "cls-25",
    width: 6.72,
    height: 15.309,
    transform: "translate(599.973 263.133)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    className: "cls-25",
    width: 6.72,
    height: 15.311,
    transform: "translate(600.224 245.555)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    className: "cls-25",
    width: 6.72,
    height: 15.313,
    transform: "translate(600.969 228.259)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    className: "cls-25",
    width: 6.723,
    height: 15.31,
    transform: "translate(601.217 203.879)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    className: "cls-23",
    d: "M353.251,312.3l-19.669,3.523L347.45,502.968,326.59,481.842,309.254,669.894h64.278Z",
    transform: "translate(315.077 -128.691)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    className: "cls-25",
    width: 6.222,
    height: 12.76,
    transform: "translate(648.009 224.292)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    className: "cls-25",
    width: 6.222,
    height: 12.755,
    transform: "translate(648.755 238.753)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    className: "cls-25",
    width: 6.222,
    height: 12.759,
    transform: "translate(653.234 298.575)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    className: "cls-25",
    width: 6.222,
    height: 12.761,
    transform: "translate(651.991 284.396)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    className: "cls-25",
    width: 6.225,
    height: 12.761,
    transform: "translate(651.74 269.371)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    className: "cls-25",
    width: 6.222,
    height: 12.759,
    transform: "translate(650.62 253.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    className: "cls-25",
    width: 6.222,
    height: 12.759,
    transform: "translate(653.609 312.608)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    className: "cls-25",
    width: 6.222,
    height: 12.755,
    transform: "translate(655.849 329.338)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    className: "cls-25",
    width: 6.225,
    height: 12.755,
    transform: "translate(656.842 345.214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    className: "cls-23",
    d: "M358.095,323.518h-7.466l.993,15.309h7.469Z",
    transform: "translate(312.314 -129.279)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    className: "cls-23",
    d: "M359.428,341.471h-7.466l.993,15.306h7.469Z",
    transform: "translate(312.225 -130.22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    className: "cls-23",
    d: "M360.495,359.42h-7.469l1,15.313h7.466Z",
    transform: "translate(312.154 -131.16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    className: "cls-23",
    d: "M361.559,377.073h-7.466l1,15.309h7.466Z",
    transform: "translate(312.083 -132.086)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    className: "cls-23",
    d: "M362.627,394.729h-7.466l.993,15.309h7.469Z",
    transform: "translate(312.011 -133.011)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    className: "cls-23",
    d: "M363.694,412.378h-7.469l1,15.313h7.465Z",
    transform: "translate(311.94 -133.936)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    className: "cls-23",
    d: "M364.758,430.034h-7.465l1,15.31h7.465Z",
    transform: "translate(311.869 -134.861)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    className: "cls-23",
    d: "M365.826,447.686H358.36l1,15.313h7.465Z",
    transform: "translate(311.798 -135.787)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    className: "cls-23",
    d: "M366.893,465.339h-7.465l1,15.31h7.465Z",
    transform: "translate(311.727 -136.712)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    className: "cls-23",
    d: "M367.961,482.995H360.5l.993,15.31h7.469Z",
    transform: "translate(311.655 -137.637)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    className: "cls-23",
    d: "M369.028,500.644h-7.469l1,15.309h7.465Z",
    transform: "translate(311.584 -138.562)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    className: "cls-23",
    d: "M370.092,518.3h-7.465l1,15.309h7.466Z",
    transform: "translate(311.513 -139.488)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    className: "cls-23",
    d: "M371.962,536.249h-7.469l2.229,15.279h7.465Z",
    transform: "translate(311.388 -140.428)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    className: "cls-23",
    d: "M374.468,553.866H367l2.226,15.283h7.469Z",
    transform: "translate(311.221 -141.352)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    className: "cls-23",
    d: "M376.975,571.489h-7.466l2.219,15.279H379.2Z",
    transform: "translate(311.053 -142.275)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    className: "cls-23",
    d: "M379.481,589.107h-7.469l2.226,15.275H381.7Z",
    transform: "translate(310.886 -143.199)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    className: "cls-23",
    d: "M381.987,606.723h-7.465l2.222,15.283h7.465Z",
    transform: "translate(310.719 -144.122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    className: "cls-23",
    d: "M384.49,624.34h-7.465l2.222,15.281h7.469Z",
    transform: "translate(310.552 -145.045)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    className: "cls-23",
    d: "M387,641.96h-7.465l2.226,15.283h7.466Z",
    transform: "translate(310.384 -145.969)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    className: "cls-23",
    d: "M389.5,659.579h-7.465l2.226,15.283h7.466Z",
    transform: "translate(310.217 -146.892)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    className: "cls-16",
    d: "M-55.033,185.211c3.023,6.782-30.2,4.818-28.955,0s-11.449-10.773-19.91-7.848l1,12.951c5.224-5.671,16.149-4.765,13.686.85C-91.286,195.888-48,194.854-50.97,188.9c-4.147-8.318,16.1,0,16.1,0C-36.368,187.2-57.605,179.446-55.033,185.211Z",
    transform: "translate(342.662 -121.578)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    className: "cls-12",
    d: "M-55.033,203.86c3.023,6.782-30.2,4.818-28.955,0s-11.449-10.773-19.91-7.847l1,12.951c5.224-5.672,16.149-4.766,13.686.85C-91.286,214.538-48,213.5-50.97,207.546c-4.147-8.317,16.1,0,16.1,0C-36.368,205.846-57.605,198.095-55.033,203.86Z",
    transform: "translate(342.662 -122.555)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84",
    transform: "translate(239.097 54.463)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    className: "cls-23",
    width: 1.493,
    height: 95.641
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    className: "cls-24",
    d: "M-75.777,383.443l17.92-2.839-44.466-109.245-14.934.753-17.754,23.437Z",
    transform: "translate(344.74 -126.545)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    className: "cls-11",
    d: "M-60.169,386.555l-6.268,10.362-.836-5.943,4.7-8.382Z",
    transform: "translate(340.217 -132.375)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    className: "cls-25",
    d: "M-334.061,668.848H-85.575l1.812-291.924-38.028-84.583-174.762,30.944-37.13,74.27-1.81,153.7L-347.264,562.6l-5.832,85.533A19.252,19.252,0,0,0-334.061,668.848Z",
    transform: "translate(359.304 -127.645)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    className: "cls-26",
    d: "M-337.15,576.136l-12.286,0-2.487,25.995,12.286,0Z",
    transform: "translate(359.223 -142.519)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    className: "cls-26",
    d: "M-325.585,603.465l-23.4,1.137-.447.38,24.64.848Z",
    transform: "translate(359.056 -143.951)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    className: "cls-26",
    d: "M-287.935,600l-23.394,1.132-.449.382,24.64.85Z",
    transform: "translate(356.542 -143.769)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    className: "cls-26",
    d: "M-260.212,618.12l-23.395,1.13-.447.384,24.638.849Z",
    transform: "translate(354.691 -144.719)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    className: "cls-26",
    d: "M-230.359,609.761l-23.4,1.135-.447.38,24.64.848Z",
    transform: "translate(352.698 -144.281)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    className: "cls-26",
    d: "M-200.831,602.486l-23.394,1.13-.447.384,24.64.85Z",
    transform: "translate(350.726 -143.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    className: "cls-26",
    d: "M-214.7,612.505l.306-19.491-.334-.362-.745,20.091Z",
    transform: "translate(350.112 -143.384)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    className: "cls-26",
    d: "M-244.422,610.412l.307-19.489-.334-.364-.747,20.1Z",
    transform: "translate(352.097 -143.275)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    className: "cls-26",
    d: "M-274.876,631.967l.308-19.491-.334-.364-.747,20.1Z",
    transform: "translate(354.13 -144.404)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    className: "cls-26",
    d: "M-304.931,609.392l.307-19.487-.336-.364-.746,20.1Z",
    transform: "translate(356.137 -143.221)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    className: "cls-26",
    d: "M-339.55,605.46h-12.286l-2.487,25.995h12.286Z",
    transform: "translate(359.383 -144.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    className: "cls-26",
    d: "M-341.416,634.484H-353.7l-2.489,25.993h12.286Z",
    transform: "translate(359.508 -145.577)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    className: "cls-26",
    d: "M-284.919,583.458l-6.639,100.648h15.68l2.738-38.841Z",
    transform: "translate(355.192 -142.903)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    className: "cls-26",
    d: "M-315.855,583.458l-6.637,100.648h15.68l2.736-38.841Z",
    transform: "translate(357.258 -142.903)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    className: "cls-26",
    d: "M-255.05,583.458l-6.639,100.648h15.68l2.738-38.841Z",
    transform: "translate(353.198 -142.903)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    className: "cls-26",
    d: "M-224.114,583.458l-6.639,100.648h15.68l2.738-38.841Z",
    transform: "translate(351.132 -142.903)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    className: "cls-26",
    d: "M-193.889,583.458l-6.639,100.648h23.811l.415-11.944Z",
    transform: "translate(349.114 -142.903)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    className: "cls-26",
    d: "M-182.336,577.922l-164.506-3.2,12-11.351,163.625-10.963Z",
    transform: "translate(358.883 -141.275)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    className: "cls-9",
    d: "M-178.642,417.982l-154.276,4.9.521-14.188,155.741-23.482Z",
    transform: "translate(357.954 -132.512)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85",
    transform: "translate(22.403 267.151)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    className: "cls-11",
    d: "M-335.739,412.493l5.342,8.086,5.681-.6-6.086-7.715Z",
    transform: "translate(335.739 -401.081)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    className: "cls-11",
    d: "M-321.422,411.291l5.346,8.09,5.68-.594-6.086-7.72Z",
    transform: "translate(334.783 -401.018)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    className: "cls-11",
    d: "M-306.387,410.114l5.342,8.088,5.683-.594-6.087-7.717Z",
    transform: "translate(333.779 -400.957)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    className: "cls-11",
    d: "M-291.353,408.934l5.344,8.088,5.681-.594-6.086-7.715Z",
    transform: "translate(332.775 -400.895)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    className: "cls-11",
    d: "M-276.317,407.759l5.342,8.09,5.68-.6-6.084-7.715Z",
    transform: "translate(331.771 -400.833)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    className: "cls-11",
    d: "M-261.284,406.579l5.342,8.09,5.681-.6-6.089-7.715Z",
    transform: "translate(330.767 -400.771)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    className: "cls-11",
    d: "M-246.252,405.4l5.346,8.09,5.679-.6-6.086-7.718Z",
    transform: "translate(329.764 -400.709)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    className: "cls-11",
    d: "M-231.216,404.224l5.342,8.086,5.683-.6L-226.279,404Z",
    transform: "translate(328.76 -400.648)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    className: "cls-11",
    d: "M-216.183,403.045l5.344,8.086,5.68-.594-6.084-7.716Z",
    transform: "translate(327.756 -400.586)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    className: "cls-11",
    d: "M-201.149,401.866l5.344,8.086,5.679-.594-6.086-7.716Z",
    transform: "translate(326.752 -400.524)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    className: "cls-11",
    d: "M-186.115,400.687l5.346,8.09,5.68-.594-6.088-7.72Z",
    transform: "translate(325.748 -400.462)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    className: "cls-23",
    d: "M-110.95,287.062l-59.727,50.892,6.948,204.187-10.219,23.39-.71,103.041H-40.594L-71.846,376.648Z",
    transform: "translate(347.387 -127.368)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86",
    transform: "translate(233.476 285.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    className: "cls-10",
    d: "M-109.565,465.328h14.91C-94.655,405.353-109.565,404.86-109.565,465.328Z",
    transform: "translate(109.565 -420.162)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    className: "cls-11",
    d: "M-109.565,465.642h11.239C-98.326,413.217-109.565,412.785-109.565,465.642Z",
    transform: "translate(109.565 -420.476)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    className: "cls-23",
    d: "M-63.171,383.858H-75.448l2.321,24.572H-60.85Z",
    transform: "translate(340.763 -132.441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    className: "cls-23",
    d: "M-58.9,412.185H-71.183l2.323,24.567h12.278Z",
    transform: "translate(340.478 -133.926)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    className: "cls-23",
    d: "M-55.7,440.506H-67.984l2.321,24.57h12.281Z",
    transform: "translate(340.264 -135.41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    className: "cls-9",
    d: "M-167.766,412.517l56.8-110.038,39.742,75.242-.291-3.919L-111.3,280.935l-58.734,100.929Z",
    transform: "translate(347.078 -127.047)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    className: "cls-24",
    d: "M-356.759,411.837l174.388-17.8,61.949-115.268L-359.745,405.033Z",
    transform: "translate(359.745 -126.933)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87",
    transform: "translate(70.853 61.265)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    className: "cls-23",
    width: 1.493,
    height: 85.435
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    className: "cls-27",
    d: "M-359.745,404.372-184.36,390.54l60.953-119.234-165.709-5.159Z",
    transform: "translate(359.745 -126.272)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    className: "cls-27",
    d: "M-359.745,404.372l236.338-133.066-165.709-5.159-32.5,63.6Z",
    transform: "translate(359.745 -126.272)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    className: "cls-9",
    d: "M25.616,492.247l-57.8-4.908,1.115-18.262-21.6,1.345L-56.646,481.2l-12.944-3.686,1.127-15.876-6.792-2.125-12.5,12.9-8.709-2.269-.5-15.595-7.026-2.181-7.162,11.537-5.722,213.333H34.379Z",
    transform: "translate(343.529 -136.032)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    className: "cls-9",
    d: "M19.752,492.128l-57.8-4.908,1.113-18.262-23.954-2.149-2.131,11.22-14.563-4.35,1.938-14.287-17.264-2.31-1.431,10.526-11.274-1.774,1.235-13.588-15.47-2.149-2.89,227.019H28.511Z",
    transform: "translate(343.92 -135.913)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    className: "cls-25",
    d: "M-38.769,679.269h70.6L23.076,494.28l-57.213,1.049-38.823-4.158Z",
    transform: "translate(340.597 -138.066)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    className: "cls-23",
    d: "M358.553,492.47l-8.275,29.985L323.731,490.7l-43.291-1.324-3.385,189.8h96.968a9.449,9.449,0,0,0,9.26-10.839Z",
    transform: "translate(317.226 -137.972)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    className: "cls-10",
    d: "M324.427,489.574h-3.021l.664,12.283h3.021Z",
    transform: "translate(314.265 -137.982)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    className: "cls-19",
    d: "M281.022,481.737l42.577-1,4.925,11.143-47.336.879Z",
    transform: "translate(316.962 -137.519)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    className: "cls-24",
    d: "M281.022,481.749l33.349-.787,14.154,10.926-47.336.879Z",
    transform: "translate(316.962 -137.531)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    className: "cls-9",
    d: "M158.18,502.713l-79.562,6.493L75.233,679.874H161Z",
    transform: "translate(330.702 -138.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    className: "cls-9",
    d: "M106.07,496.549l-16.765-.041,1.908,15.517,16.768.041Z",
    transform: "translate(329.762 -138.345)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    className: "cls-9",
    d: "M136.3,495.478l-16.768-.041,1.908,15.514,16.768.041Z",
    transform: "translate(327.744 -138.289)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    className: "cls-24",
    d: "M82.359,483.585l52.117-2.387,8.07,13.778L72.413,497.91Z",
    transform: "translate(330.89 -137.543)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    className: "cls-9",
    d: "M129.374,495.76l-29.7.753v1.7l29.7-.755Z",
    transform: "translate(329.07 -138.306)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    className: "cls-25",
    d: "M289.792,431.134h-158.6l-6.579,244.989H324.826Z",
    transform: "translate(327.405 -134.919)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    className: "cls-23",
    width: 27.629,
    height: 27.216,
    transform: "translate(469.061 325.51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    className: "cls-23",
    d: "M128.714,462.447l-4.1,215.317h11.073L152.111,463.58Z",
    transform: "translate(327.405 -136.56)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    className: "cls-9",
    d: "M299.229,431.134H168.3l-5.43,244.989H328.155Z",
    transform: "translate(324.85 -134.919)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    className: "cls-10",
    d: "M178.094,682.385H305.742s5.271-131.773-66.465-131.773C170.71,550.612,178.094,682.385,178.094,682.385Z",
    transform: "translate(323.849 -141.181)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    className: "cls-27",
    d: "M-116.022,438.022-5.439,464.58l-10.543,13.743-113.167-27.7Z",
    transform: "translate(344.348 -135.28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    className: "cls-24",
    d: "M-116.022,438.022l51.044,12.257,4.452,17.141-68.623-16.8Z",
    transform: "translate(344.348 -135.28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    className: "cls-24",
    d: "M-48.577,468.128-129.545,448.5v3.118l80.968,19.634Z",
    transform: "translate(344.375 -135.829)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    className: "cls-25",
    d: "M72,261.86H-40.937l-5.508,405.391H97.706Z",
    transform: "translate(338.826 -126.047)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    className: "cls-23",
    d: "M81.09,371.343l23.658,1.091-1.777,36.6-20.3,11.218Z",
    transform: "translate(330.311 -131.785)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    className: "cls-11",
    d: "M109.238,380.066H90.074l.247,10.206L107,386.019Z",
    transform: "translate(329.711 -132.242)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    className: "cls-19",
    d: "M81.851,378.034l30.477.649L82.915,292.57Z",
    transform: "translate(330.26 -127.657)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    className: "cls-25",
    d: "M-12.836,260.983l-28.212.831-5.4,405.391h28.694Z",
    transform: "translate(338.826 -126.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    className: "cls-23",
    d: "M80.364,259.391,41,261.653,57.826,667.121h50.043Z",
    transform: "translate(332.988 -125.918)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    className: "cls-23",
    d: "M-47,268.1l5.6,15.876L65.489,302.694l-5.971-46.5Z",
    transform: "translate(338.863 -125.75)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    className: "cls-23",
    d: "M284.717,313.721l1.4,16.233,60,28.07,1.964-46.615Z",
    transform: "translate(316.715 -128.644)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    className: "cls-11",
    d: "M-49.494,267.767l1.991,6.425H79.261l3.982-6.425Z",
    transform: "translate(339.03 -126.357)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    className: "cls-11",
    d: "M283.865,316.236l1.063,6.429H352.75l2.131-6.429Z",
    transform: "translate(316.772 -128.897)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88",
    transform: "translate(348.851 1.161)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    className: "cls-23",
    width: 1.495,
    height: 85.435,
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    transform: "translate(634.318 97.366)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    className: "cls-23",
    width: 1.12,
    height: 46.129,
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    className: "cls-16",
    d: "M-239.871,194.508c-7.286,2.233-20.342.558-18.822-2.6s-13.965-7.072-24.285-5.151l.083,7.451c6.376-3.722,22.524-1.561,17.827,1.6-3.474,2.341,10.626,8.189,21.25,2.98s28.537-1.862,28.537-1.862C-217.106,195.808-232.586,192.276-239.871,194.508Z",
    transform: "translate(354.619 -122.084)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    className: "cls-12",
    d: "M-239.871,206.941c-7.286,2.233-20.342.558-18.822-2.6s-13.965-7.072-24.285-5.151l.083,7.451c6.376-3.722,22.524-1.561,17.827,1.6-3.474,2.341,10.626,8.189,21.25,2.98s28.537-1.862,28.537-1.862C-217.106,208.241-232.586,204.709-239.871,206.941Z",
    transform: "translate(354.619 -122.736)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    className: "cls-27",
    d: "M-69.94,266.161H95.317l-24.053-13.6L8.513,208.3l-58.851,47.288Z",
    transform: "translate(340.395 -123.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    className: "cls-19",
    d: "M-20.489,266.189H98.619l-24.053-13.6L12.549,208.846C19.068,227.648,4.935,252.049-20.489,266.189Z",
    transform: "translate(337.093 -123.269)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    className: "cls-27",
    d: "M270.354,314.962h99.054l-14.419-12.2-37.613-39.7L282.1,305.477Z",
    transform: "translate(317.674 -126.111)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    className: "cls-19",
    d: "M299.993,314.987h71.394l-14.419-12.2L319.8,263.559C323.707,280.42,315.235,302.306,299.993,314.987Z",
    transform: "translate(315.695 -126.136)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    className: "cls-11",
    d: "M309.2,463.245H119.051l9,12.857,173.415-1.076Z",
    transform: "translate(327.776 -136.602)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    className: "cls-11",
    d: "M312.461,463.245H173.42L167.912,476.1l137.038.813Z",
    transform: "translate(324.514 -136.602)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    className: "cls-24",
    d: "M174.415,464.522l142.811-2.4L300.981,420.53l-73.965-2.287-66.535-2.057Z",
    transform: "translate(325.01 -134.136)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    className: "cls-11",
    d: "M187.77,683.112H297.338s4.526-118.626-57.048-118.626C181.435,564.486,187.77,683.112,187.77,683.112Z",
    transform: "translate(323.201 -141.908)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    className: "cls-22",
    d: "M195.681,684.768h60.348s2.491-88.676-31.42-88.676C192.19,596.092,195.681,684.768,195.681,684.768Z",
    transform: "translate(322.667 -143.565)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90",
    transform: "translate(513.984 450.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    className: "cls-11",
    d: "M252.539,676.168V662.33h5.571c-.038-.661-.077-1.342-.12-2.031h-5.451v-13.84h4.141q-.127-1.011-.269-2.03h-3.872V630.586h1.353c-.159-.68-.322-1.352-.491-2.027h-.862v-3.244q-.694-2.468-1.5-4.846v8.09h-9.3v-13.84h7.1c-.293-.689-.6-1.368-.915-2.034h-6.189V602.8q-.727-.854-1.5-1.644v11.533h-9.3V598.846h6.752a23.676,23.676,0,0,0-3-2.03h-3.753v-1.661c-.495-.171-.993-.313-1.5-.445v2.106h-9.3V594.4c-.512.095-1.007.213-1.5.342v2.076h-4.893a21.865,21.865,0,0,0-2.837,2.03h7.73v13.839h-9.3V600.29c-.516.506-1.017,1.035-1.5,1.593v10.8H201.32c-.287.666-.572,1.342-.845,2.031h7.363v13.841h-9.3v-8.337c-.544,1.734-1.042,3.514-1.5,5.32v3.017h-.725c-.148.673-.3,1.35-.438,2.031h1.163v13.842h-3.375c-.081.68-.156,1.356-.23,2.028h3.6V660.3h-4.661c-.028.689-.06,1.366-.081,2.027h4.742v13.842h-4.9c.014.836.032,1.516.049,2.027h4.855v1.094h1.5V678.2h9.3v1.094h1.5V678.2h9.3v1.094h1.5V678.2l9.3,0v1.091h1.5V678.2h9.3v1.091h1.5V678.2h9.3v1.091h1.5V678.2h5.925c.007-.51.018-1.195.018-2.031Zm-1.5-15.869h-9.3v-13.84h9.3Zm-41.7-13.842h9.3V660.3h-9.3Zm0-15.87h9.3v13.842h-9.3Zm10.8-15.871,9.3,0v13.84l-9.3,0Zm20.1,29.714h-9.3V630.586h9.3Zm-10.8-13.842v13.842h-9.3V630.586Zm-9.3,15.87,9.3,0V660.3h-9.3Zm10.8,0h9.3V660.3h-9.3Zm20.1-15.872v13.842h-9.3V630.586Zm-10.8-15.867v13.84h-9.3v-13.84Zm-20.1-15.873h9.3v13.839h-9.3Zm-10.8,15.869h9.3v13.841h-9.3Zm-10.8,15.871h9.3v13.842h-9.3Zm0,15.87h9.3V660.3h-9.3Zm0,29.712V662.326h9.3v13.842Zm10.8,0V662.326h9.3v13.842Zm10.8,0V662.326l9.3,0v13.839Zm10.8,0V662.33h9.3v13.839Zm10.8,0V662.33h9.3v13.839Z",
    transform: "translate(-191.088 -593.589)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    className: "cls-11",
    d: "M223.919,593.544c-35.946,0-32.073,86.149-32.073,86.149h2.246c-.275-9.591-1.388-83.208,29.922-83.208,32.755,0,32.635,73.62,32.483,83.208h2.265S261.525,593.544,223.919,593.544Z",
    transform: "translate(-191.061 -593.544)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    className: "cls-11",
    d: "M191.013,683.849h3.622l-1.813,3.706Z",
    transform: "translate(-191.013 -598.277)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    className: "cls-11",
    d: "M196.094,683.849h3.625l-1.809,3.706Z",
    transform: "translate(-191.352 -598.277)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    className: "cls-11",
    d: "M207.743,683.849h3.625l-1.813,3.706Z",
    transform: "translate(-192.13 -598.277)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    className: "cls-11",
    d: "M219.392,683.849h3.622l-1.813,3.706Z",
    transform: "translate(-192.908 -598.277)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    className: "cls-11",
    d: "M231.037,683.849h3.625l-1.812,3.706Z",
    transform: "translate(-193.685 -598.277)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    className: "cls-11",
    d: "M242.687,683.849h3.622l-1.813,3.706Z",
    transform: "translate(-194.463 -598.277)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    className: "cls-11",
    d: "M254.332,683.849h3.625l-1.812,3.706Z",
    transform: "translate(-195.241 -598.277)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    className: "cls-11",
    d: "M260.249,683.849h3.621l-1.809,3.706Z",
    transform: "translate(-195.636 -598.277)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    className: "cls-22",
    d: "M243.081,564.486a37.709,37.709,0,0,0-13.7,2.516c46.422,16.987,42.673,116.11,42.673,116.11h28.073S304.656,564.486,243.081,564.486Z",
    transform: "translate(320.409 -141.908)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    className: "cls-19",
    d: "M178.394,464.522h-62.72l12.108-45.137,30.812-3.2Z",
    transform: "translate(328.002 -134.136)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    className: "cls-23",
    d: "M56.195,434.328-7.3,430.852l7.245,30.129L47.9,470.622Z",
    transform: "translate(336.212 -134.904)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91",
    transform: "translate(346.279 254.062)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    className: "cls-10",
    d: "M11.309,430.882H39.517C39.517,372.145,11.309,371.667,11.309,430.882Z",
    transform: "translate(-11.309 -386.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    className: "cls-22",
    d: "M15.844,428.324H35.591C35.591,380.133,15.844,379.739,15.844,428.324Z",
    transform: "translate(-11.612 -386.932)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    className: "cls-27",
    d: "M180.6,464.65H148.744l.5-45.137,12.5-.9Z",
    transform: "translate(325.794 -134.263)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    className: "cls-19",
    width: 66.037,
    height: 3.399,
    transform: "translate(442.185 327.402)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    className: "cls-19",
    width: 139.374,
    height: 3.401,
    transform: "translate(504.901 327.402)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92",
    transform: "translate(517.51 352.348)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    className: "cls-10",
    d: "M194.791,511.921h6.837C201.628,483.306,194.791,483.071,194.791,511.921Z",
    transform: "translate(-194.791 -490.371)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    className: "cls-11",
    d: "M194.791,512.235h3.42C198.211,491.148,194.791,490.976,194.791,512.235Z",
    transform: "translate(-194.791 -490.685)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    transform: "translate(464.249 352.348)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    className: "cls-10",
    d: "M144.556,511.921h-6.837C137.719,483.306,144.556,483.071,144.556,511.921Z",
    transform: "translate(-137.719 -490.371)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    className: "cls-11",
    d: "M144.8,512.235h-3.42C141.38,491.148,144.8,490.976,144.8,512.235Z",
    transform: "translate(-137.963 -490.685)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94",
    transform: "translate(545.376 352.348)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    className: "cls-10",
    d: "M224.651,511.921h6.836C231.487,483.306,224.651,483.071,224.651,511.921Z",
    transform: "translate(-224.651 -490.371)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    className: "cls-11",
    d: "M224.651,512.235h3.417C228.068,491.148,224.651,490.976,224.651,512.235Z",
    transform: "translate(-224.651 -490.685)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95",
    transform: "translate(573.238 352.348)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    className: "cls-10",
    d: "M254.506,511.921h6.837C261.343,483.306,254.506,483.071,254.506,511.921Z",
    transform: "translate(-254.506 -490.371)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    className: "cls-11",
    d: "M254.506,512.235h3.423C257.929,491.148,254.506,490.976,254.506,512.235Z",
    transform: "translate(-254.506 -490.685)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96",
    transform: "translate(601.103 352.348)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    className: "cls-10",
    d: "M284.365,511.921H291.2C291.2,483.306,284.365,483.071,284.365,511.921Z",
    transform: "translate(-284.365 -490.371)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    className: "cls-11",
    d: "M284.365,512.235h3.417C287.782,491.148,284.365,490.976,284.365,512.235Z",
    transform: "translate(-284.365 -490.685)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    className: "cls-26",
    d: "M-204.445,684.064H-220.7l12.189-92.537,7.218-8.872h6.722Z",
    transform: "translate(350.461 -142.861)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    className: "cls-26",
    d: "M-235.024,684.064h-16.259l12.189-92.537,7.22-8.872,6.229.6Z",
    transform: "translate(352.503 -142.861)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    className: "cls-26",
    d: "M-265.6,684.064h-16.258l12.189-92.537,7.22-8.872h6.72Z",
    transform: "translate(354.545 -142.861)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    className: "cls-26",
    d: "M-296.183,684.064h-16.259l12.189-92.537,7.22-8.872h6.72Z",
    transform: "translate(356.587 -142.861)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    className: "cls-26",
    d: "M-346.159,645.621l-.127-14.847-.2-.276-.117,15.309Z",
    transform: "translate(358.867 -145.368)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    className: "cls-26",
    d: "M-350.184,634.648l18.552.543.341-.718-18.98-.421Z",
    transform: "translate(359.112 -145.554)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    className: "cls-26",
    d: "M-326.762,684.064h-16.259l12.189-92.537,7.22-8.872h6.718Z",
    transform: "translate(358.628 -142.861)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    className: "cls-23",
    d: "M-197.243,684.064H-213.5l12.189-92.537,7.22-8.872Z",
    transform: "translate(349.98 -142.861)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    className: "cls-23",
    d: "M-227.823,684.064h-16.259l12.189-92.537,7.22-8.872Z",
    transform: "translate(352.022 -142.861)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    className: "cls-23",
    d: "M-258.4,684.064h-16.258l12.189-92.537,7.22-8.872Z",
    transform: "translate(354.064 -142.861)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    className: "cls-23",
    d: "M-288.982,684.064h-16.259l12.189-92.537,7.22-8.872Z",
    transform: "translate(356.106 -142.861)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    className: "cls-23",
    d: "M-319.563,684.064h-16.259l12.191-92.537,7.218-8.872Z",
    transform: "translate(358.148 -142.861)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    className: "cls-9",
    d: "M184.834,472.621h-6.3l-1.162,7.561h6.307Z",
    transform: "translate(323.882 -137.093)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    className: "cls-23",
    d: "M131.143,472.621h4.9l.9,7.561h-4.9Z",
    transform: "translate(326.969 -137.093)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    className: "cls-23",
    d: "M157.633,472.621h4.9l.9,7.561h-4.907Z",
    transform: "translate(325.2 -137.093)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    className: "cls-23",
    d: "M141.808,472.621h4.9l.9,7.561h-4.907Z",
    transform: "translate(326.257 -137.093)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    className: "cls-9",
    d: "M200.477,472.621h-6.3l-1.162,7.561h6.307Z",
    transform: "translate(322.838 -137.093)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    className: "cls-9",
    d: "M216.125,472.621h-6.3l-1.162,7.561h6.3Z",
    transform: "translate(321.793 -137.093)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    className: "cls-9",
    d: "M231.771,472.621h-6.307l-1.159,7.561h6.3Z",
    transform: "translate(320.748 -137.093)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    className: "cls-9",
    d: "M247.415,472.621h-6.307l-1.159,7.561h6.3Z",
    transform: "translate(319.704 -137.093)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    className: "cls-9",
    d: "M263.058,472.621h-6.3l-1.162,7.561h6.3Z",
    transform: "translate(318.659 -137.093)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    className: "cls-9",
    d: "M278.7,472.621h-6.3l-1.162,7.561h6.3Z",
    transform: "translate(317.615 -137.093)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    className: "cls-9",
    d: "M294.348,472.621h-6.3l-1.162,7.561h6.307Z",
    transform: "translate(316.57 -137.093)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_376",
    "data-name": "Path 376",
    className: "cls-9",
    d: "M309.992,472.621h-6.3l-1.159,7.561h6.3Z",
    transform: "translate(315.526 -137.093)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    className: "cls-27",
    d: "M149.894,421.085l12.278-1.891,138.013,1.334L161.84,416.172l-13.274,1.51Z",
    transform: "translate(325.806 -134.135)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    className: "cls-22",
    d: "M272.489,575.21l7.466-9.638-4.233,11.338Z",
    transform: "translate(317.531 -141.965)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    className: "cls-22",
    d: "M258.769,568.5l5.971-10.91-2.533,11.982Z",
    transform: "translate(318.447 -141.547)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    className: "cls-22",
    d: "M243.777,566.052l1.731-12.708,1.774,12.131Z",
    transform: "translate(319.448 -141.324)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    className: "cls-22",
    d: "M284.142,589.637l10.444-4.87-8.207,8.029Z",
    transform: "translate(316.753 -142.971)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    className: "cls-22",
    d: "M293.042,608.534l11.186-.761-9.984,4.578Z",
    transform: "translate(316.159 -144.177)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    className: "cls-22",
    d: "M299.5,637.674l11.154,1.365-10.543,2.612Z",
    transform: "translate(315.728 -145.744)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    className: "cls-22",
    d: "M302.871,664.747l10.175,1.518-9.536,2.2Z",
    transform: "translate(315.503 -147.163)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    className: "cls-11",
    d: "M193.863,676.244l-11.285.091,10.239-3.973Z",
    transform: "translate(323.535 -147.562)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    className: "cls-11",
    d: "M191.839,655.192l-10.631-4.041,10.765-.012Z",
    transform: "translate(323.626 -146.45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    className: "cls-11",
    d: "M195.552,625.379l-9.9-6,10.635,2.045Z",
    transform: "translate(323.33 -144.785)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    className: "cls-11",
    d: "M201.477,598.861l-8.949-5.726,9.575,2Z",
    transform: "translate(322.87 -143.41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    className: "cls-11",
    d: "M214.049,578.919l-4.406-10.551,6.787,7.9Z",
    transform: "translate(321.727 -142.112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    className: "cls-11",
    d: "M228.4,569.97l-.632-11.663,3.689,10.2Z",
    transform: "translate(320.517 -141.584)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    className: "cls-25",
    width: 8.296,
    height: 19.091,
    transform: "translate(482.999 522.113)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    className: "cls-25",
    width: 8.292,
    height: 19.091,
    transform: "translate(482.339 498.079)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    className: "cls-25",
    width: 8.299,
    height: 19.089,
    transform: "translate(482.003 460.464)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    className: "cls-9",
    width: 8.296,
    height: 19.089,
    transform: "translate(487.645 441.376)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    className: "cls-25",
    width: 8.296,
    height: 19.089,
    transform: "translate(483.663 421.718)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    className: "cls-25",
    width: 8.296,
    height: 19.091,
    transform: "translate(483.497 401.494)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    className: "cls-9",
    d: "M317.856,488.978h-8.3l2.24,18.992h8.3Z",
    transform: "translate(315.056 -137.951)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    className: "cls-9",
    d: "M321.32,509.623h-8.3l2.24,18.994h8.292Z",
    transform: "translate(314.825 -139.033)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    className: "cls-9",
    d: "M323.186,530.568h-8.3l2.236,18.994h8.3Z",
    transform: "translate(314.7 -140.131)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    className: "cls-9",
    d: "M325.587,552.407h-8.3l2.236,19h8.3Z",
    transform: "translate(314.54 -141.275)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    className: "cls-9",
    d: "M329.853,573.352h-8.3l2.24,18.994h8.3Z",
    transform: "translate(314.255 -142.373)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    className: "cls-9",
    d: "M330.921,594.6h-8.3l2.237,18.99h8.3Z",
    transform: "translate(314.184 -143.486)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    className: "cls-9",
    d: "M336.255,615.542h-8.3l2.236,18.992h8.3Z",
    transform: "translate(313.828 -144.584)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    className: "cls-9",
    d: "M337.054,636.784h-8.3l2.236,18.99h8.3Z",
    transform: "translate(313.774 -145.697)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    className: "cls-9",
    d: "M342.388,657.429h-8.3l2.236,18.994h8.3Z",
    transform: "translate(313.418 -146.78)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    className: "cls-9",
    d: "M341.855,678.007h-8.3l2.236,11.055h8.3Z",
    transform: "translate(313.454 -147.858)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    className: "cls-9",
    width: 8.296,
    height: 19.089,
    transform: "translate(488.808 381.648)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    className: "cls-9",
    width: 8.296,
    height: 19.092,
    transform: "translate(489.97 361.987)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    className: "cls-9",
    width: 8.299,
    height: 19.091,
    transform: "translate(487.811 479.367)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    className: "cls-23",
    width: 8.296,
    height: 19.091,
    transform: "translate(449.735 522.113)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    className: "cls-23",
    width: 8.299,
    height: 19.094,
    transform: "translate(450.728 500.344)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    className: "cls-23",
    width: 8.296,
    height: 19.089,
    transform: "translate(449.982 480.122)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    className: "cls-23",
    width: 8.299,
    height: 19.089,
    transform: "translate(451.226 460.274)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    className: "cls-23",
    width: 8.299,
    height: 19.089,
    transform: "translate(451.226 439.293)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    className: "cls-23",
    width: 8.299,
    height: 19.091,
    transform: "translate(452.968 419.445)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    className: "cls-23",
    width: 8.299,
    height: 19.089,
    transform: "translate(451.724 399.033)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    className: "cls-23",
    width: 8.299,
    height: 16.063,
    transform: "translate(452.968 381.363)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    className: "cls-23",
    width: 8.299,
    height: 17.198,
    transform: "translate(451.724 362.649)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    className: "cls-23",
    width: 8.296,
    height: 17.198,
    transform: "translate(452.721 342.803)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    className: "cls-23",
    d: "M156.956,562.382H137.545l.495,1.887,19.082-.753Z",
    transform: "translate(326.541 -141.798)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    className: "cls-23",
    d: "M152.333,602.872H132.923l.495,1.889,19.079-.753Z",
    transform: "translate(326.85 -143.92)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    className: "cls-23",
    d: "M150.38,644.362H130.965l.5,1.887,19.082-.753Z",
    transform: "translate(326.981 -146.095)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    className: "cls-23",
    d: "M158.833,497.671H145.015l.353,1.885,13.581-.755Z",
    transform: "translate(326.043 -138.406)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    className: "cls-9",
    d: "M169.5,520.109H155.683l.353,1.885,13.581-.752Z",
    transform: "translate(325.33 -139.582)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    className: "cls-25",
    d: "M-5.6,501.065h-18.24l.468,2.49,17.927-1Z",
    transform: "translate(337.317 -138.584)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    className: "cls-23",
    d: "M54.492,507.926H36.254l.466,2.49,17.93-.994Z",
    transform: "translate(333.305 -138.944)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    className: "cls-23",
    d: "M52.712,377.874H34.475l.463,2.488,17.93-.994Z",
    transform: "translate(333.423 -132.128)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    className: "cls-23",
    d: "M65.509,613.109H47.271l.466,2.49,17.93-1Z",
    transform: "translate(332.569 -144.457)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    className: "cls-25",
    d: "M-4.886,347.678H-23.124l.468,2.49,17.929-1Z",
    transform: "translate(337.269 -130.545)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    className: "cls-25",
    d: "M-6.665,611.249H-24.9l.465,2.493,17.93-1Z",
    transform: "translate(337.388 -144.359)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    className: "cls-23",
    d: "M23.053,639.773H-16.368l1.009,2.49,38.751-1Z",
    transform: "translate(336.818 -145.854)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    className: "cls-9",
    d: "M-95.358,602.074h-39.421l1.01,2.49,38.751-1Z",
    transform: "translate(344.724 -143.878)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    className: "cls-9",
    d: "M-115.173,544.029h-18.538l.475,2.49,18.222-1Z",
    transform: "translate(344.653 -140.836)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    className: "cls-25",
    d: "M-25.509,424.55H-43.747l.466,2.49,17.929-1Z",
    transform: "translate(338.646 -134.574)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    className: "cls-9",
    d: "M168.7,583.523H154.881l.357,1.889,13.581-.753Z",
    transform: "translate(325.384 -142.906)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    className: "cls-9",
    d: "M173.674,541.437H159.859l.353,1.889,13.581-.757Z",
    transform: "translate(325.052 -140.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    className: "cls-25",
    width: 18.914,
    height: 31.754,
    transform: "translate(286.882 509.449)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    "data-name": "Rectangle 61",
    className: "cls-25",
    width: 18.915,
    height: 31.754,
    transform: "translate(290.366 473.349)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    "data-name": "Rectangle 62",
    className: "cls-25",
    width: 18.916,
    height: 31.754,
    transform: "translate(287.877 436.647)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    "data-name": "Rectangle 63",
    className: "cls-9",
    width: 12.279,
    height: 23.44,
    transform: "translate(221.508 331.935)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_64",
    "data-name": "Rectangle 64",
    className: "cls-9",
    width: 12.279,
    height: 23.442,
    transform: "translate(221.508 356.884)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65",
    "data-name": "Rectangle 65",
    className: "cls-9",
    width: 12.279,
    height: 23.437,
    transform: "translate(218.52 383.725)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_66",
    "data-name": "Rectangle 66",
    className: "cls-23",
    width: 12.279,
    height: 23.439,
    transform: "translate(212.214 404.891)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_67",
    "data-name": "Rectangle 67",
    className: "cls-25",
    width: 12.279,
    height: 24.947,
    transform: "translate(174.712 387.126)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_68",
    "data-name": "Rectangle 68",
    className: "cls-25",
    width: 12.279,
    height: 24.947,
    transform: "translate(173.715 360.663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    className: "cls-26",
    d: "M-324.17,537.04l-12.286,1.137v24.949l12.286-1.135Z",
    transform: "translate(358.19 -140.47)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    className: "cls-26",
    d: "M-324.88,515.72l-12.288.814V534.41l12.288-.814Z",
    transform: "translate(358.237 -139.352)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    className: "cls-26",
    d: "M-322.746,494.574l-12.288.814v17.878l12.288-.816Z",
    transform: "translate(358.095 -138.244)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    className: "cls-26",
    d: "M-325.235,473.431l-12.286.816v17.876l12.286-.814Z",
    transform: "translate(358.261 -137.136)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    className: "cls-26",
    d: "M-323.1,453.086l-12.286.814v17.878l12.286-.816Z",
    transform: "translate(358.119 -136.07)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    className: "cls-26",
    d: "M-323.46,431.145l-12.286.814v17.878l12.286-.816Z",
    transform: "translate(358.143 -134.92)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_69",
    "data-name": "Rectangle 69",
    className: "cls-25",
    width: 12.279,
    height: 23.056,
    transform: "translate(169.734 286.193)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70",
    "data-name": "Rectangle 70",
    className: "cls-25",
    width: 12.279,
    height: 24.947,
    transform: "translate(170.73 312.276)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71",
    "data-name": "Rectangle 71",
    className: "cls-25",
    width: 12.279,
    height: 19.656,
    transform: "translate(172.721 339.115)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72",
    "data-name": "Rectangle 72",
    className: "cls-23",
    width: 19.411,
    height: 23.439,
    transform: "translate(206.743 435.51)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_73",
    "data-name": "Rectangle 73",
    className: "cls-9",
    width: 10.205,
    height: 22.588,
    transform: "translate(217.692 419.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_74",
    "data-name": "Rectangle 74",
    className: "cls-9",
    width: 12.279,
    height: 23.44,
    transform: "translate(217.36 460.084)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_75",
    "data-name": "Rectangle 75",
    className: "cls-9",
    width: 12.277,
    height: 23.44,
    transform: "translate(218.854 485.602)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_76",
    "data-name": "Rectangle 76",
    className: "cls-23",
    width: 9.626,
    height: 21.928,
    transform: "translate(213.542 363.686)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77",
    "data-name": "Rectangle 77",
    className: "cls-25",
    width: 20.245,
    height: 31.754,
    transform: "translate(373.823 437.401)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78",
    "data-name": "Rectangle 78",
    className: "cls-25",
    width: 20.243,
    height: 31.758,
    transform: "translate(309.116 364.819)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_79",
    "data-name": "Rectangle 79",
    className: "cls-25",
    width: 20.246,
    height: 31.756,
    transform: "translate(308.784 314.921)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_80",
    "data-name": "Rectangle 80",
    className: "cls-25",
    width: 20.245,
    height: 31.754,
    transform: "translate(306.459 412.454)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_81",
    "data-name": "Rectangle 81",
    className: "cls-25",
    width: 20.246,
    height: 31.754,
    transform: "translate(307.122 497.132)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_82",
    "data-name": "Rectangle 82",
    className: "cls-23",
    width: 20.245,
    height: 31.754,
    transform: "translate(382.783 497.699)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_83",
    "data-name": "Rectangle 83",
    className: "cls-25",
    width: 20.243,
    height: 31.754,
    transform: "translate(309.114 250.283)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84",
    "data-name": "Rectangle 84",
    className: "cls-25",
    width: 20.245,
    height: 31.753,
    transform: "translate(361.213 177.321)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_85",
    "data-name": "Rectangle 85",
    className: "cls-25",
    width: 16.924,
    height: 27.975,
    transform: "translate(363.87 218.525)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    className: "cls-23",
    d: "M88.748,289.608l-12.606.194.29,24.757,12.606-.194Z",
    transform: "translate(330.641 -127.501)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    className: "cls-23",
    d: "M90.081,327.308l-12.606.19,2.031,25.894,12.606-.194Z",
    transform: "translate(330.552 -129.477)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    className: "cls-23",
    d: "M92.211,359.745l-10.928.178,1.689,19.248,10.931-.183Z",
    transform: "translate(330.298 -131.177)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    className: "cls-23",
    d: "M96.748,422.324l-8,.133,1.268,19.229,8-.136Z",
    transform: "translate(329.799 -134.457)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    className: "cls-23",
    d: "M97.55,446.559l-8,.136,1.272,19.225,8-.136Z",
    transform: "translate(329.746 -135.727)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    className: "cls-23",
    d: "M99.5,470.683l-8,.136,1.272,19.225,8-.136Z",
    transform: "translate(329.615 -136.992)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    className: "cls-23",
    d: "M100.837,494.621l-8,.131,1.268,19.229,8-.135Z",
    transform: "translate(329.526 -138.246)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    className: "cls-23",
    d: "M102.972,521.847l-8,.133,1.268,19.229,8-.136Z",
    transform: "translate(329.384 -139.673)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    className: "cls-23",
    d: "M104.838,551.167l-8,.133,1.268,19.229,8-.134Z",
    transform: "translate(329.259 -141.21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    className: "cls-23",
    d: "M105.9,577.2l-8,.134,1.268,19.225,8-.134Z",
    transform: "translate(329.188 -142.575)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    className: "cls-23",
    d: "M113.372,666.36l-8,.135,1.268,19.227,8-.133Z",
    transform: "translate(328.689 -147.248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    className: "cls-23",
    d: "M110.972,644.519l-8,.133,1.272,19.229,8-.136Z",
    transform: "translate(328.85 -146.103)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    className: "cls-23",
    d: "M110.173,619.983l-8,.136,1.268,19.225,8-.136Z",
    transform: "translate(328.903 -144.817)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    className: "cls-23",
    d: "M109.124,601.118l-8,.129,1.237,16.332,8-.133Z",
    transform: "translate(328.973 -143.828)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_86",
    "data-name": "Rectangle 86",
    className: "cls-25",
    width: 16.924,
    height: 27.975,
    transform: "translate(368.848 341.763)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_87",
    "data-name": "Rectangle 87",
    className: "cls-25",
    width: 16.923,
    height: 27.979,
    transform: "translate(370.177 374.647)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88",
    "data-name": "Rectangle 88",
    className: "cls-25",
    width: 16.924,
    height: 27.975,
    transform: "translate(372.169 407.539)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_89",
    "data-name": "Rectangle 89",
    className: "cls-25",
    width: 18.915,
    height: 31.756,
    transform: "translate(290.366 400.357)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    className: "cls-25",
    d: "M-55.908,541.036H-66.029l2.987,21.548h10.119Z",
    transform: "translate(340.134 -140.679)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    className: "cls-25",
    d: "M-61.243,520.5H-71.363l2.987,18.323h10.121Z",
    transform: "translate(340.49 -139.603)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_90",
    "data-name": "Rectangle 90",
    className: "cls-25",
    width: 18.915,
    height: 31.754,
    transform: "translate(290.366 362.934)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_91",
    "data-name": "Rectangle 91",
    className: "cls-25",
    width: 18.915,
    height: 31.753,
    transform: "translate(290.366 327.208)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_92",
    "data-name": "Rectangle 92",
    className: "cls-25",
    width: 18.915,
    height: 31.758,
    transform: "translate(291.86 292.618)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_93",
    "data-name": "Rectangle 93",
    className: "cls-25",
    width: 18.916,
    height: 29.485,
    transform: "translate(293.351 260.297)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_94",
    "data-name": "Rectangle 94",
    className: "cls-25",
    width: 18.916,
    height: 29.485,
    transform: "translate(292.357 226.842)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    className: "cls-25",
    d: "M-28.943,287.692l-15.929-3.969v29.489h15.929Z",
    transform: "translate(338.721 -127.193)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_95",
    "data-name": "Rectangle 95",
    className: "cls-25",
    width: 15.929,
    height: 29.489,
    transform: "translate(292.357 190.552)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    className: "cls-25",
    d: "M-22.623,521.232V500.459l-2.189.529.876,20.425Z",
    transform: "translate(337.382 -138.552)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    className: "cls-23",
    d: "M31.6,486.536V465.759l-2.183.533.876,20.42Z",
    transform: "translate(333.761 -136.734)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    className: "cls-23",
    d: "M153.922,615.759V594.981l-2.183.535.873,20.42Z",
    transform: "translate(325.594 -143.507)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    className: "cls-23",
    d: "M25.38,565.991V533.858l-2.187.822.876,31.588Z",
    transform: "translate(334.177 -140.303)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    className: "cls-23",
    d: "M16.57,662.3V630.165l-2.187.825.876,31.584Z",
    transform: "translate(334.765 -145.351)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    className: "cls-23",
    d: "M10.978,311.668V290.307l-2.187.551.876,21Z",
    transform: "translate(335.138 -127.538)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    className: "cls-23",
    d: "M16.79,547.482h38l-.975-2.49-37.352,1Z",
    transform: "translate(334.626 -140.887)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    className: "cls-23",
    d: "M307.728,404.943V390.237l-.8.378.322,14.457Z",
    transform: "translate(315.232 -132.776)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    className: "cls-23",
    d: "M321.626,358.885V344.18l-.795.375.318,14.456Z",
    transform: "translate(314.304 -130.362)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    className: "cls-23",
    d: "M304.6,396.475h13.825l-.353-1.141-13.588.454Z",
    transform: "translate(315.395 -133.043)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    className: "cls-23",
    d: "M285.939,377.609h13.821l-.353-1.137-13.585.459Z",
    transform: "translate(316.641 -132.054)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    className: "cls-23",
    d: "M335.012,432.663h13.821l-.357-1.137-13.585.454Z",
    transform: "translate(313.365 -134.94)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    className: "cls-23",
    d: "M337.143,481.135h13.821l-.353-1.141-13.585.456Z",
    transform: "translate(313.222 -137.48)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    className: "cls-23",
    d: "M329.677,370.43H343.5l-.353-1.141-13.588.459Z",
    transform: "translate(313.721 -131.678)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    className: "cls-23",
    d: "M-189.844,526.936h33.4l-.853-2.49-32.831,1Z",
    transform: "translate(348.42 -139.81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    className: "cls-23",
    d: "M-318.633,493.338l25.58-2.192.255-1.568-26.055,2.285Z",
    transform: "translate(357.015 -137.982)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    className: "cls-23",
    d: "M-299.758,482l1.493,18.138,1.374.289-1.571-18.477Z",
    transform: "translate(355.74 -137.582)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    className: "cls-23",
    d: "M-258.129,512.939h32.22l-.825-1.977-31.671.791Z",
    transform: "translate(352.979 -139.103)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    className: "cls-23",
    d: "M-251.175,507.7v20.363l1.733-.522-.7-20.018Z",
    transform: "translate(352.496 -138.923)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    className: "cls-23",
    d: "M-231.31,516.835V498.079l-1.6.481.641,18.434Z",
    transform: "translate(351.276 -138.428)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    className: "cls-9",
    d: "M-58.834,516.863V496.849l1.221.683-.488,19.605Z",
    transform: "translate(339.653 -138.363)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    className: "cls-9",
    d: "M-55.477,505.852l-21.266-3,.546-1.474,20.9,3.566Z",
    transform: "translate(340.849 -138.601)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97",
    transform: "translate(355.243 178.078)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    className: "cls-10",
    d: "M20.914,339.351H32.195C32.195,295.68,20.914,295.32,20.914,339.351Z",
    transform: "translate(-20.914 -306.463)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    className: "cls-22",
    d: "M22.727,337.455h7.9C30.624,301.617,22.727,301.328,22.727,337.455Z",
    transform: "translate(-21.035 -306.673)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98",
    transform: "translate(399.558 179.211)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    className: "cls-10",
    d: "M68.4,339.6h6.836C75.236,297.185,68.4,296.836,68.4,339.6Z",
    transform: "translate(-68.4 -307.659)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    className: "cls-11",
    d: "M68.4,340.069h3.417C71.817,308.811,68.4,308.556,68.4,340.069Z",
    transform: "translate(-68.4 -308.124)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99",
    transform: "translate(231.764 211.346)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    className: "cls-10",
    d: "M-111.4,373.515h9.492C-101.907,331.1-111.4,330.748-111.4,373.515Z",
    transform: "translate(111.399 -341.57)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    className: "cls-11",
    d: "M-111.4,373.98h4.748C-106.651,342.725-111.4,342.467-111.4,373.98Z",
    transform: "translate(111.399 -342.035)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100",
    transform: "translate(403.575 253.495)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    className: "cls-10",
    d: "M72.7,423.664h7.264C79.968,373.719,72.7,373.309,72.7,423.664Z",
    transform: "translate(-72.704 -386.051)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    className: "cls-11",
    d: "M72.7,424.211h3.632C76.336,387.408,72.7,387.108,72.7,424.211Z",
    transform: "translate(-72.704 -386.599)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101",
    transform: "translate(302.663 179.211)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    className: "cls-9",
    d: "M-28.591,339.6h-6.837C-35.428,297.185-28.591,296.836-28.591,339.6Z",
    transform: "translate(35.428 -307.659)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    className: "cls-10",
    d: "M-28.347,340.069h-3.422C-31.769,308.811-28.347,308.556-28.347,340.069Z",
    transform: "translate(35.184 -308.124)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102",
    transform: "translate(39.82 300.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    className: "cls-10",
    d: "M-311.311,467.708h-5.765C-317.076,425.286-311.311,424.941-311.311,467.708Z",
    transform: "translate(317.076 -435.762)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    className: "cls-11",
    d: "M-311.105,468.173h-2.884C-313.989,436.912-311.105,436.657-311.105,468.173Z",
    transform: "translate(316.87 -436.227)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103",
    transform: "translate(73.668 300.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    className: "cls-10",
    d: "M-275.043,467.708h-5.763C-280.806,425.286-275.043,424.941-275.043,467.708Z",
    transform: "translate(280.806 -435.762)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    className: "cls-11",
    d: "M-274.837,468.173h-2.883C-277.72,436.912-274.837,436.657-274.837,468.173Z",
    transform: "translate(280.6 -436.227)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104",
    transform: "translate(107.516 300.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    className: "cls-10",
    d: "M-238.772,467.708h-5.765C-244.537,425.286-238.772,424.941-238.772,467.708Z",
    transform: "translate(244.537 -435.762)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    className: "cls-11",
    d: "M-238.566,468.173h-2.883C-241.449,436.912-238.566,436.657-238.566,468.173Z",
    transform: "translate(244.331 -436.227)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105",
    transform: "translate(141.365 300.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    className: "cls-10",
    d: "M-202.5,467.708h-5.762C-208.266,425.286-202.5,424.941-202.5,467.708Z",
    transform: "translate(208.266 -435.762)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    className: "cls-11",
    d: "M-202.3,468.173h-2.883C-205.181,436.912-202.3,436.657-202.3,468.173Z",
    transform: "translate(208.06 -436.227)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    "data-name": "Group 106",
    transform: "translate(302.663 255.271)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    className: "cls-9",
    d: "M-28.591,423.762h-6.837C-35.428,376.175-28.591,375.785-28.591,423.762Z",
    transform: "translate(35.428 -387.925)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    className: "cls-10",
    d: "M-28.347,424.283h-3.422C-31.769,389.218-28.347,388.93-28.347,424.283Z",
    transform: "translate(35.184 -388.447)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_107",
    "data-name": "Group 107",
    transform: "translate(615.063 214.683)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    className: "cls-9",
    d: "M310.4,367.936h-11.08C299.323,337.6,310.4,337.354,310.4,367.936Z",
    transform: "translate(-299.323 -345.092)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    className: "cls-10",
    d: "M310.8,368.269h-5.547C305.252,345.92,310.8,345.735,310.8,368.269Z",
    transform: "translate(-299.719 -345.425)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    className: "cls-23",
    d: "M205.542,539.239H189.283v13.612h14.479Z",
    transform: "translate(323.087 -140.585)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    className: "cls-23",
    d: "M289.934,539.239H277.819v13.612h10.79Z",
    transform: "translate(317.175 -140.585)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    className: "cls-16",
    d: "M207.448,539.229l-14.436-.187c2.537,5.547,3.739,20.29,4.777,28.681l4.48-18.994L207.7,563.2C210.105,551.888,208.961,546.227,207.448,539.229Z",
    transform: "translate(322.838 -140.575)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    className: "cls-24",
    d: "M-72.206,266.688l2.114,2.407,165.5.85,2.989-5.668Z",
    transform: "translate(340.546 -126.174)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    className: "cls-24",
    d: "M269.687,315.789l1.261,1.779,98.623.633,1.781-4.192Z",
    transform: "translate(317.718 -128.78)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_108",
    "data-name": "Group 108",
    transform: "translate(298.165 145.567)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    className: "cls-11",
    d: "M-37.195,272.466h-3.053l2.258,7.264h2.224Z",
    transform: "translate(40.247 -272.17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    className: "cls-11",
    d: "M-28.661,272.466h-3.053l2.258,7.264h2.224Z",
    transform: "translate(39.677 -272.17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    className: "cls-11",
    d: "M-20.126,272.466h-3.053l2.256,7.264H-18.7Z",
    transform: "translate(39.107 -272.17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    className: "cls-11",
    d: "M-11.593,272.466h-3.053l2.258,7.264h2.224Z",
    transform: "translate(38.538 -272.17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    className: "cls-11",
    d: "M-3.057,272.466H-6.11l2.258,7.264H-1.63Z",
    transform: "translate(37.968 -272.17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    className: "cls-11",
    d: "M5.476,272.466H2.423l2.258,7.264H6.9Z",
    transform: "translate(37.398 -272.17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    className: "cls-11",
    d: "M15.789,272.153H12.736l.6,7.561h2.222Z",
    transform: "translate(36.709 -272.153)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    className: "cls-11",
    d: "M24.144,272.466H21.092l.763,7.264h2.222Z",
    transform: "translate(36.152 -272.17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    className: "cls-11",
    d: "M30.7,272.466h3.053L31.5,279.73H29.277Z",
    transform: "translate(35.605 -272.17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    className: "cls-11",
    d: "M38.7,272.466h3.053L39.5,279.73H37.276Z",
    transform: "translate(35.071 -272.17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    className: "cls-11",
    d: "M46.7,272.466h3.053L47.5,279.73H45.276Z",
    transform: "translate(34.537 -272.17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    className: "cls-11",
    d: "M54.706,272.466h3.049L55.5,279.73H53.279Z",
    transform: "translate(34.002 -272.17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    className: "cls-11",
    d: "M62.706,272.466h3.049L63.5,279.73H61.279Z",
    transform: "translate(33.468 -272.17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    className: "cls-11",
    d: "M70.706,272.466h3.053L71.5,279.73H69.278Z",
    transform: "translate(32.934 -272.17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    className: "cls-11",
    d: "M78.709,272.466h3.049L79.5,279.73H77.282Z",
    transform: "translate(32.4 -272.17)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    className: "cls-23",
    d: "M86.005,414.175H66.386l2.162,14.466H83.843Z",
    transform: "translate(331.293 -134.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    className: "cls-25",
    d: "M86.16,414.175H81.178L68.7,428.641H84Z",
    transform: "translate(331.138 -134.03)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_96",
    "data-name": "Rectangle 96",
    className: "cls-25",
    width: 18.913,
    height: 1.993,
    transform: "translate(351.095 273.047)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_97",
    "data-name": "Rectangle 97",
    className: "cls-25",
    width: 1.749,
    height: 33.686,
    transform: "translate(359.677 258.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    className: "cls-25",
    d: "M13.936,427.25h2.1c0-44.521,19.111-44.16,19.111,0h2.1C37.241,378.722,13.936,378.328,13.936,427.25Z",
    transform: "translate(334.795 -132.8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    className: "cls-25",
    d: "M54.126,426.988H-8.484l6.9,22.78h48.81Z",
    transform: "translate(336.292 -134.702)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    className: "cls-23",
    d: "M12.944,441.1H6.973L4.733,453.3H15.187Z",
    transform: "translate(335.409 -135.441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    className: "cls-23",
    d: "M38.547,441.1H32.576L30.333,453.3H40.787Z",
    transform: "translate(333.7 -135.441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    className: "cls-19",
    d: "M-130.653,276.541l-73.269,110.8,66.178-109.073Z",
    transform: "translate(349.341 -126.817)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    className: "cls-19",
    d: "M-185.291,274.311-260.92,387.384l68.5-111.313Z",
    transform: "translate(353.147 -126.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    className: "cls-19",
    d: "M-249.473,274.5l-75.633,113.071,68.5-111.312Z",
    transform: "translate(357.432 -126.71)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    className: "cls-19",
    d: "M-19.794,261.715l15.855-.5,6.211-6.931-6.7,5.6-12.772.357,1.862-5.369Z",
    transform: "translate(337.047 -125.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    className: "cls-19",
    d: "M-25.3,254.443l15.857-.5,6.211-6.931-6.7,5.6-12.774.353,1.864-5.367Z",
    transform: "translate(337.415 -125.269)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    className: "cls-19",
    d: "M-7.7,247.859l15.857-.5,6.215-6.931-6.706,5.6-12.772.353,1.862-5.367Z",
    transform: "translate(336.24 -124.924)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    className: "cls-19",
    d: "M-11.615,237.455l15.853-.5,6.215-6.931-6.7,5.6-12.774.353,1.864-5.365Z",
    transform: "translate(336.501 -124.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    className: "cls-19",
    d: "M1.9,230.256l16.012-.5,2.388-7.11-3.657,5.745-12.927.346-1.184-5.512Z",
    transform: "translate(335.598 -123.992)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    className: "cls-19",
    d: "M-27.413,247.36l12.871-.4,5.987-5.882-6.194,4.752-10.364.282,2.254-4.561Z",
    transform: "translate(337.555 -124.958)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    "data-name": "Path 520",
    className: "cls-19",
    d: "M-40.792,260.995l12.422-.335,6.736-6.3-6.746,5.076-9.993.221,2.929-4.9Z",
    transform: "translate(338.449 -125.654)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    className: "cls-27",
    d: "M10.6,240.64H.308l-2.155,5.668H8.441Z",
    transform: "translate(335.848 -124.935)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    "data-name": "Path 522",
    className: "cls-27",
    d: "M-.253,255.2H-10.536l-2.153,4.723H-2.4Z",
    transform: "translate(336.572 -125.698)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    "data-name": "Path 523",
    className: "cls-27",
    d: "M16.639,249.213H6.35L4.2,253.937H14.484Z",
    transform: "translate(335.445 -125.384)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    className: "cls-27",
    d: "M19.3,222.89h8.921l.378,4.719H19.679Z",
    transform: "translate(334.436 -124.005)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    className: "cls-27",
    d: "M32.9,239.046h8.925l.378,4.719H33.278Z",
    transform: "translate(333.528 -124.851)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    className: "cls-27",
    d: "M14.229,209.821l7.091,6.143.378,4.725H12.77Z",
    transform: "translate(334.872 -123.32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    className: "cls-19",
    d: "M295.961,312.694l11.783-.377,4.621-5.148-4.982,4.163-9.5.262,1.385-3.987Z",
    transform: "translate(315.964 -128.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    className: "cls-19",
    d: "M291.861,307.286l11.787-.373,4.621-5.152-4.985,4.163-9.493.266,1.385-3.995Z",
    transform: "translate(316.238 -128.138)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    className: "cls-19",
    d: "M304.945,302.394l11.79-.377,4.618-5.151-4.982,4.163-9.5.265,1.385-3.991Z",
    transform: "translate(315.364 -127.882)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    className: "cls-19",
    d: "M302.038,294.656l11.786-.373,4.621-5.152-4.985,4.163-9.493.266,1.385-3.991Z",
    transform: "translate(315.558 -127.476)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    className: "cls-19",
    d: "M312.093,289.3l11.9-.366,1.777-5.292-2.72,4.276-9.607.258-.88-4.1Z",
    transform: "translate(314.887 -127.189)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    className: "cls-19",
    d: "M290.3,302.019l9.564-.3,4.452-4.371-4.6,3.528-7.706.212,1.678-3.394Z",
    transform: "translate(316.342 -127.907)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    className: "cls-19",
    d: "M280.348,312.157l9.232-.247,5.01-4.683L289.573,311l-7.427.165,2.177-3.639Z",
    transform: "translate(317.007 -128.425)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    className: "cls-27",
    d: "M318.549,297.027h-7.642l-1.6,4.212h7.646Z",
    transform: "translate(315.073 -127.89)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    className: "cls-27",
    d: "M310.488,307.85h-7.646l-1.6,3.51h7.646Z",
    transform: "translate(315.612 -128.458)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    className: "cls-27",
    d: "M323.043,303.4H315.4l-1.6,3.512h7.642Z",
    transform: "translate(314.773 -128.224)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    className: "cls-27",
    d: "M325.025,283.827h6.635l.279,3.51H325.3Z",
    transform: "translate(314.024 -127.198)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    "data-name": "Path 538",
    className: "cls-27",
    d: "M335.134,295.84h6.635l.283,3.508h-6.639Z",
    transform: "translate(313.349 -127.828)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    "data-name": "Path 539",
    className: "cls-27",
    d: "M320.719,265.734l5.271,4.572.279,3.507h-6.635Z",
    transform: "translate(314.383 -126.25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    "data-name": "Path 540",
    className: "cls-26",
    d: "M-339.02,616.725l.562-19.487-.611-.368-1.365,20.1Z",
    transform: "translate(358.456 -143.606)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    "data-name": "Path 541",
    className: "cls-27",
    d: "M167.21,419.161h-7.8l3.982,7.562h7.8Z",
    transform: "translate(325.081 -134.292)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    className: "cls-27",
    d: "M170.231,428.533h-7.8l3.985,7.562h7.8Z",
    transform: "translate(324.88 -134.783)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    className: "cls-27",
    d: "M172.188,437.509h-7.8l3.985,7.564h7.794Z",
    transform: "translate(324.749 -135.253)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    "data-name": "Path 544",
    className: "cls-27",
    d: "M185.522,437.509h-7.8l3.985,7.564h7.8Z",
    transform: "translate(323.859 -135.253)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    "data-name": "Path 545",
    className: "cls-27",
    d: "M176.989,418.758h-7.8l3.985,7.564h7.794Z",
    transform: "translate(324.428 -134.27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    className: "cls-19",
    d: "M194.1,425.216h-7.8l3.985,7.56h7.794Z",
    transform: "translate(323.286 -134.609)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    "data-name": "Path 547",
    className: "cls-19",
    d: "M205.258,452.075h-7.8l3.985,7.562h7.794Z",
    transform: "translate(322.541 -136.017)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    "data-name": "Path 548",
    className: "cls-27",
    d: "M178.231,446.487h-7.8l3.985,7.561h7.8Z",
    transform: "translate(324.345 -135.724)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_549",
    "data-name": "Path 549",
    className: "cls-27",
    d: "M181.964,455.662H174.17l3.982,7.562h7.8Z",
    transform: "translate(324.096 -136.205)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    className: "cls-24",
    d: "M313,421.357H305.2l3.982,7.189h7.8Z",
    transform: "translate(315.347 -134.407)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    className: "cls-24",
    d: "M316.021,430.267h-7.8l3.985,7.189H320Z",
    transform: "translate(315.145 -134.874)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    className: "cls-24",
    d: "M317.975,438.8h-7.794l3.982,7.189h7.8Z",
    transform: "translate(315.015 -135.321)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    className: "cls-24",
    d: "M324.021,447.333h-7.8l3.985,7.189h7.8Z",
    transform: "translate(314.611 -135.768)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    className: "cls-24",
    d: "M327.754,456.06h-7.8l3.985,7.186h7.8Z",
    transform: "translate(314.362 -136.225)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_98",
    "data-name": "Rectangle 98",
    className: "cls-23",
    width: 12.776,
    height: 6.048,
    transform: "translate(604.457 190.742)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_99",
    "data-name": "Rectangle 99",
    className: "cls-23",
    width: 12.776,
    height: 6.048,
    transform: "translate(626.687 190.742)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_100",
    "data-name": "Rectangle 100",
    className: "cls-23",
    width: 12.772,
    height: 6.048,
    transform: "translate(651.91 190.742)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    className: "cls-16",
    d: "M296.326,539.042H279.152a55.108,55.108,0,0,1,4.568,20.978l5.144-10.581,6.466,17.385C297.736,555.514,297.839,546.036,296.326,539.042Z",
    transform: "translate(317.086 -140.575)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110",
    transform: "translate(0 399.608)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    className: "cls-22",
    d: "M-458.758,682.794l78.5-108.868,10.5,7.681V605.8l7.42-17.961,18.6-47.589,8.016,12.839,7.456,97.993,8.634-14.2,51.388,3.454,95.015,41.506Z",
    transform: "translate(458.765 -540.246)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    className: "cls-11",
    d: "M-264.36,666.1l-1.469,3.254,42.045,14.776-86.845-6.715-5.368,1.8,29.513,4.912-48.27,1.036L-337.387,681l-9.879-6.984-34.187,7.274,18.553-6.88-6.858-40.018-33.126,29.9-12.756,6.362-43.126,17.077,268.759-.953Z",
    transform: "translate(458.765 -545.18)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111",
    transform: "translate(292.698 505.804)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    className: "cls-28",
    d: "M365.27,652.316l20.736,6.818,15.45,15.462h13.619l27.239,14.078H-145.126l14.284-18.179,35.184-5.886,1.4,14.981,46.271,8.025,37.725.252,21.2-17.372,25.086-2.43,9.29,5.762,15.654,9.22L165.94,681.51l17.036.96,83.449-.576,60.647-3.457Z",
    transform: "translate(145.126 -652.316)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    className: "cls-29",
    d: "M420.046,659.511l-12.073,10.8-43.279,10.8,70.8-6.146Z",
    transform: "translate(111.085 -652.693)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    className: "cls-29",
    d: "M439.328,675.828l-87.392,13.018-26.861-6.509-71.367,1.045L218.1,689.328l248.472.578Z",
    transform: "translate(120.874 -653.548)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    "data-name": "Path 561",
    className: "cls-29",
    d: "M20.586,671.5l-6.718,11.14H51.606l37.17,6.82-89.39-.588Z",
    transform: "translate(135.477 -653.321)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_115",
    "data-name": "Group 115",
    transform: "translate(1080.769 -536.223)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    "data-name": "Path 562",
    className: "cls-5",
    d: "M1092.391,269.58c-5.085-6.491-12.845-10.434-21.8-11.066a10.352,10.352,0,0,0-1.56.053,8.271,8.271,0,0,0,1.4-4.075,10.407,10.407,0,0,0-4.411-9.182,44.539,44.539,0,0,0-5.056-9.7,18.148,18.148,0,0,0,5.21-11.508c.821-12.172-7.467-20.974-20.629-21.791q-10.976-.679-21.956-1.286a8.494,8.494,0,0,1-3.166-.174q-7.427-.4-14.853-.773a8.58,8.58,0,0,0-5.221,1.434,8.615,8.615,0,0,0-5.063-1.931q-9.174-.429-18.349-.807a8.191,8.191,0,0,1-2.851-.116q-7.43-.3-14.86-.566a8.585,8.585,0,0,0-5.2,1.507,8.6,8.6,0,0,0-5.088-1.86q-9.177-.3-18.356-.552a8.751,8.751,0,0,0-1.111.049,8.872,8.872,0,0,0-1.107-.109q-18.928-.5-37.859-.791c-.268,0-.532.007-.792.028-.262-.028-.525-.047-.791-.051q-7.434-.11-14.866-.186a8.555,8.555,0,0,0-7.235,3.8l-.261-.363a8.578,8.578,0,0,0-6.926-3.557q-7.943-.047-15.885-.056a8.56,8.56,0,0,0-7.1,3.719,31.93,31.93,0,0,0-17.105-4.594c-2.346.013-8.571,1.85-13.424,3.84a8.567,8.567,0,0,0-6.388-2.726q-7.434.09-14.866.212a8.586,8.586,0,0,0-6.241,2.815,8.571,8.571,0,0,0-6.336-2.582q-9.022.183-18.041.414a8.578,8.578,0,0,0-6.177,2.843,8.552,8.552,0,0,0-7.315-3.716,8.808,8.808,0,0,0-1.255.129q-4.27.751-8.538,1.514a8.494,8.494,0,0,0-6.654,5.837q-5.329,17.391-10.54,34.8a11.59,11.59,0,0,0-6.666,10.61,8.307,8.307,0,0,0,1.817,4.868q-8.771.35-17.54.748a8.317,8.317,0,0,0,1.409-5,10.224,10.224,0,0,0-3.455-7.228l-.019-.411a22.015,22.015,0,0,0,19.1-22.7c-.387-10.313-8.562-20.473-23.438-19.785q-10.665.5-21.327,1.062a8.565,8.565,0,0,0-7.229,4.7,31.684,31.684,0,0,0-18.268-4.192c-3.586.21-16.005,5.195-18.828,7.895A30.857,30.857,0,0,0,619,253.7a28.82,28.82,0,0,0,6.474,4.637l-3.02.2a8.409,8.409,0,0,0-7.632,6.457q-.4,1.7-.8,3.4-.731-1.747-1.463-3.493a8.366,8.366,0,0,0-8.328-5.1q-8.516.614-17.031,1.273a8.4,8.4,0,0,0-7.743,9.014,10.357,10.357,0,0,0,3.674,7.1l2.03,26.513a11.2,11.2,0,0,0-2.455,8.3,8.32,8.32,0,0,0,8.891,7.707q4.6-.356,9.195-.7a8.2,8.2,0,0,0,3.933-1.348,8.187,8.187,0,0,0,7.429,1.611q3.053-.842,6.107-1.676a8.248,8.248,0,0,0,2.414-1.1,8.153,8.153,0,0,0,4.152.817q8.891-.6,17.784-1.141a7.931,7.931,0,0,1,3.674-.224q16.5-.993,33.008-1.817a8.246,8.246,0,0,0,6.265-3.418,8.219,8.219,0,0,0,6.559,2.8q8.9-.409,17.8-.769a8.354,8.354,0,0,0,7.951-8.7,10.316,10.316,0,0,0-3.354-7.253l-.538-14.3a14.047,14.047,0,0,0,4.266.506,8.381,8.381,0,0,0,7.913-6.877,17.275,17.275,0,0,0,2.509,7.182,8.362,8.362,0,0,0-1.535,5.137q.189,5.635.38,11.27a8.451,8.451,0,0,0,1.828,4.971c2.665,3.345,11.177,7.892,21.8,7.6a22.263,22.263,0,0,0,17.685-9.123,29.208,29.208,0,0,0,21.233,8.286c2.7-.047,12.875-3.315,17.178-5.793a8.267,8.267,0,0,0,7.432,4.572q16.521-.129,33.044-.089a8.337,8.337,0,0,0,8.3-8.12q.11-3.452.221-6.9c.927,8.045,7.661,16.012,21.312,16.166a29.251,29.251,0,0,0,13.828-3.218,22.288,22.288,0,0,0,12.082,3.626,8.232,8.232,0,0,0,6.437-2.916q2.986-3.513,5.982-7.021c-.032.3-.085.588-.091.887a8.35,8.35,0,0,0,8.07,8.584q7.184.187,14.368.407a8.208,8.208,0,0,0,6.164-2.513,8.224,8.224,0,0,0,5.993,2.908q8.718.3,17.435.645c.206.008.409,0,.612-.006.2.023.4.047.61.055q16.514.664,33.022,1.5a8.083,8.083,0,0,1,4.657.238q8.9.462,17.792.973a8.159,8.159,0,0,1,7.729.454q7.423.444,14.845.923a8.188,8.188,0,0,0,5.847-1.95,30.232,30.232,0,0,0,13.523,4.2c3.015.2,15.753-2.8,18.966-5.042a31.273,31.273,0,0,0,13.157-23.307A30.279,30.279,0,0,0,1092.391,269.58Zm-50.035-9.456c.053-.023.107-.037.158-.061a8.447,8.447,0,0,0,3.869,1.219q4.583.291,9.166.593a19.026,19.026,0,0,0-4.325,2.029,32.965,32.965,0,0,0-2.628,2.189A18.6,18.6,0,0,0,1042.357,260.125Zm-42.424-43.631a11.537,11.537,0,0,0,1.275,1.061q-.4,8.518-.807,17.038a.914.914,0,1,1-1.315-.063Q999.509,225.51,999.933,216.494Zm-46.121-1.91a11.551,11.551,0,0,0,1.289,1.043q-.287,8.523-.575,17.047a.915.915,0,1,1-1.316-.045Q953.511,223.607,953.811,214.584Zm-62.951,32.189q.159-10.531.317-21.064a14.665,14.665,0,0,0,3.213-.573q-.115,7.156-.23,14.313a10.237,10.237,0,0,0-3.247,7.326,8.322,8.322,0,0,0,1.534,4.941c-.924-.226-1.891-.423-2.905-.578A8.315,8.315,0,0,0,890.861,246.773Zm-83.95,9.013a30.757,30.757,0,0,0-17.434-5.013,8.344,8.344,0,0,0,.581-1.338q1.5-4.649,3.009-9.3a29.948,29.948,0,0,0,4.585,6.392,28.913,28.913,0,0,0,10.836,7.21A8.426,8.426,0,0,0,806.911,255.786Zm-150.4.66c.921-.46,1.73-.908,2.405-1.331a8.514,8.514,0,0,0,.8,1.153Zm29.315,33.29a8.3,8.3,0,0,0-2.021-2.315l-1.8-1.409a8.286,8.286,0,0,0-3.146-1.523c.088-.025.167-.069.256-.1a8.323,8.323,0,0,0,2.229.2,14.087,14.087,0,0,0,4.208-.873Q685.683,286.725,685.823,289.736Zm40.365-18.473q-.161-4.791-.324-9.582a8.294,8.294,0,0,0-1.789-4.876q3.178-.113,6.356-.219a8.425,8.425,0,0,0,6.1-2.906,8.369,8.369,0,0,0,.953.82A20.837,20.837,0,0,0,726.188,271.262ZM764.526,254.6a8.45,8.45,0,0,0,2.081-1.7,8.4,8.4,0,0,0,5.605,3.642,11.59,11.59,0,0,0-1.905,1.263c-.377.336-.74.682-1.1,1.032a8.256,8.256,0,0,0-.639-.966A13.211,13.211,0,0,0,764.526,254.6Zm98.663,23.645a21.14,21.14,0,0,0-6.807,11.97q.028-.92.059-1.84a8.389,8.389,0,0,0-3.118-6.81l-1.791-1.439a8.29,8.29,0,0,0-8.82-.995l-2.046,1a8.325,8.325,0,0,0-3.021,2.5q-.005-7.792-.009-15.583a10.145,10.145,0,0,0,3.037-7.81,8.365,8.365,0,0,0-6.354-7.655c.71-.3,1.377-.589,1.979-.88a8.412,8.412,0,0,0,7.195,4.062q7.3.009,14.611.049a8.42,8.42,0,0,0,7.994-5.614q.723,1.049,1.446,2.1a8.41,8.41,0,0,0,2.812,2.556,16.554,16.554,0,0,0-4.827,2.549,15.611,15.611,0,0,0-5.511,11.77A18.191,18.191,0,0,0,863.189,278.242Zm59.781,14.229a11.777,11.777,0,0,0-3.363,2.157,8.385,8.385,0,0,0-2.784-6.655l-1.178-1.052a11.086,11.086,0,0,0,3.217-7.577,8.359,8.359,0,0,0-8.164-8.571l-3.18-.067a15.211,15.211,0,0,0-6.806-15.382q8.29.154,16.58.351a8.4,8.4,0,0,0,8.612-8.169,10.257,10.257,0,0,0-2.948-7.455q.175-7.155.351-14.311c.386.132.782.243,1.18.344q-.071,2.839-.141,5.678a24.13,24.13,0,0,0,8.447,18.9,28.292,28.292,0,0,0,5.649,3.866,8.339,8.339,0,0,0-2.989,3.883Q929.152,275.431,922.97,292.471ZM962.607,262a10.482,10.482,0,0,0,2.84,7.49q-.09,2.415-.18,4.832-2.748-8.308-5.528-16.612a8.312,8.312,0,0,0-.844-1.744,28.2,28.2,0,0,0,7.661-4.172,25.4,25.4,0,0,0,6.215-6.878,25.462,25.462,0,0,0,5.656,7.358,28.129,28.129,0,0,0,2.632,2.084q-4.871-.21-9.742-.406A8.365,8.365,0,0,0,962.607,262Zm46.729-6.283a28.024,28.024,0,0,0,2.839-1.84c.189-.142.368-.291.553-.437a8.346,8.346,0,0,0,1.117,2.5l-4.181-.22C1009.553,255.713,1009.446,255.72,1009.336,255.719Z",
    transform: "translate(-579.433 -195.073)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117",
    transform: "translate(1117.52 -527.988)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116",
    "data-name": "Group 116"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    "data-name": "Path 563",
    className: "cls-12",
    d: "M612.579,231.135a22.634,22.634,0,0,1,7.09-18.029c1.19-1.147,11.639-5.445,13.35-5.547,14.491-.9,22.779,9.328,23.358,20.27a22.846,22.846,0,0,1-7.414,18.205c-1.257,1.128-11.724,5.256-13.279,5.359C622.1,252.248,613.338,242.2,612.579,231.135Zm27.447,15.371c2.468-2.772,3.168-10.176,2.741-17.516-.322-5.534-1.244-10.533-2.481-13.267-.58-1.276-5.379-5.288-7.086-5.18a23.634,23.634,0,0,0-4.565,2.038c-2.37,2.648-2.989,8.87-2.567,15.521.382,6.03,1.572,11.883,3.036,15.222.513,1.152,4.659,5.318,6.4,5.21A17.968,17.968,0,0,0,640.026,246.506Z",
    transform: "translate(-582.434 -201.334)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    className: "cls-12",
    d: "M687.252,217.919c.281,6.724-4.511,13.845-13.914,14.3l-2.322.113L669.69,230.9l1.183-1.555c3.452-.169,4.644-5.712,4.4-11a21.762,21.762,0,0,0-1.339-7.108,12.954,12.954,0,0,0-3.7-1.942l-3.475.171q.883,18.2,1.765,36.4l1.464.488a2.364,2.364,0,0,1,1.783,1.971q-9.05.444-18.1.94a2.373,2.373,0,0,1,1.576-2.145l1.408-.637-1.917-36.765-1.546-.478a2.4,2.4,0,0,1-1.751-1.963q10.621-.582,21.243-1.093C682.243,205.722,686.989,211.635,687.252,217.919Z",
    transform: "translate(-575.464 -201.601)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    className: "cls-12",
    d: "M723.661,244.526l.678-.333q-5.589-13.668-11.265-27.316l-1.324.043q-2.28,7.464-4.538,14.93,4.277-.774,8.557-1.536,1.047,1.338,2.093,2.675l-1.806,2.427q-4.844-.435-9.693-.855-1.351,4.473-2.7,8.948l3.276.63a3.348,3.348,0,0,1,2.724,2.835q-7.306.251-14.614.539a3.292,3.292,0,0,1,2.516-2.966l2.541-.721q5.831-19.512,11.818-39,4.25-.765,8.5-1.519,8.394,20.246,16.6,40.536l1.007.286a2.3,2.3,0,0,1,1.737,1.949q-8.871.223-17.741.494C721.995,245.324,722.98,244.858,723.661,244.526Z",
    transform: "translate(-567.655 -202.163)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    "data-name": "Path 566",
    className: "cls-12",
    d: "M730.756,206.4l-1.02-.285c-.511-.174-1.726-.7-1.758-1.948q8.983-.239,17.969-.426c.025,1.245-.979,1.7-1.667,2.028l-.69.327q5.539,13.713,10.992,27.444l1.317-.024q4.285-13.192,8.643-26.374l-3.363-.757a3.435,3.435,0,0,1-2.7-2.883q7.4-.127,14.807-.219a3.3,3.3,0,0,1-2.621,2.9l-2.582.658q-6.344,19.372-12.531,38.768-4.206.7-8.409,1.41Q739.043,226.69,730.756,206.4Z",
    transform: "translate(-561.758 -202.166)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    className: "cls-12",
    d: "M764.748,224.739a22.6,22.6,0,0,1,8.058-17.6c1.25-1.079,11.912-4.782,13.626-4.787,14.512-.086,22.224,10.594,22.2,21.553a22.809,22.809,0,0,1-8.392,17.76c-1.316,1.056-11.987,4.588-13.545,4.6C773.1,246.355,764.9,235.831,764.748,224.739ZM791.3,241.632c2.614-2.629,3.718-9.983,3.692-17.335-.019-5.543-.666-10.587-1.752-13.385-.508-1.307-5.079-5.584-6.789-5.572a23.539,23.539,0,0,0-4.668,1.778c-2.51,2.511-3.465,8.687-3.409,15.352.053,6.044.921,11.953,2.2,15.369.449,1.179,4.36,5.573,6.108,5.562A17.887,17.887,0,0,0,791.3,241.632Z",
    transform: "translate(-555.173 -202.351)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    className: "cls-12",
    d: "M848.617,203.45a2.77,2.77,0,0,1-2.57,2.828q-1.65.35-3.3.7-.251,19.217-.5,38.432-3.967-.052-7.935-.1-10.676-15.6-21.557-31.123-.055,13.674-.108,27.347l2.873.76c1.437.382,2.495,1.135,2.486,2.879q-7.31-.041-14.62-.05a2.756,2.756,0,0,1,2.5-2.863l3.253-.739.093-32.331q-1.226-1.747-2.455-3.495l-1.518-.564a2.409,2.409,0,0,1-1.642-2.058q7.911.009,15.822.059,9.666,13.483,19.172,27.026l.315,0q.138-11.617.277-23.235l-2.9-.782c-1.45-.39-2.517-1.149-2.5-2.894Q841.213,203.337,848.617,203.45Z",
    transform: "translate(-548.253 -202.207)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    className: "cls-12",
    d: "M880.488,216.866c-2.836-.078-5.489-2.39-6.639-4.413q-1.634-2.877-3.274-5.752l-2.655-.063q-.419,18.341-.836,36.681l1.425.6a2.369,2.369,0,0,1,1.638,2.1q-9.057-.221-18.116-.391a2.368,2.368,0,0,1,1.725-2.023q.723-.268,1.449-.533.35-18.343.7-36.684l-2.655-.051q-1.758,2.8-3.511,5.605c-1.235,1.972-3.983,4.166-6.819,4.122q.1-6.323.193-12.644,18.857.3,37.71.814Q880.656,210.546,880.488,216.866Z",
    transform: "translate(-541.172 -202.142)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    "data-name": "Path 570",
    className: "cls-12",
    d: "M920.273,205.655c-.069,1.743-1.176,2.445-2.644,2.758l-2.489.523q-.446,11.422-.89,22.844c-.417,10.454-10.58,16.223-18,15.97s-17.172-6.72-16.888-17.179q.336-11.862.672-23.724l-1.5-.6a2.411,2.411,0,0,1-1.587-2.1q9.142.257,18.282.566c.027,1.123-1.071,1.772-1.711,2l-1.471.511-.757,23.722c-.2,6.412,5.484,10.715,8.734,10.834,3.313.117,9.219-3.772,9.463-10.182q.428-11.423.857-22.846l-2.442-.717c-1.44-.429-2.487-1.215-2.424-2.958Q912.873,205.347,920.273,205.655Z",
    transform: "translate(-535.08 -201.997)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    className: "cls-12",
    d: "M959.413,207.643c-.1,1.742-1.211,2.428-2.684,2.721l-2.5.486q-.6,11.414-1.209,22.83c-.564,10.447-10.807,16.068-18.226,15.709s-17.079-6.967-16.649-17.421q.5-11.856,1-23.712l-1.493-.625a2.414,2.414,0,0,1-1.559-2.125q9.139.39,18.276.831c.012,1.123-1.1,1.755-1.739,1.974l-1.479.491q-.545,11.854-1.088,23.709c-.29,6.409,5.334,10.793,8.583,10.958,3.311.164,9.272-3.64,9.606-10.046q.589-11.414,1.176-22.83L947,209.841c-1.434-.449-2.47-1.251-2.384-2.993Q952.017,207.229,959.413,207.643Z",
    transform: "translate(-528.067 -201.728)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    className: "cls-12",
    d: "M994.587,252.036q-7.547-.53-15.095-1.022c-3.483-7.343-2.593-18.708-6.735-18.97l-1.165-1.572,1.347-1.413.691.043c2.888.183,4.42-3.151,4.732-8.124.265-4.227-.068-6-.571-7.09a13.988,13.988,0,0,0-3.468-2.343l-3.472-.217L968.668,247.7q.7.323,1.4.649a2.373,2.373,0,0,1,1.561,2.157q-9.047-.569-18.1-1.086a2.364,2.364,0,0,1,1.8-1.956l1.469-.476q1.035-18.377,2.072-36.755l-1.486-.648a2.414,2.414,0,0,1-1.529-2.147q10.935.623,21.869,1.323c7.965.51,13.128,4.989,12.6,12.881-.389,5.844-5.608,9.419-11.21,10.367,4.907,2.129,9.421,7.365,12.586,17.2l1.336.654A2.379,2.379,0,0,1,994.587,252.036Z",
    transform: "translate(-521.362 -201.347)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    className: "cls-12",
    d: "M624.258,262.986l-.805.055q-4.123,17.639-8.13,35.288-3.053.844-6.1,1.693-7.255-17.452-14.643-34.873l-.805.064q1.165,15.435,2.333,30.869l1.666.808a2.636,2.636,0,0,1,1.674,2.62q-4.6.354-9.192.721a2.6,2.6,0,0,1,1.26-2.849l1.528-1q-1.367-17.856-2.733-35.712l-1.533-.441a2.391,2.391,0,0,1-1.771-1.922q8.474-.677,16.951-1.309,5.532,13.049,10.989,26.116l.8-.057q3.139-13.681,6.347-27.357,8.261-.569,16.526-1.092a2.319,2.319,0,0,1-1.488,2.154l-1.394.651q1.148,18.372,2.294,36.743l1.448.468a2.351,2.351,0,0,1,1.782,1.947q-8.893.564-17.783,1.179A2.365,2.365,0,0,1,625,295.589l1.375-.656Q625.315,278.959,624.258,262.986Z",
    transform: "translate(-587.005 -192.043)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    className: "cls-12",
    d: "M669.311,283.1q.106,5.858.215,11.715-16.507.853-33.005,1.878a2.367,2.367,0,0,1,1.533-2.155l1.378-.645-2.182-36.75-1.457-.409a2.449,2.449,0,0,1-1.805-2.01q16.25-1.011,32.506-1.854.316,6.314.635,12.63c-2.786.145-5.5-1.956-6.847-3.88q-1.816-2.615-3.638-5.228-3.789.208-7.576.426l.909,16.3q2.872-.165,5.746-.326.509-1.462,1.02-2.926a3.992,3.992,0,0,1,2.971-2.471l.7,13.312a3.968,3.968,0,0,1-3.2-2.132l-1.325-2.8q-2.871.16-5.741.324.442,7.931.884,15.86l4.244,1.007a8.135,8.135,0,0,0,4.833-1.765q2.674-4.2,5.362-8.4,1.022-.551,2.043-1.105Z",
    transform: "translate(-578.591 -192.387)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    className: "cls-12",
    d: "M702.83,263.933c-2.786.108-5.538-2.026-6.8-3.969q-1.786-2.764-3.58-5.525l-2.609.11q.759,18.328,1.519,36.659l1.436.5a2.356,2.356,0,0,1,1.742,1.985q-8.9.372-17.8.794a2.363,2.363,0,0,1,1.563-2.132l1.388-.626-1.652-36.653-2.609.123q-1.548,2.909-3.089,5.822c-1.086,2.048-3.643,4.419-6.427,4.559l-.619-12.631q18.526-.934,37.059-1.652Q702.592,257.614,702.83,263.933Z",
    transform: "translate(-572.984 -192.697)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    className: "cls-12",
    d: "M738.845,264.424c-2.787.068-5.444-2.042-6.738-4.065q-2.1-3.184-4.207-6.366a6.944,6.944,0,0,0-3.029-1.6c-2.674.078-5.2,3.084-5.089,6.757.167,5.022,21.508,10.859,21.686,19.475.21,9.341-6.668,14.676-13.906,14.883-8.406.241-14.3-3.485-15.075-4.457q-.182-5.635-.364-11.27c2.778-.092,5.627,2.186,6.729,4.021q1.882,3.089,3.758,6.179c.388.673,4.943,2.909,5.311,2.9,2.332-.067,4.959-3.128,4.835-7.923-.072-3.321-21.314-7.855-21.7-18.916-.3-9.088,6.322-14.178,14.916-14.423,8.341-.236,11.818,2.054,12.589,3.03Q738.7,258.539,738.845,264.424Z",
    transform: "translate(-564.79 -193.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    className: "cls-12",
    d: "M739.584,271.47a22.764,22.764,0,0,1,7.754-17.675c1.219-1.089,11.668-4.894,13.352-4.915,14.268-.224,21.952,10.382,22.037,21.342a22.982,22.982,0,0,1-8.084,17.839c-1.284,1.068-11.741,4.7-13.273,4.732C748,293.009,739.843,282.56,739.584,271.47Zm26.266,16.644c2.544-2.653,3.56-10.017,3.465-17.368-.072-5.543-.756-10.581-1.85-13.37-.512-1.3-5.047-5.535-6.729-5.506a22.9,22.9,0,0,0-4.571,1.821c-2.444,2.535-3.325,8.719-3.2,15.384.109,6.041,1.018,11.944,2.309,15.347.454,1.174,4.338,5.531,6.058,5.5A17.472,17.472,0,0,0,765.849,288.114Z",
    transform: "translate(-559.68 -193.174)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    className: "cls-12",
    d: "M812.43,277.74q-.2,6.821-.4,13.641-16.523-.043-33.045.091a2.361,2.361,0,0,1,1.644-2.069l1.41-.571-.253-36.815-1.5-.55a2.4,2.4,0,0,1-1.633-2.044q8.992-.072,17.984-.093a2.315,2.315,0,0,1-1.612,2.06l-1.429.565q.057,17.784.115,35.57l4.183,1.234a8.116,8.116,0,0,0,4.918-1.5q2.888-4.984,5.794-9.963l2.037-.994Z",
    transform: "translate(-552.682 -193.084)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    className: "cls-12",
    d: "M867.867,284.005q-3.859,4.524-7.695,9.056c-4.605-.095-8.133-1.778-11.88-5.951l-.242-.254q-.628.706-1.252,1.413c-2.444,2.826-7.625,4.43-12.536,4.37-8.715-.1-13.226-4.552-13.189-9.725.033-4.359,3.274-9.261,10.049-12.488l1.305-.608q-1.8-1.952-3.61-3.9c-2.633-2.831-3.791-5.519-3.768-7.948a7.339,7.339,0,0,1,2.66-5.519c1.25-1.115,10.925-3.679,12.609-3.65,10.336.145,15.736,4.372,15.644,9.227-.066,3.552-3.178,7.475-9.41,10.3l-.81.362q3.378,3.7,6.741,7.4,1.67-1.9,3.343-3.8l-2.087-.911a3.009,3.009,0,0,1-2.116-2.78q7.733.137,15.465.31a2.858,2.858,0,0,1-2.533,2.748q-1.926.393-3.85.791-2.846,3.213-5.68,6.43,1.3,1.426,2.6,2.854c2.535,2.791,4,3.507,5.536,3.54q1.567-1.338,3.136-2.673Zm-22.359.068q-5.3-5.815-10.639-11.612l-.745.427c-.374.182-2.186,2.03-2.231,6.142-.063,5.917,3.1,8.881,6.668,8.929a7.779,7.779,0,0,0,5.569-2.288Zm-9.807-29.3a8.567,8.567,0,0,0,2.291,5.512q2.692,2.9,5.373,5.808l.251-.121c.56-.242,1.4-2.6,1.44-5.212.063-4.111-1.227-9.241-4.774-9.291a23.732,23.732,0,0,0-3.933,1.131A3.357,3.357,0,0,0,835.7,254.778Z",
    transform: "translate(-545.085 -193.19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    className: "cls-12",
    d: "M899.784,291.281l.688-.287q-4.614-14.006-9.315-28l-1.3-.043q-2.713,7.3-5.4,14.6,4.245-.492,8.493-.972.943,1.4,1.883,2.806l-1.928,2.3q-4.724-.751-9.453-1.489-1.611,4.376-3.213,8.753l3.173.844a3.335,3.335,0,0,1,2.491,3.007q-7.182-.228-14.368-.421a3.266,3.266,0,0,1,2.656-2.794l2.539-.551q6.958-19.088,14.069-38.146,4.218-.487,8.44-.959,6.951,20.753,13.706,41.537l.972.351a2.289,2.289,0,0,1,1.579,2.059q-8.716-.357-17.434-.668C898.1,291.969,899.1,291.569,899.784,291.281Z",
    transform: "translate(-536.048 -192.965)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    className: "cls-12",
    d: "M943.832,283.476q-.481,5.838-.961,11.677-16.507-.86-33.019-1.547a2.354,2.354,0,0,1,1.741-1.984l1.435-.5q.759-18.393,1.516-36.784l-1.408-.559a2.459,2.459,0,0,1-1.593-2.186q16.263.675,32.519,1.518-.318,6.314-.636,12.63c-2.785-.145-5.278-2.515-6.422-4.569q-1.544-2.789-3.093-5.578-3.79-.185-7.578-.359l-.732,16.3q2.874.133,5.748.272L932.659,269a3.973,3.973,0,0,1,3.2-2.15q-.32,6.657-.639,13.314a3.984,3.984,0,0,1-2.975-2.452q-.52-1.46-1.039-2.919-2.871-.138-5.742-.272-.357,7.934-.712,15.869,2.06.718,4.121,1.44a8.127,8.127,0,0,0,4.985-1.256q3.081-3.9,6.176-7.8l2.145-.887Z",
    transform: "translate(-529.185 -192.639)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    className: "cls-12",
    d: "M982.17,297.528q-7.421-.5-14.844-.954c-3.439-7.326-2.59-18.695-6.664-18.939q-.573-.783-1.148-1.566l1.321-1.419.679.041c2.84.169,4.338-3.171,4.634-8.146.249-4.227-.081-6-.578-7.088a13.7,13.7,0,0,0-3.416-2.326q-1.707-.1-3.413-.2-1.031,18.192-2.061,36.383l1.38.642a2.362,2.362,0,0,1,1.54,2.15q-8.895-.528-17.792-1a2.355,2.355,0,0,1,1.765-1.965l1.441-.482q.974-18.382,1.948-36.763l-1.46-.641a2.4,2.4,0,0,1-1.509-2.139q10.755.576,21.505,1.227c7.834.474,12.921,4.929,12.419,12.822-.369,5.845-5.491,9.444-11,10.417,4.83,2.106,9.279,7.322,12.412,17.142l1.315.648A2.365,2.365,0,0,1,982.17,297.528Z",
    transform: "translate(-523.463 -192.339)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    className: "cls-12",
    d: "M975.611,276.164a22.687,22.687,0,0,1,9.246-16.921c1.308-.977,12.052-3.84,13.732-3.71,14.242,1.044,20.99,12.291,20.132,23.216a22.9,22.9,0,0,1-9.594,17.053c-1.371.951-12.108,3.641-13.637,3.535C982.146,298.367,974.914,287.235,975.611,276.164Zm24.746,18.91c2.765-2.417,4.41-9.663,4.949-16.994.406-5.529.156-10.607-.693-13.483-.4-1.342-4.555-5.961-6.234-6.082a22.924,22.924,0,0,0-4.714,1.408c-2.654,2.308-4.064,8.393-4.517,15.042-.41,6.028-.014,11.988.98,15.493.35,1.21,3.85,5.9,5.565,6.021A17.386,17.386,0,0,0,1000.357,295.075Z",
    transform: "translate(-517.417 -191.862)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_138",
    "data-name": "Group 138",
    transform: "matrix(0.995, 0.105, -0.105, 0.995, 203.275, 76.806)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120",
    transform: "translate(0 12.366)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    "data-name": "Path 584",
    className: "cls-19",
    d: "M36.108,17.14c-.985,2.406-27.732-6.259-31.259-7.7S-.739,4.874.246,2.468,4.887-.719,8.414.724,37.092,14.734,36.108,17.14Z",
    transform: "translate(4.014 9.502)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    "data-name": "Path 585",
    className: "cls-19",
    d: "M40.184,7.2C39.991,9.789,10.763,9.715,6.812,9.42s-7-2.637-6.8-5.23S3.564-.265,7.515.031,40.379,4.6,40.184,7.2Z",
    transform: "translate(0 19.13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    className: "cls-19",
    d: "M39.049.851C39.585,3.4,11.815,11.408,7.981,12.216S.6,11.619.069,9.075,2.2,3.813,6.038,3,38.512-1.692,39.049.851Z",
    transform: "translate(1.104 25.451)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    className: "cls-19",
    d: "M31.265,26.75C29.6,28.744,6.19,11.919,3.193,9.412S-.883,3.256.785,1.262s5.45-1.579,8.448.928S32.933,24.755,31.265,26.75Z",
    transform: "translate(8.77 0)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    className: "cls-30",
    x2: 17.065,
    y2: 10.156,
    transform: "translate(20.271 14.562)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    className: "cls-30",
    x2: 19.436,
    y2: 3.551,
    transform: "translate(17.899 21.167)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    className: "cls-30",
    y1: 3.443,
    x2: 19.271,
    transform: "translate(18.064 24.718)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    "data-name": "Path 588",
    className: "cls-24",
    d: "M17.827,51.845s24.372-17.7,26.232-23.5C47.837,16.552,45.778.79,40.668.062c-4.564-.65-3.929,3.923-6.317,9.432,0,0-.051-8.434-4.827-8.4s-4.138,10.611-4.138,10.611-2.514-8.251-6.207-7.1-3.021,10.133-3.021,10.133-2.029-4.03-4.548-3.248-.746,7.793-.746,7.793-2.844-3.078-5.975-.876S6.07,29.042,6.07,29.042.57,28.761.031,33.7,5.919,45.638,17.827,51.845Z",
    transform: "translate(49.083 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    "data-name": "Group 126",
    transform: "translate(54.666 53.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    "data-name": "Path 589",
    className: "cls-24",
    d: "M10.62,12.149a.96.96,0,0,1-.4-.164c-1.281-.9-6.9-3.824-9.694-5.243a.962.962,0,0,1-.032-1.7C4.977,2.553,10.944.1,11,.072a.962.962,0,0,1,.73,1.781c-.051.021-4.615,1.9-8.7,4.013,2.487,1.282,7.041,3.663,8.293,4.546a.963.963,0,0,1-.709,1.737Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122",
    transform: "translate(7.643 11.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    "data-name": "Path 590",
    className: "cls-24",
    d: "M2.916.785A2.207,2.207,0,0,0,2.426.92,1.644,1.644,0,0,0,2,1.173a1.4,1.4,0,0,0-.478.75.726.726,0,0,0-.02.347c.022.08.065.1.1.107a.134.134,0,0,0,.1-.015c.026-.013.007-.072-.124-.028A.962.962,0,1,1,2.532,4a1.691,1.691,0,0,1-1.352.063,1.806,1.806,0,0,1-.912-.735,1.749,1.749,0,0,1-.26-1.084,2.255,2.255,0,0,1,.281-.874A2.613,2.613,0,0,1,1.461.261,2.656,2.656,0,0,1,2.2.035,2.883,2.883,0,0,1,2.96.017a.383.383,0,0,1,.019.759Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123",
    transform: "translate(10.576 10.943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    "data-name": "Path 591",
    className: "cls-24",
    d: "M.611.007c.336.055.675.1,1.013.168.335.087.677.139,1.011.257l.5.161.5.207a4.06,4.06,0,0,1,.491.24,3.763,3.763,0,0,1,.48.286,4.037,4.037,0,0,1,1.58,1.832,2.67,2.67,0,0,1,.166,1.421,2.524,2.524,0,0,1-.71,1.385L5.6,6.009A.967.967,0,0,1,4.239,4.631a1.111,1.111,0,0,1,.109-.092.736.736,0,0,0,.225-.825,2.455,2.455,0,0,0-.85-1.19,5.963,5.963,0,0,0-1.521-.9c-.274-.135-.579-.215-.87-.327-.3-.093-.606-.17-.911-.257L.381,1.029A.524.524,0,0,1,.611.007Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    "data-name": "Group 124",
    transform: "translate(10.523 9.766)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    "data-name": "Path 592",
    className: "cls-24",
    d: "M.312,1.1C.624.963.932.815,1.25.683c.328-.112.642-.256.985-.341L2.745.2,3.273.1A4.042,4.042,0,0,1,3.815.029,3.715,3.715,0,0,1,4.373,0,4.037,4.037,0,0,1,6.7.663a2.671,2.671,0,0,1,.921,1.1,2.523,2.523,0,0,1,.169,1.547l-.014.063a.967.967,0,0,1-1.891-.4,1.034,1.034,0,0,1,.04-.137.737.737,0,0,0-.267-.813,2.456,2.456,0,0,0-1.365-.526,5.96,5.96,0,0,0-1.763.087c-.3.038-.6.139-.907.205-.3.087-.6.191-.9.287L.682,2.08A.524.524,0,0,1,.312,1.1Z",
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125",
    transform: "translate(10.581 6.922)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_593",
    "data-name": "Path 593",
    className: "cls-24",
    d: "M.067,4.177c.167-.3.326-.6.5-.9.2-.286.361-.59.584-.864L1.476,2l.362-.4a4.135,4.135,0,0,1,.394-.38A3.794,3.794,0,0,1,2.663.865,4.046,4.046,0,0,1,4.922,0,2.669,2.669,0,0,1,6.316.327,2.524,2.524,0,0,1,7.377,1.465l.027.058a.967.967,0,0,1-1.756.81A1.034,1.034,0,0,1,5.6,2.2a.737.737,0,0,0-.7-.492,2.459,2.459,0,0,0-1.408.4,5.967,5.967,0,0,0-1.36,1.125c-.22.212-.4.472-.6.707s-.366.512-.551.769L.95,4.74a.525.525,0,0,1-.883-.563Z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_594",
    "data-name": "Path 594",
    className: "cls-19",
    d: "M44.676,25.081C19.5,43.117,2.827,25.039,0,13.418c0,0,11.736-13.252,34.019-9.349A13.349,13.349,0,0,1,43.493,0C49.3.083,44.676,25.081,44.676,25.081Z",
    transform: "translate(37.515 24.443)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_132",
    "data-name": "Group 132",
    transform: "translate(45.772 52.062)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_595",
    "data-name": "Path 595",
    className: "cls-24",
    d: "M9.569,11.9a.955.955,0,0,1-.526-.269C7.935,10.519,2.9,6.681.386,4.807a.963.963,0,0,1,.259-1.68c4.842-1.689,11.14-3.09,11.2-3.1a.963.963,0,0,1,.416,1.88c-.055.012-4.872,1.084-9.255,2.469,2.232,1.688,6.312,4.811,7.4,5.9a.962.962,0,0,1-.835,1.63Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_128",
    "data-name": "Group 128",
    transform: "translate(6.191 10.887)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_596",
    "data-name": "Path 596",
    className: "cls-24",
    d: "M3.175.862a2.266,2.266,0,0,0-.506.049,1.638,1.638,0,0,0-.466.177,1.4,1.4,0,0,0-.6.657.74.74,0,0,0-.079.338.13.13,0,0,0,.078.123.136.136,0,0,0,.1,0c.028-.009.019-.069-.118-.049a.963.963,0,1,1,.66,1.809A1.7,1.7,0,0,1,.9,3.8,1.811,1.811,0,0,1,.13,2.919,1.754,1.754,0,0,1,.059,1.806,2.25,2.25,0,0,1,.485.994,2.615,2.615,0,0,1,1.83.1,2.667,2.667,0,0,1,2.595,0a2.862,2.862,0,0,1,.753.113.382.382,0,0,1-.11.75Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_129",
    "data-name": "Group 129",
    transform: "translate(9.474 10.743)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_597",
    "data-name": "Path 597",
    className: "cls-24",
    d: "M.7.029c.322.113.648.217.97.339.315.143.643.253.951.425l.469.245.455.289a4.059,4.059,0,0,1,.442.321,3.825,3.825,0,0,1,.425.363A4.044,4.044,0,0,1,5.654,4.085a2.666,2.666,0,0,1-.079,1.429,2.524,2.524,0,0,1-.936,1.243l-.053.036a.967.967,0,0,1-1.1-1.589,1.108,1.108,0,0,1,.123-.073.736.736,0,0,0,.363-.775A2.456,2.456,0,0,0,3.335,3.04,5.964,5.964,0,0,0,1.991,1.9c-.247-.18-.535-.311-.8-.471C.91,1.282.621,1.154.336,1.016L.3,1A.525.525,0,0,1,.7.029Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_130",
    "data-name": "Group 130",
    transform: "translate(9.443 10.145)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_598",
    "data-name": "Path 598",
    className: "cls-24",
    d: "M.4.485c.331-.083.66-.176,1-.251C1.734.179,2.069.091,2.421.066L2.948.012,3.486,0a4.011,4.011,0,0,1,.546.024A3.837,3.837,0,0,1,4.586.1,4.043,4.043,0,0,1,6.767,1.144a2.67,2.67,0,0,1,.72,1.237,2.526,2.526,0,0,1-.1,1.554l-.024.059a.967.967,0,0,1-1.795-.72,1.048,1.048,0,0,1,.063-.128A.738.738,0,0,0,5.51,2.3a2.459,2.459,0,0,0-1.255-.751A5.965,5.965,0,0,0,2.5,1.332c-.305-.015-.617.034-.928.048-.311.034-.623.086-.937.128l-.044.006A.525.525,0,0,1,.4.485Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    "data-name": "Group 131",
    transform: "translate(9.498 7.511)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_599",
    "data-name": "Path 599",
    className: "cls-24",
    d: "M.117,3.316c.215-.265.423-.536.647-.8.241-.249.456-.52.724-.751l.39-.358L2.3,1.08A4.05,4.05,0,0,1,2.755.773,3.829,3.829,0,0,1,3.241.5,4.039,4.039,0,0,1,5.614.03,2.666,2.666,0,0,1,6.932.589a2.524,2.524,0,0,1,.852,1.3l.016.061a.967.967,0,1,1-1.869.5A1.054,1.054,0,0,1,5.9,2.311a.737.737,0,0,0-.606-.6,2.46,2.46,0,0,0-1.455.15,5.938,5.938,0,0,0-1.533.877c-.253.171-.473.4-.715.594-.228.214-.448.442-.674.664l-.032.03a.525.525,0,0,1-.774-.706Z",
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    className: "cls-19",
    cx: 13.78,
    cy: 13.78,
    r: 13.78,
    transform: "translate(68.131 24.416)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_600",
    "data-name": "Path 600",
    className: "cls-24",
    d: "M0,0C.609,3.662,6.559,7.171,11.758,2.963Z",
    transform: "translate(83.302 43.517)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_133",
    "data-name": "Group 133",
    transform: "translate(83.224 33.633)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    "data-name": "Path 601",
    className: "cls-16",
    d: "M2.047,11.554s5.669,3.121,18.432-.112c0,0-1.455-8.975-8.788-11.441,0,0-3.438,9-11.395,8.842C.3,8.842-1.064,10.689,2.047,11.554Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    className: "cls-11",
    d: "M.253.061C-.1.27-.081.956.3,1.593s.969.984,1.323.775.335-.895-.042-1.532S.607-.148.253.061Z",
    transform: "translate(11.523 3.17)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_135",
    "data-name": "Group 135",
    transform: "translate(79.265 30.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    "data-name": "Path 603",
    className: "cls-27",
    d: "M10.343,6.04A5.2,5.2,0,1,1,6.04.068,5.205,5.205,0,0,1,10.343,6.04Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    className: "cls-5",
    cx: 3.938,
    cy: 3.938,
    r: 3.938,
    transform: "translate(0.225 7.696) rotate(-71.565)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134",
    transform: "translate(2.343 2.241)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_604",
    "data-name": "Path 604",
    className: "cls-11",
    d: "M6.261,3.656A3.151,3.151,0,1,1,3.656.041,3.15,3.15,0,0,1,6.261,3.656Z",
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_605",
    "data-name": "Path 605",
    className: "cls-24",
    d: "M.141,0C5.184,2.3,6.956,8.512,6.956,8.512A16.737,16.737,0,0,0,1.1,2.388,1.829,1.829,0,0,1,.141,0Z",
    transform: "translate(95.41 34.343)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_136",
    "data-name": "Group 136",
    transform: "translate(69.115 12.905)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_606",
    "data-name": "Path 606",
    className: "cls-19",
    d: "M15.652,11.794C-.317,6.954,6.228,0,6.228,0S-.427.509.022,6.648,15.652,11.794,15.652,11.794Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_607",
    "data-name": "Path 607",
    className: "cls-19",
    d: "M1.051,0C-2.408,3.363,3.78,7.359,3.78,7.359L7.655,8.1S-1.289,3.882,1.051,0Z",
    transform: "translate(1.734 3.124)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    "data-name": "Path 608",
    className: "cls-19",
    d: "M.014,0A7.571,7.571,0,0,0,.021,1.022c.448,6.139,15.63,5.146,15.63,5.146l-.185-.057c-.154-.017-.307-.033-.464-.048C7.318,5.323,1.737,2.771.014,0Z",
    transform: "translate(0.001 5.626)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_137",
    "data-name": "Group 137",
    transform: "translate(78.51 14.727)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    "data-name": "Path 609",
    className: "cls-19",
    d: "M7.647,10.357C2.627,6.3,4.95,0,4.95,0S-7.812,6.647,7.647,10.357Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    "data-name": "Path 610",
    className: "cls-19",
    d: "M.836,0C-.819,2.207-.7,5.064,7.646,7.067,7.646,7.067.095,3.654.836,0Z",
    transform: "translate(0.001 3.29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    "data-name": "Path 611",
    className: "cls-19",
    d: "M.343,0C-1.147,1.834,2.7,5.492,2.7,5.492l2.117.75S-.922,2.015.343,0Z",
    transform: "translate(1.58 3.752)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    className: "cls-27",
    d: "M39.209,41.236C18.351,51.061,4,46.775,8.223,40.366c0,0-8.317-3.373-7.027-7.3S7.874,29.7,7.874,29.7s-8.7-2.561-7.811-6.321,6.887.19,6.887.19-5.817-5.083-4.9-9.215,8.342,1.354,8.342,1.354-2.825-4.739-.765-8.624,6.125,1.969,7.2,3.613c0,0,.444-6.947,4.724-10.111s7.015,7.156,5.728,15.631S26.361,36.95,39.209,41.236Z",
    transform: "translate(32.61 1.689)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    className: "cls-31",
    d: "M9.131,32.979c-3.96-.165-4.471-2.3-3.046-4.735,0,0-6.373-.784-5.795-4.593C.726,20.788,4.731,21,4.731,21S-.709,19.292.078,16.7c.776-2.559,5.469.18,5.469.18S.8,13.262,1.422,10.358s5.052.82,5.052.82S4.828,7.906,6.14,5.158s3.694,1.284,4.325,2.417c0,0,.376-4.865,3.027-7.143s4.156,4.9,3.245,10.844",
    transform: "translate(40.34 12.309)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroSolEnAero);
export default __webpack_public_path__ + "static/media/hero-solEnAero.8ac6b792be7751558f908aaae928f552.svg";
export { ForwardRef as ReactComponent };